// PRIMARY locale — source of truth. Every key added here must be added to
// he.ts and en.ts in the same commit (structural equality is enforced by
// TypeScript in those files via `Translations = typeof ar`).
//
// Note: no `as const` — we want the inferred shape to be `string` at the
// leaves so `he: Translations` / `en: Translations` can assign different
// strings. Key structure is still locked because adding a new leaf to
// `ar` widens `Translations`, and the other files will fail to compile
// until they include that key.
export const ar = {
  fulfillment: {
    deliveryOnly: 'هذا الإجراء متاح لطلبات التوصيل فقط.',
    pickupOnly: 'هذا الإجراء متاح للاستلام الذاتي فقط.',
    busy: 'بيانات الطلب قيد التحديث. حاول مجددًا ثم راجع التفاصيل.',
    amountOutOfRange: 'المجموع خارج النطاق المدعوم',
    clientUpdateRequired: 'حدّث الصفحة لمتابعة تأكيد الطلب.',
    pickupStockNotice: 'يتم خصم الكمية عند تأكيد الطلب.',
    pickupNext: 'استلم الطلب من المكان الموضّح. تواصل مع المتجر للتفاصيل.',
    collected: 'تم الاستلام',
    legacySubtotal: 'مجموع المنتجات — رسوم التوصيل غير مسجّلة',
    quoteFailed: 'تعذّر حساب المجموع. حاول مجددًا.',
    quoteLoading: 'جارٍ حساب المجموع',
    loadFailed: 'تعذّر تحميل خيارات الاستلام. حاول مجددًا.',
    optionsChanged: 'تغيّرت الخيارات. راجع التفاصيل والمجموع ثم أكّد مجددًا.',
    unavailable: 'التوصيل والاستلام غير متاحين حاليًا',
    chooseMethod: 'اختر التوصيل أو الاستلام الذاتي',
    pickupPlace: 'مكان الاستلام',
    freePickup: 'استلام ذاتي مجاني',
    freeDelivery: 'توصيل مجاني',
    deliveryFee: 'رسوم التوصيل',
    pickup: 'استلام ذاتي',
    delivery: 'توصيل',
    title: 'طريقة الاستلام',
  },
  common: {
    save: 'حفظ',
    cancel: 'إلغاء',
    delete: 'حذف',
    loading: 'جارٍ التحميل...',
    error: 'حدث خطأ',
    retry: 'إعادة المحاولة',
    search: 'بحث',
    call: 'اتصال',
    actions: {
      close: 'إغلاق',
    },
    phoneCountry: {
      IL: 'إسرائيل',
      PS: 'فلسطين',
      JO: 'الأردن',
      SY: 'سوريا',
      LB: 'لبنان',
      EG: 'مصر',
      TR: 'تركيا',
      US: 'الولايات المتحدة',
      international: 'رقم دولي',
    },
    languageNames: {
      ar: 'العربية',
      he: 'עברית',
      en: 'English',
    },
    errors: {
      permissionDenied: 'ليس لديك صلاحية لفعل ذلك.',
      networkFailed: 'فشل الاتصال. تحقّق من الشبكة وأعد المحاولة.',
      storeNotFound: 'هذا المتجر لم يعد موجودًا. يرجى تحديث الصفحة.',
      unknown: 'حدث خطأ ما. حاول مرة أخرى.',
    },
  },
  auth: {
    signup: {
      title: 'إنشاء حساب',
      subtitle: 'ابدأ متجرك اليوم',
      emailLabel: 'البريد الإلكتروني',
      passwordLabel: 'كلمة المرور',
      passwordConfirmLabel: 'تأكيد كلمة المرور',
      submit: 'إنشاء الحساب',
      submitting: 'جارٍ الإنشاء...',
      haveAccount: 'لديك حساب بالفعل؟',
      signInLink: 'تسجيل الدخول',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      errors: {
        emailRequired: 'البريد الإلكتروني مطلوب',
        emailInvalid: 'صيغة البريد الإلكتروني غير صحيحة',
        passwordTooShort: 'يجب أن تكون كلمة المرور 8 أحرف على الأقل',
        passwordConfirmRequired: 'تأكيد كلمة المرور مطلوب',
        passwordMismatch: 'كلمتا المرور غير متطابقتين',
        emailAlreadyExists: 'هذا البريد الإلكتروني مسجل بالفعل',
        rateLimited: 'عدد كبير من المحاولات. الرجاء المحاولة بعد قليل.',
        networkFailed: 'فشل الاتصال. تحقق من الإنترنت.',
        accountCreatedSignInFailed: 'تم إنشاء حسابك. الرجاء المحاولة مرة أخرى بعد قليل.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
        noNegativeInventory: 'admin.barcode.errors.noNegativeInventory',
      },
    },
    callback: {
      title: 'جارٍ التحقق...',
    },
    phoneOtp: {
      phoneLabel: 'رقم الهاتف',
      phoneHint: 'أدخل الرقم مع رمز الدولة أو اختر الدولة.',
      codeLabel: 'رمز التحقق',
      codeHint: 'أدخل الرمز المكوّن من 6 أرقام.',
      requestCode: 'إرسال الرمز',
      requestingCode: 'جارٍ الإرسال...',
      verifyCode: 'تأكيد الرمز',
      verifyingCode: 'جارٍ التحقق...',
      retryHandoff: 'إعادة المحاولة',
      resendCode: 'إرسال رمز جديد',
      changePhone: 'تغيير الرقم',
      sentMessage: 'أرسلنا رمز تحقق إلى رقمك.',
      smsOnly: 'سنرسل الرمز برسالة SMS.',
      existingEmailFallback: 'هل لا تملك هاتفًا موثقًا؟',
      useEmailFallback: 'استخدم البريد وكلمة المرور',
      usePhoneOtp: 'استخدم رمز الهاتف',
      errors: {
        phoneRequired: 'رقم الهاتف مطلوب',
        phoneInvalid: 'رقم الهاتف غير صالح',
        codeRequired: 'رمز التحقق مطلوب',
        codeInvalid: 'أدخل رمزًا من 6 أرقام',
        invalidCode: 'الرمز غير صحيح أو انتهت صلاحيته',
        customerAccountMissing: 'لا يوجد حساب زبون لهذا الرقم. أنشئ حسابًا أولًا.',
        adminAccountMissing: 'لا يوجد حساب تاجر لهذا الرقم.',
        rateLimited: 'محاولات كثيرة. حاول بعد قليل.',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        cartHandoffFailed: 'تم تسجيل الدخول، لكن تعذر نقل السلة. حاول مرة أخرى.',
        profileEnsureFailed: 'تم التحقق من الرقم، لكن تعذر تجهيز حساب الزبون. حاول مرة أخرى.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
  },
  catalog: {
    products: 'المنتجات',
    outOfStock: 'غير متوفر',
  },
  checkout: {
    cart: 'السلة',
    total: 'المجموع',
  },
  customer: {
    phoneCountryLabel: 'رمز الدولة',
    phoneCountry: {
      IL: 'إسرائيل',
      PS: 'فلسطين',
      JO: 'الأردن',
      SY: 'سوريا',
      LB: 'لبنان',
      EG: 'مصر',
      TR: 'تركيا',
      US: 'الولايات المتحدة',
    },
    signup: {
      title: 'المتابعة برقم الهاتف',
      subtitle: 'رمز تحقق واحد يكفي لمتابعة التسوق.',
      fullNameLabel: 'الاسم الكامل',
      fullNameHint: 'كما تحب أن يراك البائع',
      emailLabel: 'البريد الإلكتروني',
      emailHint: 'سيُستخدم هذا البريد لتسجيل الدخول',
      passwordLabel: 'كلمة المرور',
      passwordHint: '٨ أحرف على الأقل',
      passwordConfirmLabel: 'تأكيد كلمة المرور',
      phoneLabel: 'رقم الهاتف (اختياري)',
      phoneHint: 'يساعد البائع على التواصل معك بخصوص الطلب',
      phoneCountryLabel: 'رمز الدولة',
      phoneCountry: {
        IL: 'إسرائيل',
        PS: 'فلسطين',
        JO: 'الأردن',
        SY: 'سوريا',
        LB: 'لبنان',
        EG: 'مصر',
        TR: 'تركيا',
        US: 'الولايات المتحدة',
      },
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      submit: 'إنشاء حساب',
      submitting: 'جارٍ الإنشاء...',
      haveAccount: 'لديك حساب بالفعل؟',
      signInLink: 'تسجيل الدخول',
      successToast: 'تم إنشاء حسابك بنجاح!',
      errors: {
        fullNameRequired: 'الاسم الكامل مطلوب',
        fullNameTooShort: 'الاسم قصير جدًا',
        fullNameTooLong: 'الاسم طويل جدًا',
        emailRequired: 'البريد الإلكتروني مطلوب',
        emailInvalid: 'صيغة البريد الإلكتروني غير صحيحة',
        passwordTooShort: 'يجب أن تكون كلمة المرور ٨ أحرف على الأقل',
        passwordConfirmRequired: 'تأكيد كلمة المرور مطلوب',
        passwordMismatch: 'كلمتا المرور غير متطابقتين',
        phoneInvalid: 'رقم الهاتف غير صالح للدولة المختارة',
        emailAlreadyExists:
          'هذا البريد الإلكتروني مسجل بالفعل. إذا كنت تاجرًا، يمكنك تسجيل الدخول بنفس الحساب للتسوق.',
        rateLimited: 'عدد كبير من المحاولات. حاول بعد قليل.',
        networkFailed: 'فشل الاتصال. تحقّق من الإنترنت.',
        accountCreatedSignInFailed: 'تم إنشاء حسابك. حاول تسجيل الدخول بعد قليل.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    header: {
      signUpLink: 'المتابعة برقم الهاتف',
      signInLink: 'تسجيل الدخول',
      avatarMenuLabel: 'قائمة الحساب',
      signOut: 'تسجيل الخروج',
      myProfile: 'حسابي',
      myAddresses: 'عناويني',
      myOrders: 'طلباتي',
    },
    login: {
      title: 'المتابعة برقم الهاتف',
      subtitle: 'الزبائن الجدد والعائدون يستخدمون نفس رمز الهاتف.',
      emailLabel: 'البريد الإلكتروني',
      emailHint: 'العنوان الذي استخدمته عند إنشاء الحساب',
      passwordLabel: 'كلمة المرور',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      submit: 'تسجيل الدخول',
      submitting: 'جارٍ تسجيل الدخول…',
      forgotPasswordLink: 'نسيت كلمة المرور؟',
      noAccountYet: 'ليس لديك حساب؟',
      signUpLink: 'إنشاء حساب',
      phoneOnlyHint: 'لا تحتاج إلى بريد إلكتروني أو كلمة مرور.',
      errors: {
        emailRequired: 'البريد الإلكتروني مطلوب',
        emailInvalid: 'البريد الإلكتروني غير صالح',
        passwordRequired: 'كلمة المرور مطلوبة',
        invalidCredentials: 'بيانات الدخول غير صحيحة. حاول مرة أخرى.',
        rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    passwordReset: {
      request: {
        title: 'إعادة تعيين كلمة المرور',
        subtitle: 'سنرسل رابط إعادة التعيين إلى بريدك الإلكتروني.',
        emailLabel: 'البريد الإلكتروني',
        submit: 'إرسال رابط إعادة التعيين',
        submitting: 'جارٍ الإرسال…',
        successTitle: 'تفقّد بريدك الإلكتروني',
        successMessage:
          'إذا كان هذا البريد مرتبطاً بحساب، ستتلقى رسالة مع رابط إعادة التعيين خلال دقائق قليلة.',
        backToSignIn: 'العودة إلى تسجيل الدخول',
        errors: {
          emailRequired: 'البريد الإلكتروني مطلوب',
          emailInvalid: 'البريد الإلكتروني غير صالح',
          rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
          networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
          unknown: 'حدث خطأ. حاول مرة أخرى.',
        },
      },
      confirm: {
        title: 'اختر كلمة مرور جديدة',
        subtitle: 'أدخل كلمة مرور جديدة لإكمال إعادة التعيين.',
        passwordLabel: 'كلمة المرور الجديدة',
        passwordHint: '٨ أحرف على الأقل',
        passwordConfirmLabel: 'تأكيد كلمة المرور',
        showPassword: 'إظهار كلمة المرور',
        hidePassword: 'إخفاء كلمة المرور',
        submit: 'حفظ كلمة المرور الجديدة',
        submitting: 'جارٍ الحفظ…',
        sessionMissingTitle: 'انتهت صلاحية رابط إعادة التعيين',
        sessionMissingMessage: 'يرجى طلب رابط جديد.',
        sessionMissingCta: 'طلب رابط جديد',
        successToast: 'تم تغيير كلمة المرور. أهلاً بك!',
        errors: {
          passwordTooShort: 'يجب أن تكون كلمة المرور ٨ أحرف على الأقل',
          passwordMismatch: 'كلمتا المرور غير متطابقتين',
          rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
          networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
          unknown: 'حدث خطأ. حاول مرة أخرى.',
        },
      },
    },
    profilePlaceholder: {
      title: 'صفحة الحساب قادمة قريباً',
      subtitle: 'نحن نعمل على هذه الصفحة. تابعنا قريباً.',
      cta: 'العودة إلى المتجر',
      ariaLabel: 'صفحة الحساب المؤقتة',
    },
    account: {
      pageTitle: 'الحساب',
      ariaLabel: 'صفحة الحساب',
      subtitle: 'إدارة ملفك الشخصي وعناوين التوصيل المحفوظة وطلباتك.',
      navLabel: 'أقسام الحساب',
      items: {
        profile: {
          title: 'الملف الشخصي',
          description: 'عدّل الاسم واللغة المفضلة.',
        },
        addresses: {
          title: 'العناوين المحفوظة',
          description: 'أضف أو عدّل أو اختر عنوان التوصيل الأساسي.',
        },
        orders: {
          title: 'الطلبات',
          description: 'راجع طلباتك الأخيرة وحالتها.',
        },
      },
    },
    profile: {
      pageTitle: 'الملف الشخصي',
      ariaLabel: 'صفحة الملف الشخصي',
      editButton: 'تعديل الملف',
      addressesButton: 'إدارة العناوين المحفوظة',
      saveButton: 'حفظ التغييرات',
      saving: 'جارٍ الحفظ…',
      cancelButton: 'إلغاء',
      nameLabel: 'الاسم',
      emailLabel: 'البريد الإلكتروني',
      emailReadOnly: 'لا يمكن تغيير البريد الإلكتروني حالياً',
      phoneLabel: 'رقم الهاتف',
      phoneOptional: 'اختياري',
      phoneReadOnly: 'رقم الهاتف مثبت من تسجيل الدخول ولا يمكن تغييره هنا.',
      phonePlaceholder: '+972501234567',
      localeLabel: 'اللغة المفضلة',
      localeAr: 'العربية',
      localeHe: 'עברית',
      localeEn: 'English',
      successToast: 'تم حفظ التغييرات بنجاح',
      signOut: 'تسجيل الخروج',
      signingOut: 'جارٍ تسجيل الخروج…',
      deleteAccount: {
        title: 'حذف الحساب',
        warning:
          'هذا الإجراء لا يمكن التراجع عنه. سيتم حذف حسابك نهائياً. ستبقى طلباتك النشطة مرئية للبائع مع بيانات مجهولة الهوية.',
        confirmPrompt: 'اكتب "{{word}}" للتأكيد',
        confirmWord: 'حذف',
        confirmButton: 'حذف الحساب نهائياً',
        deleting: 'جارٍ حذف الحساب…',
      },
      errors: {
        nameRequired: 'الاسم مطلوب',
        nameTooLong: 'الاسم طويل جداً (الحد الأقصى ١٠٠ حرف)',
        phoneInvalid: 'رقم هاتف غير صالح',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        rateLimited: 'محاولات كثيرة. يرجى المحاولة بعد دقائق قليلة.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
        deleteFailed: 'فشل حذف الحساب. حاول مرة أخرى.',
      },
    },
    addresses: {
      pageTitle: 'عناويني',
      ariaLabel: 'صفحة العناوين',
      addNewCta: 'إضافة عنوان جديد',
      limitReached: 'وصلت إلى الحد الأقصى (٢٠ عنواناً). احذف عنواناً قديماً لإضافة عنوان جديد.',
      defaultBadge: 'الأساسي',
      makeDefault: 'جعله الأساسي',
      edit: 'تعديل',
      delete: 'حذف',
      actionsMenuLabel: 'إجراءات العنوان',
      empty: {
        title: 'لا توجد عناوين محفوظة بعد',
        body: 'أضف عنواناً لتسريع عملية الدفع.',
        cta: 'أضف عنوانك الأول',
      },
      form: {
        addTitle: 'إضافة عنوان جديد',
        editTitle: 'تعديل العنوان',
        labelLabel: 'التسمية',
        labelPlaceholder: 'مثال: المنزل، العمل',
        labelOptional: 'اختياري',
        recipientNameLabel: 'اسم المستلم',
        addressLine1Label: 'العنوان',
        addressLine2Label: 'سطر العنوان الثاني',
        cityLabel: 'المدينة',
        localitySearchPlaceholder: 'ابحث عن البلدة أو المدينة',
        localitySearchPrompt: 'ابدأ بالكتابة للعثور على البلدة أو المدينة.',
        localityNoResults: 'لا توجد بلدة أو مدينة مطابقة',
        regionLabel: 'المنطقة',
        regionFallbackLabel: 'الولاية / المحافظة',
        postalCodeLabel: 'الرمز البريدي',
        countryLabel: 'الدولة',
        phoneLabel: 'رقم الهاتف',
        phoneOptional: 'اختياري — قد يستخدمه البائع لتنسيق التوصيل.',
        isDefaultLabel: 'اجعل هذا عنواني الأساسي',
        saveNew: 'حفظ العنوان',
        saveEdit: 'حفظ التغييرات',
        cancel: 'إلغاء',
        saving: 'جارٍ الحفظ…',
      },
      districtIL: {
        northern: 'المنطقة الشمالية',
        haifa: 'منطقة حيفا',
        central: 'المنطقة الوسطى',
        tel_aviv: 'منطقة تل أبيب',
        jerusalem: 'منطقة القدس',
        southern: 'المنطقة الجنوبية',
      },
      successToast: {
        created: 'تم حفظ العنوان',
        updated: 'تم تحديث العنوان',
        deleted: 'تم حذف العنوان',
        defaultSet: 'تم تحديث العنوان الأساسي',
      },
      deleteConfirm: {
        title: 'هل تريد حذف هذا العنوان؟',
        body: 'لن يظهر هذا العنوان بعد الآن ضمن خيارات الدفع. الطلبات السابقة لن تتأثر.',
        confirm: 'حذف',
        confirmAlias: 'admin.products.barcode.confirm',
        deleting: 'جارٍ الحذف…',
      },
      errors: {
        labelTooLong: 'التسمية طويلة جداً',
        recipientNameRequired: 'اسم المستلم مطلوب',
        recipientNameTooLong: 'اسم المستلم طويل جداً',
        addressLine1Required: 'العنوان مطلوب',
        addressLine1TooLong: 'العنوان طويل جداً',
        addressLine2TooLong: 'سطر العنوان الثاني طويل جداً',
        cityRequired: 'المدينة مطلوبة',
        cityTooLong: 'اسم المدينة طويل جداً',
        regionRequired: 'المنطقة مطلوبة',
        regionTooLong: 'المنطقة طويلة جداً',
        postalCodeRequired: 'الرمز البريدي مطلوب',
        postalCodeInvalidIL: 'الرمز البريدي الإسرائيلي يجب أن يكون ٥ أو ٧ أرقام',
        postalCodeInvalid: 'رمز بريدي غير صالح',
        countryRequired: 'الدولة مطلوبة',
        phoneInvalid: 'رقم الهاتف غير صالح',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة.',
        rateLimited: 'محاولات كثيرة. حاول بعد دقائق قليلة.',
        notFound: 'العنوان غير موجود.',
        deleteFailed: 'تعذّر حذف العنوان.',
        setDefaultFailed: 'تعذّر تعيين العنوان الأساسي.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    // DEPRECATED: F-019 replaced the orders placeholder with the real order
    // history page. These keys are retained for translator reference only.
    // No runtime code references them. Safe to remove in a future cleanup.
    ordersPlaceholder: {
      title: 'الطلبات قادمة قريباً',
      subtitle: 'نحن نعمل على هذه الصفحة. تابعنا قريباً.',
      cta: 'العودة إلى المتجر',
      ariaLabel: 'صفحة الطلبات المؤقتة',
    },
    callback: {
      title: 'جارٍ التحقق...',
      loading: 'لحظة من فضلك، نتحقّق من بريدك الإلكتروني.',
    },
    authGate: {
      title: 'تحقق من رقمك للتواصل مع البائع',
      subtitle: 'للتواصل مع {{storeName}} بشأن {{productName}}، تابع بتحقق الهاتف.',
      signInCta: 'المتابعة برقم الهاتف',
      signUpCta: 'المتابعة برقم الهاتف',
      closeLabel: 'إغلاق',
      primedBanner: {
        message: 'تم تسجيل الدخول — اضغط على "تواصل مع البائع" لإرسال رسالة إلى {{storeName}}',
        dismissLabel: 'تجاهل',
      },
    },
  },
  cart: {
    errors: {
      insufficientStock: 'عذرًا، شخص آخر طلب آخر الوحدات — لم يتبقَّ سوى {{available}}',
      productNotFound: 'المنتج غير موجود',
      notAuthenticated: 'الرجاء تسجيل الدخول للمتابعة',
      permissionDenied: 'ليس لديك الصلاحية لإجراء هذا التغيير',
      networkFailed: 'فشل الاتصال بالشبكة. حاول مرة أخرى.',
      unknown: 'حدث خطأ غير متوقع. حاول مرة أخرى.',
      storeUnpublished: 'هذا المتجر لا يقبل الطلبات حاليًا',
      cartItemNotFound: 'لم يعد هذا المنتج في سلتك. سنحدّث العرض.',
      invalidQuantity: 'تعذّر تحديث الكمية. حاول مرة أخرى.',
      variantUnavailable: 'هذا الخيار لم يعد متاحًا',
      insufficientVariantStock: 'لا توجد كمية كافية لهذا الخيار',
    },
  },
  reviews: {
    verifiedCustomer: 'زبون موثّق',
    verifiedPurchase: 'شراء موثّق',
    merchantResponse: 'ردّ المتجر',
    ratingLabel: '{{rating}} من 5',
    reviewCount: '{{count}} تقييم',
    noReviewsYet: 'لا توجد تقييمات بعد',
    errors: {
      notEligible: 'هذا المنتج غير مؤهل للتقييم',
      alreadyReviewed: 'تم تقييم هذا المنتج',
      permissionDenied: 'ليست لديك صلاحية إرسال هذا التقييم',
      productUnavailable: 'لا يمكن تقييم هذا المنتج الآن',
      ratingInvalid: 'اختر تقييماً من 1 إلى 5',
      textTooLong: 'يجب ألا يتجاوز النص 1000 حرف',
      whitespaceOnly: 'اكتب نصاً واضحاً أو اترك الحقل فارغاً',
    },
  },
  admin: {
    newsletterSubscribers: {
      consentVersion: 'إصدار الموافقة',
      source: 'مصدر الاشتراك',
      exportError: 'تعذّر تصدير المشتركين المعروضين. حاول مرة أخرى.',
      recentLimit: 'الأحدث، حتى {{count}} مشترك',
      title: 'المشتركون',
      description: 'عرض جهات الاتصال الحديثة التي وافقت على الاشتراك في متجرك.',
      limit: 'عدد جهات الاتصال الحديثة',
      limitOption: 'آخر {{count}} جهة اتصال',
      export: 'تصدير المشتركين المعروضين',
      empty:
        'لا يوجد مشتركون بعد. فعّل جمع الاشتراكات وانشر محتوى الاشتراك ليتمكّن الزوّار من الاشتراك.',
      loadError: 'تعذّر تحميل المشتركين.',
      forbidden: 'هذه الصفحة متاحة لمالك المتجر والمسؤولين فقط.',
      contact: 'جهة الاتصال',
      method: 'طريقة التواصل',
      status: 'الحالة',
      subscribedAt: 'وقت الاشتراك',
      lastSubmittedAt: 'آخر إرسال',
      active: 'نشط',
      suppressed: 'موقوف',
      suppress: 'إيقاف الاشتراك',
      suppressTitle: 'إيقاف اشتراك جهة الاتصال؟',
      suppressBody: 'سيبقى الاشتراك موقوفًا حتى إذا أُرسل طلب اشتراك جديد.',
      suppressSuccess: 'تم إيقاف الاشتراك.',
      suppressError: 'تعذّر إيقاف الاشتراك. حاول مرة أخرى.',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
    },
    websiteTemplates: {
      newsletter: {
        enabled: 'السماح بالاشتراك',
        help: 'الاشتراك معطّل افتراضيًا. انشر التغييرات لتفعيله في المتجر.',
        contactMethods: 'طرق التواصل المقبولة',
        email: 'البريد الإلكتروني',
        phone: 'رقم الهاتف',
        consentVersion: 'تُستخدم موافقة الاشتراك الحالية.',
        invalid: 'اختر طريقة تواصل واحدة على الأقل.',
      },
      runtime: {
        reload: 'إعادة تحميل المحرر',
        unsavedWarning: 'ستفقدون التغييرات غير المحفوظة عند إعادة التحميل.',
        reloadFailed: 'ما زال المحرر يحتاج إلى إصدار أحدث. حاولوا لاحقًا.',
      },
      fashion: {
        campaignPositionHint:
          'تبقى هذه الحملة مرتبطة بفئتها الأصلية. تُخفى عندما تكون الفئة غير متاحة أو فارغة.',
      },
      richText: {
        hint: 'اترك سطرًا فارغًا بين الفقرات. ابدأ السطر بـ - لإنشاء قائمة نقطية.',
        lossy: 'يحتوي هذا النص على تنسيق سيتم تبسيطه إذا قمت بتعديله.',
      },
      gallery: {
        credits: 'حقوق صور القوالب',
        title: 'واجهة المتجر',
        heading: 'اختر قالبًا لإنشاء متجرك الإلكتروني',
        subheading: 'اختر تصميمًا يناسب نشاطك التجاري. يمكنك تعديل المحتوى بسهولة بعد الاختيار.',
        filterLabel: 'تصفية القوالب حسب الفئة',
        filter: {
          all: 'كل القوالب',
        },
        badge: {
          live: 'منشور',
          draftSaved: 'مسودة محفوظة',
          custom: 'مصمَّم لمتجرك',
        },
        swatchesLabel: 'ألوان القالب',
        action: {
          previewDemo: 'معاينة العرض التوضيحي',
          use: 'استخدم القالب',
          edit: 'تعديل',
          opening: 'جارٍ الفتح…',
          editNamed: 'تعديل: {{name}}',
          previewDemoNamed: 'معاينة العرض التوضيحي: {{name}}',
          useTemplateNamed: 'استخدم القالب: {{name}}',
        },
        loadMore: 'عرض المزيد من القوالب',
        empty: 'لا توجد قوالب في هذه الفئة بعد.',
        loadError: 'تعذّر تحميل القوالب.',
        designUnavailable: 'هذا التصميم غير متاح. اختر قالبًا.',
        notStarted: 'اختر «استخدم القالب» لبدء هذا التصميم.',
      },
      category: {
        jewelry: 'مجوهرات',
        fashion: 'أزياء',
        beauty: 'تجميل',
        electronics: 'إلكترونيات',
        homeLiving: 'المنزل والمعيشة',
        food: 'طعام',
        other: 'أخرى',
      },
      common: {
        retry: 'حاول مرة أخرى',
        cancel: 'إلغاء',
        close: 'إغلاق',
      },
      catalog: {
        'luxury-jewelry-v1': {
          title: 'مجوهرات فاخرة',
          description: 'تصميم تحريري كحلي وذهبي للمجوهرات، مع صفحات تسوّق متناسقة.',
        },
        'modern-beauty-v1': {
          title: 'الجمال العصري',
          description: 'تصميم محايد وواسع لمنتجات التجميل.',
        },
        'editorial-fashion-v1': {
          title: 'أزياء تحريرية',
          description: 'مجموعات غنية بالصور بأسلوب بسيط بالأبيض والأسود.',
        },
        'jewelry-atelier-v1': {
          title: 'مجوهرات',
          description: 'تصميم أنيق وفاخر للمجوهرات والإكسسوارات.',
        },
        'apparel-stride-v1': {
          title: 'أزياء',
          description: 'تصميم جريء للملابس والأحذية يبرز المقاسات.',
        },
        legacy: {
          title: 'تصميمك الأصلي',
          description: 'التصميم الذي كان لمتجرك قبل القوالب.',
        },
      },
      preview: {
        title: 'معاينة: {{name}}',
        readOnly: 'معاينة فقط. متجرك المنشور لا يتغير.',
        useThis: 'استخدم هذا القالب',
      },
      stage: {
        applying: 'جارٍ التطبيق…',
        title: 'استخدام {{name}}؟',
        carriedOver: 'العناصر المنقولة: {{count}}',
        notCarriedBody: 'لا يوجد مكان مناسب لهذه العناصر في القالب الجديد، لذلك لن تظهر فيه.',
        confirm: 'استخدم القالب',
        success: 'تمت إضافة القالب إلى مسودتك.',
        originalDesignNote: 'يبقى تصميمك الأصلي في قائمة القوالب، لذا يمكنك العودة إليه.',
      },
      useTemplate: {
        noPublish: 'ستُنشأ مسودة فقط. لن يُنشر شيء حتى تضغط «نشر».',
      },
      editor: {
        back: 'رجوع',
        status: {
          live: 'منشور',
          draft: 'مسودة',
          unpublishedChanges: 'تغييرات غير منشورة',
        },
        changeTemplate: 'تغيير القالب',
        editMode: 'وضع التعديل',
        on: 'تشغيل',
        off: 'إيقاف',
        publish: 'نشر',
        publishChanges: 'نشر التغييرات',
        allPublished: 'كل التغييرات منشورة',
        publishing: 'جارٍ النشر…',
        published: 'تغييراتك منشورة الآن.',
        noChanges: 'لا توجد تغييرات غير منشورة.',
        publishedStoreHint: 'تم نشر التصميم. سيظهر موقعك للزبائن بعد نشر المتجر.',
        unpublished: 'لديك تغييرات غير منشورة.',
        device: {
          desktop: 'عرض سطح المكتب',
          mobile: 'عرض الجوال',
        },
        reload: 'تحديث',
        openLive: 'عرض المتجر المنشور',
        page: {
          home: 'الرئيسية',
          catalog: 'قائمة المنتجات',
          product: 'صفحة المنتج',
          cart: 'السلة',
          checkout: 'إتمام الطلب',
          order: 'تأكيد الطلب',
          storeInfo: 'معلومات المتجر',
        },
        editHint: 'اختر أيقونة القلم لتعديل العنصر.',
        slotMarker: 'تعديل {{label}}',
        storeLanguage: 'لغة المتجر',
        legacyNotice: 'تم تحويل متجرك إلى تصميم ثابت. بعض الأجزاء أصبحت مقفلة.',
        legacyReport: 'عرض تفاصيل التحويل',
        unmappable:
          'تعذّر تحويل تصميمك الحالي تلقائيًا. متجرك المنشور لم يتغير. اختر قالبًا لمتابعة التعديل.',
        templateThumbnailAlt: 'قالب {{name}}',
        more: 'خيارات إضافية',
        updateTemplate: 'تحديث القالب',
        updateTemplateHint: 'يتوفر إصدار أحدث من هذا التصميم. سيُحتفظ بمحتواك حيثما يناسب.',
        updating: 'جارٍ التحديث…',
        updateTemplateDone: 'تم تحديث القالب',
        updateTemplateAllKept: 'تم الاحتفاظ بكل محتواك.',
        save: {
          notSaved: 'لم يُحفظ — صحّح الحقل المحدد',
          saving: 'جارٍ الحفظ…',
          saved: 'تم حفظ كل التغييرات',
          savedShort: 'تم الحفظ',
          failed: 'تعذّر حفظ التغييرات',
          retry: 'إعادة المحاولة',
          conflict: 'تم تغيير هذا أيضًا في نافذة أخرى.',
          conflictShort: 'تغيّر في نافذة أخرى',
          conflictHelp:
            'الاحتفاظ بنسختك يحمّل أحدث مسودة ويضع نصك من هذه النافذة فوقها، فيحلّ محل تغييرات النافذة الأخرى على العناصر نفسها.',
          reload: 'الاحتفاظ بنسختي',
          rejected: 'تعذّر حفظ أحد العناصر',
        },
      },
      report: {
        title: 'تفاصيل التحويل',
        mapped: 'عناصر قابلة للتعديل: {{count}}',
        frozen: 'عناصر مقفلة: {{count}}',
        sourceLanguage: 'النص المحفوظ من: {{language}}',
      },
      leave: {
        title: 'آخر تغييراتك لم تُحفظ',
        body: 'إذا غادرت الآن فستضيع.',
        saving: 'جارٍ حفظ تغييراتك قبل المغادرة…',
        leave: 'المغادرة دون حفظ',
        retry: 'إعادة المحاولة والمغادرة',
        keepMine: 'الاحتفاظ بنسختي والمغادرة',
        stay: 'البقاء',
      },
      dialog: {
        titleEdit: 'تعديل {{label}}',
        useDefault: 'استخدام نص القالب',
        leaveEmpty: 'اتركه فارغًا',
        textHelp: 'اكتب ما يجب أن يراه المتسوقون تمامًا، بأي لغة.',
        charCount: '{{count}} / {{max}}',
        required: 'مطلوب قبل النشر.',
        conflictTitle: 'تغيّرت هذه المسودة في مكان آخر',
        conflictBody:
          'تم حفظ نسخة أحدث في نافذة أخرى. اختيارك هنا يبقى كما هو: أعد التحميل لتطبيقه على النسخة الأحدث.',
        reloadDraft: 'إعادة تحميل المسودة',
        saveFailed: 'تعذّر حفظ التغييرات. حاول مرة أخرى.',
        refreshFailed:
          'تم حفظ تغييراتك، لكن تعذّر تحميل المسودة المحدّثة. أعد تحميل المسودة للمتابعة.',
        discardTitle: 'تجاهل التغييرات غير المحفوظة؟',
        discardBody: 'لم تُحفظ تغييراتك في هذه النافذة.',
        keepEditing: 'متابعة التعديل',
        discard: 'تجاهل التغييرات',
        done: 'تم',
      },
      link: {
        shop: 'تسوّق جميع المنتجات',
        sales: 'التخفيضات',
        choose: 'اختر…',
        method: {
          whatsapp: 'واتساب',
          phone: 'الهاتف',
          email: 'البريد الإلكتروني',
        },
        label: 'الرابط إلى',
        none: 'بدون رابط',
        category: 'فئة',
        product: 'منتج',
        collection: 'مجموعة',
        storePage: 'صفحة في المتجر',
        contact: 'التواصل',
      },
      ref: {
        noOptions: 'لا توجد عناصر للاختيار بعد. أضفها من الكتالوج أولًا.',
        chooseCategory: 'اختر فئة',
        chooseProduct: 'اختر منتجًا',
        chooseCollection: 'اختر مجموعة',
        auto: 'اختيار تلقائي',
      },
      media: {
        posterFailed: 'تعذّر إنشاء صورة غلاف من هذا الفيديو. ارفع صورة غلاف للمتابعة.',
        emptyPreview: 'لا توجد وسائط بعد',
        upload: 'رفع ملف',
        limits: {
          image: 'الصور: JPG أو PNG أو WebP، حتى 5 ميغابايت.',
          gif: 'GIF: حتى 8 ميغابايت.',
          video: 'فيديو: MP4 أو WebM، حتى 15 ثانية و20 ميغابايت.',
        },
        poster: 'صورة الغلاف',
        posterHelp: 'تظهر قبل تشغيل الفيديو وعند تقليل الحركة.',
        altRequired: 'أضف وصفًا قصيرًا قبل حفظ هذه الصورة',
        alt: 'وصف لقارئات الشاشة',
        remove: 'إزالة الوسائط الحالية',
        uploading: 'جارٍ الرفع…',
        checking: 'جارٍ فحص الملف…',
        error: {
          type: 'نوع الملف غير مدعوم هنا.',
          mov: 'ملفات MOV غير مدعومة. صدّر الملف بصيغة MP4 (H.264) وارفعه مجددًا.',
          size: 'الملف كبير جدًا.',
          dimensions: 'أبعاد الصورة أو الفيديو خارج النطاق المسموح.',
          duration: 'الفيديو أطول من 15 ثانية.',
          codec: 'صيغة الفيديو غير مدعومة. استخدم MP4 (H.264) أو WebM.',
          metadata: 'يحتوي الفيديو على بيانات وصفية لا يمكن إزالتها. صدّره مجددًا بصيغة MP4.',
          posterRequired: 'أضف صورة غلاف لهذه الحركة أو الفيديو.',
          generic: 'فشل الرفع. حاول مرة أخرى.',
          corrupt: 'الملف تالف أو لا يمكن فتحه.',
        },
        current: 'الوسائط الحالية',
        uploadImageOrVideo: 'رفع صورة أو فيديو',
        uploadImage: 'رفع صورة',
        dropHint: 'أو اسحب ملفًا إلى هنا',
        help: {
          imageOrVideo: 'ارفع صورة عالية الجودة أو فيديو قصيرًا يتكرر تلقائيًا.',
          image: 'ارفع صورة عالية الجودة.',
        },
        progress: 'جارٍ الرفع… {{percent}}٪',
        posterAuto: 'أنشأنا صورة غلاف من الفيديو. يمكنك استبدالها.',
        replacePoster: 'استبدال صورة الغلاف',
        useTemplateImage: 'استخدام صورة القالب',
        framing: {
          title: 'الموضع والتكبير',
          desktop: 'سطح المكتب',
          mobile: 'الجوال',
          zoom: 'تكبير',
          zoomIn: 'تكبير الصورة',
          zoomOut: 'تصغير الصورة',
          reset: 'إعادة ضبط',
          apply: 'تطبيق',
          dragHint: 'اسحب لتغيير الموضع. استخدم مفاتيح الأسهم للتحريك.',
          position: 'الموضع داخل الإطار',
          positionStatus: 'أفقيًا {{x}}٪، عموديًا {{y}}٪، تكبير {{zoom}}×',
          previewNote: 'قد يتغيّر هذا الإطار قليلًا في متجرك حسب حجم الشاشة والنص.',
          defaultHint: 'ارفع صورتك الخاصة لضبط موضعها',
          unappliedTitle: 'الموضع الجديد غير مطبَّق',
          unappliedBody: 'اضغط «تطبيق» للاحتفاظ بالموضع والتكبير اللذين غيّرتهما، أو غادر دونهما.',
          leaveUnapplied: 'المغادرة دون تطبيق',
        },
      },
      locale: {
        title: 'لغة المتجر',
        help: 'الأزرار والسلة والدفع والرسائل في متجرك تستخدم هذه اللغة. نصوصك تبقى كما كتبتها تمامًا.',
        independent: 'هذا لا يغيّر لغة لوحة التحكم.',
        ar: 'العربية',
        he: 'עברית',
        en: 'English',
        save: 'حفظ',
        saving: 'جارٍ الحفظ…',
      },
      readiness: {
        missingMerchantValue: '{{label}} يحتاج إلى نصك.',
        missingRequired: '{{label}} مطلوب.',
        invalidMedia: '{{label}}: الملف لم يعد متاحًا.',
        invalidReference: '{{label}}: العنصر المرتبط لم يعد متاحًا.',
        missingLogo: 'ارفع شعار المتجر قبل النشر.',
        goTo: 'الانتقال إلى العنصر',
      },
      publish: {
        titleDesign: 'نشر {{name}}؟',
        titleChanges: 'نشر التغييرات على {{name}}؟',
        titleOriginal: 'نشر هذا التصميم؟',
        bodyChanges: 'سيرى الزبائن آخر التغييرات المحفوظة على {{name}}.',
        bodyFirst: 'لا يوجد تصميم منشور لمتجرك بعد. سيرى الزبائن {{name}}.',
        bodyFirstStoreOffline:
          'لا يوجد تصميم منشور لمتجرك بعد. سيرى الزبائن {{name}} بعد نشر متجرك.',
        bodyReplace: 'سيرى الزبائن {{name}} بدلًا من {{live}}. تبقى مسودة {{live}} محفوظة.',
        bodyReplaceUnknown: 'سيرى الزبائن {{name}} بدلًا من التصميم المنشور حاليًا.',
        bodyReplaceOriginal:
          'سيحلّ هذا التصميم محل التصميم الذي يعرضه متجرك الآن. سيرى الزبائن هذا التصميم.',
        stale: 'تغيّرت واجهة متجرك في جلسة أخرى. حدّث الصفحة وحاول مرة أخرى.',
        title: 'نشر تغييرات واجهة المتجر؟',
        body: 'ستصبح تغييرات واجهة متجرك المحفوظة مرئية للعملاء.',
        confirm: 'نشر',
        failed: 'فشل النشر. لم يتغير شيء في متجرك المنشور.',
        checking: 'جارٍ فحص واجهة متجرك…',
        fixFirst: 'أصلح هذه العناصر قبل النشر:',
        successTitle: 'تم نشر واجهة المتجر',
        viewLive: 'عرض المتجر المنشور',
        goToSettings: 'الانتقال إلى إعدادات المتجر',
        goToStorePublish: 'الانتقال إلى نشر المتجر',
        warningsTitle: 'أمور قد ترغب في إصلاحها',
        warningsIntro: 'يمكنك النشر الآن. يُفضّل إصلاح هذه الأمور لكنها لا تمنع النشر.',
        warningsToggle: 'عرض التفاصيل',
        warningsToggleHide: 'إخفاء التفاصيل',
        publishAnyway: 'النشر على أي حال',
        flushFirst: 'تعذّر حفظ آخر تغييراتك حتى الآن. حاول مرة أخرى.',
        adsNotice:
          'الإعلانات النشطة في متجرك تظهر في صفحة المتجر الحالية فقط، ولن يعرضها هذا التصميم. لن يُحذف أي شيء.',
      },
      issue: {
        missingStoreLogo: {
          warning: 'أضف شعار المتجر من الإعدادات',
        },
        invalidReference: {
          warning: 'يشير رابط إلى عنصر لم يعد متاحًا',
          warningNamed: '{{label}}: يشير الرابط إلى عنصر لم يعد متاحًا',
        },
        missingMerchantValue: {
          warning: '{{label}} بلا نص بعد',
        },
      },
      errors: {
        builderRetired: 'محرر التصميم القديم لم يعد متاحًا. استخدم محرر الموقع.',
        slotRetired: 'يُدار هذا العنصر من صفحته الخاصة.',
        templateUnavailable: 'هذا القالب لم يعد متاحًا.',
        invalidValue: 'لا يمكن حفظ هذه القيمة. تحقق منها وحاول مجددًا.',
        unsafeText: 'أزل رموز الاتجاه أو التحكم المخفية وحاول مجددًا.',
        tooLong: 'النص طويل جدًا.',
        rateLimited: 'عمليات حفظ كثيرة. انتظر قليلًا وحاول مجددًا.',
        generic: 'حدث خطأ ما. حاول مرة أخرى.',
      },
      slot: {
        mission: {
          body: 'نص رسالة المتجر',
          ctaLabel: 'نص رابط الرسالة',
          ctaLink: 'وجهة رابط الرسالة',
        },
        community: {
          heading: 'عنوان المجتمع',
          media: 'صورة أو فيديو المجتمع',
          ctaLabel: 'نص رابط المجتمع',
          ctaLink: 'وجهة رابط المجتمع',
        },
        newsletter: {
          heading: 'عنوان الاشتراك',
          body: 'نص الاشتراك',
          collection: 'إعدادات الاشتراك',
        },

        announcement: {
          text: 'الإعلان',
        },
        brand: {
          tagline: 'الشعار النصي',
        },
        hero: {
          heading: 'العنوان الرئيسي',
          subheading: 'العنوان الفرعي',
          ctaLabel: 'نص الزر',
          ctaLink: 'رابط الزر',
          media: 'الصورة أو الفيديو الرئيسي',
        },
        category: {
          tile: 'بطاقة الفئة',
          tileImage: 'صورة بطاقة الفئة',
        },
        section: {
          heading: 'عنوان القسم',
          body: 'نص القسم',
        },
        feature: {
          title: 'عنوان الميزة',
          body: 'نص الميزة',
        },
        promo: {
          heading: 'عنوان البانر',
          body: 'نص البانر',
          media: 'صورة أو فيديو البانر',
          ctaLabel: 'نص زر البانر',
          ctaLink: 'رابط زر البانر',
        },
        about: {
          heading: 'عنوان "من نحن"',
          body: 'عن متجرك',
          media: 'صورة "من نحن"',
        },
        policy: {
          delivery: 'سياسة التوصيل',
          returns: 'سياسة الإرجاع',
        },
        contact: {
          note: 'ملاحظة التواصل',
        },
        product: {
          careNote: 'تعليمات العناية',
          sizeGuide: 'دليل المقاسات',
        },
        cart: {
          note: 'ملاحظة السلة',
        },
        checkout: {
          note: 'ملاحظة الدفع',
        },
        confirmation: {
          message: 'رسالة الشكر',
        },
        footer: {
          note: 'نص التذييل',
        },
        legacy: {
          text: 'نص',
          media: 'صورة',
        },
        ordinal: '{{label}} {{n}}',
      },
      frame: {
        viewport: 'حجم المعاينة',
        toolbar: 'أدوات واجهة المتجر',
        back: 'الصفحة السابقة',
        forward: 'الصفحة التالية',
        address: 'عنوان الصفحة الحالية',
        loading: 'جارٍ تحميل واجهة متجرك…',
        loadError: 'تعذّر تحميل واجهة متجرك.',
        openLiveUnavailable: 'انشر واجهة متجرك أولًا لعرضها للعملاء.',
        resetNotice: 'أعدنا تحميل عرض واجهة متجرك. تغييراتك المحفوظة باقية.',
        draftCartNote: 'المنتجات التي تضيفها إلى السلة هنا للتجربة فقط. لا يتم إنشاء أي طلبات.',
      },
      overlay: {
        moreItems: 'عناصر أخرى قابلة للتعديل',
        regionListTitle: 'العناصر القابلة للتعديل في هذه الصفحة',
      },
      region: {
        newsletterCollection: {
          label: 'إعدادات الاشتراك',
          edit: 'تعديل إعدادات الاشتراك',
        },
        heroText: {
          label: 'نص الواجهة الرئيسية',
          edit: 'تعديل نص الواجهة الرئيسية',
        },
        heroMedia: {
          label: 'صورة أو فيديو الواجهة الرئيسية',
          edit: 'تعديل وسائط الواجهة الرئيسية',
        },
        heroMediaMobile: {
          label: 'وسائط الواجهة (الجوال)',
          edit: 'تعديل وسائط الواجهة (الجوال)',
        },
        heroMediaDesktop: {
          label: 'وسائط الواجهة (سطح المكتب)',
          edit: 'تعديل وسائط الواجهة (سطح المكتب)',
        },
        promoText: {
          label: 'نص البانر',
          edit: 'تعديل نص البانر',
        },
        promoMedia: {
          label: 'صورة أو فيديو البانر',
          edit: 'تعديل وسائط البانر',
        },
        aboutText: {
          label: 'نص "من نحن"',
          edit: 'تعديل نص "من نحن"',
        },
        aboutMedia: {
          label: 'صورة "من نحن"',
          edit: 'تعديل صورة "من نحن"',
        },
        categoryImage: {
          label: 'صورة الفئة',
          edit: 'تعديل صورة الفئة',
        },
        categoryTile: {
          label: 'الفئة المعروضة',
          edit: 'اختيار الفئة المعروضة',
        },
        categoriesHeading: {
          label: 'عنوان الفئات',
          edit: 'تعديل عنوان الفئات',
        },
        sectionHeading: {
          label: 'عنوان القسم',
          edit: 'تعديل عنوان القسم',
        },
        sectionText: {
          label: 'نص القسم',
          edit: 'تعديل نص القسم',
        },
        featureText: {
          label: 'نص الميزة',
          edit: 'تعديل نص الميزة',
        },
        announcement: {
          label: 'شريط الإعلان',
          edit: 'تعديل شريط الإعلان',
        },
        tagline: {
          label: 'العبارة التعريفية للمتجر',
          edit: 'تعديل العبارة التعريفية للمتجر',
        },
        footerText: {
          label: 'نص التذييل',
          edit: 'تعديل نص التذييل',
        },
        storeDetails: {
          label: 'تفاصيل المتجر',
          edit: 'تعديل تفاصيل المتجر',
        },
        storeAbout: {
          label: 'عن متجرك',
          edit: 'تعديل "عن متجرك"',
        },
        deliveryPolicy: {
          label: 'سياسة التوصيل',
          edit: 'تعديل سياسة التوصيل',
        },
        returnsPolicy: {
          label: 'سياسة الإرجاع',
          edit: 'تعديل سياسة الإرجاع',
        },
        productCare: {
          label: 'تعليمات العناية',
          edit: 'تعديل تعليمات العناية',
        },
        productSizeGuide: {
          label: 'دليل المقاسات',
          edit: 'تعديل دليل المقاسات',
        },
        cartNote: {
          label: 'ملاحظة السلة',
          edit: 'تعديل ملاحظة السلة',
        },
        checkoutNote: {
          label: 'ملاحظة الدفع',
          edit: 'تعديل ملاحظة الدفع',
        },
        thankYouMessage: {
          label: 'رسالة الشكر',
          edit: 'تعديل رسالة الشكر',
        },
        legacyText: {
          label: 'نص',
          edit: 'تعديل النص',
        },
        legacyMedia: {
          label: 'صورة',
          edit: 'تعديل الصورة',
        },
      },
    },
    storefrontEngine: {
      sections: {
        hero: {
          name: 'قسم البطل',
          description: 'يعرض أول مساحة يراها المتسوقون في واجهة المتجر.',
        },
        header: {
          name: 'رأس المتجر',
          description: 'يعرض شعار المتجر والتنقل الأساسي.',
        },
        footer: {
          name: 'تذييل المتجر',
          description: 'يعرض علامة دكانتي وروابط التواصل المتاحة.',
        },
        mobileNav: {
          name: 'تنقل الهاتف',
          description: 'يعرض روابط التنقل السريعة أسفل الشاشة.',
        },
        announcementBar: {
          name: 'شريط الإعلانات',
          description: 'يعرض رسالة قصيرة فوق رأس المتجر مع رابط اختياري.',
        },
        trustBadge: {
          name: 'شارة الثقة',
          description: 'تعرض ملخص تقييمات مختصر قرب رأس الصفحة.',
        },
        promotionalAds: {
          name: 'إعلانات المتجر',
          description: 'تعرض إعلانات المتجر النشطة.',
        },
        categories: {
          name: 'الأقسام',
          description: 'تعرض أقسام المتجر التي تحتوي على منتجات منشورة.',
        },
        benefits: {
          name: 'مزايا المتجر',
          description: 'تعرض مزايا يكتبها التاجر مع أيقونات معتمدة.',
        },
        faq: {
          name: 'الأسئلة الشائعة',
          description: 'تعرض أسئلة وأجوبة يكتبها التاجر.',
        },
        about: {
          name: 'عن المتجر',
          description: 'تعرض فقرات متجر مترجمة يكتبها التاجر.',
        },
        testimonials: {
          name: 'آراء مكتوبة',
          description: 'تعرض اقتباسات يكتبها التاجر دون بيانات زبائن أو طلبات.',
        },
        newsletterCta: {
          name: 'دعوة النشرة',
          description: 'تعرض دعوة آمنة مع جمع وسيلة تواصل بموافقة الزبون عند التفعيل.',
        },
        liveOffers: {
          name: 'العروض المباشرة',
          description: 'تعرض حملات العروض النشطة.',
        },
        productRail: {
          bestSellers: {
            name: 'الأكثر مبيعا',
            description: 'تعرض المنتجات الأكثر طلبا.',
          },
          trendingNow: {
            name: 'الرائجة الآن',
            description: 'تعرض المنتجات الرائجة مؤخرا.',
          },
          newArrivals: {
            name: 'وصل حديثا',
            description: 'تعرض أحدث المنتجات المنشورة.',
          },
          specialOffers: {
            name: 'عروض خاصة',
            description: 'تعرض المنتجات ذات السعر المخفض.',
          },
          customCollection: {
            name: 'مجموعة مخصصة',
            description: 'تعرض مجموعة منتجات مرتبة يختارها التاجر.',
          },
        },
        trustSummary: {
          name: 'ملخص الثقة',
          description: 'يعرض ملخصا أوسع للتقييمات.',
        },
        editorialBanner: {
          name: 'لافتة تحريرية',
          description:
            'تعرض صورة وعنوانًا ونصًا ودعوة لاتخاذ إجراء من تأليف التاجر لكسر إيقاع الصفحة.',
        },
      },
      lifecycle: {
        duplicate: 'تكرار {{section}}',
        restore: 'استعادة {{section}}',
        add: {
          open: 'إضافة قسم',
          title: 'إضافة قسم',
          description: 'اختر قسمًا مدعومًا من الصفحة الرئيسية لإضافته إلى هذه المسودة.',
          empty: 'لا توجد أقسام يمكن إضافتها الآن.',
          insertion: {
            afterSelected: 'يضاف بعد {{section}}.',
            atPlacement: 'يضاف إلى {{placement}}.',
          },
        },
        delete: {
          open: 'حذف {{section}}',
          title: 'حذف القسم',
          description:
            'احذف {{section}} من هذه المسودة. يبقى القسم قابلًا للاستعادة حتى تنشر تغييرًا آخر.',
          confirm: 'حذف القسم',
        },
        pending: {
          ready:
            'تم تجهيز تغيير دورة الحياة. اضغط تطبيق لتحديث المعاينة الحية أو إلغاء للحفاظ على الصفحة الحالية.',
          apply: 'تطبيق',
          cancel: 'إلغاء',
          applied: 'تم تطبيق تغيير دورة الحياة.',
          cancelled: 'تم إلغاء تغيير دورة الحياة.',
          blocking: 'طبّق أو ألغِ تغيير دورة الحياة قبل المتابعة.',
        },
      },
      inlineEditor: {
        launch: {
          open: 'فتح المحرر المباشر',
          description: 'استخدم لوحة واجهة متجر كاملة لتعديل الأقسام مباشرة.',
        },
        toolbar: {
          label: 'شريط أدوات محرر واجهة المتجر المباشر',
          backToBuilder: 'العودة إلى الباني',
          navigationControls: 'تنقل المحرر',
          statusControls: 'حالة المحرر',
          deviceControls: 'جهاز المعاينة',
          zoomControls: 'أدوات التكبير',
          sectionControls: 'عناصر تحكم القسم',
          historyControls: 'عناصر تحكم السجل',
          releaseControls: 'عناصر تحكم المسودة والنشر',
          openSettings: 'تعديل الإعدادات',
          openQuickPresentation: 'عرض سريع',
          addSection: 'إضافة قسم',
        },
        inspector: {
          title: 'لوحة القسم',
          description: 'تحرير {{section}}.',
          emptyTitle: 'لا يوجد قسم محدد',
          emptyBody: 'اختر قسما من واجهة المتجر لتعديله.',
          readOnlyTitle: 'قسم للعرض فقط',
        },
      },
      v3: {
        shell: {
          ariaLabel: 'محرر باني واجهة المتجر V3',
          panelDrawer: 'لوحة الباني',
          panelDrawerDescription: 'عدّل منطقة الباني المحددة في درج مضغوط.',
          inspectorDrawer: 'لوحة القسم',
          inspectorDrawerDescription: 'عدّل القسم المحدد في درج لوحة مضغوط.',
        },
        rail: {
          ariaLabel: 'مناطق الباني',
          templates: 'القوالب',
          design: 'التصميم',
          sections: 'الأقسام',
          settings: 'الإعدادات',
        },
        toolbar: {
          dukantiIdentity: 'دوكانتي',
          storefrontIdentity: 'واجهة المتجر',
          back: 'العودة إلى واجهة المتجر',
          publish: 'نشر',
          undo: 'تراجع',
          redo: 'إعادة',
          deviceGroup: 'جهاز اللوحة',
          status: {
            draft: 'مسودة',
            published: 'منشور',
          },
        },
        autosave: {
          idle: 'جاهز',
          dirty: 'تغييرات غير محفوظة',
          debouncing: 'سيتم الحفظ بعد قليل',
          saving: 'جارٍ الحفظ...',
          saved: 'تم حفظ كل التغييرات',
          failed: 'تعذر الحفظ',
          conflict: 'يلزم التحديث',
          blocked: 'النشر محجوب',
          details: {
            idle: 'المسودة جاهزة.',
            dirty: 'تنتظر التغييرات الحفظ كمسودة.',
            debouncing: 'سيتم حفظ المسودة بعد لحظات.',
            saving: 'يتم حفظ هذه المسودة قبل أي نشر.',
            saved: 'المسودة محفوظة. المتجر المباشر لم يتغير.',
            failed: 'تعديلاتك المحلية ما زالت موجودة.',
            conflict: 'حمّل أحدث مسودة قبل النشر.',
            blocked: 'أصلح الحقول المحددة قبل النشر.',
          },
        },
        templates: {
          title: 'القوالب',
          description:
            'ابدأوا من واجهة متجر مصممة لنوع تجارتكم، ثم عدّلوا التصميم والأقسام كما تريدون.',
          categoriesTitle: 'أنواع المتاجر',
          allCategories: 'الكل',
          results: {
            all: 'القوالب المتاحة: {{count}}',
            category: 'قوالب {{category}}: {{count}}',
            allDescription:
              'اختاروا نوع المتجر، راجعوا الملاءمة، ثم طبّقوا القالب على هذه المسودة.',
          },
          metadata: {
            intent: 'الهدف: {{intent}}',
            themePreset: 'النمط: {{theme}}',
          },
          actions: {
            apply: 'تطبيق',
            applied: 'مطبق',
            save: 'حفظ القالب الحالي',
            delete: 'حذف {{name}}',
          },
          intent: {
            quickStart: 'بداية سريعة',
            campaign: 'يقودها العرض',
            trust: 'يقودها الثقة',
            catalog: 'يقودها الكتالوج',
            story: 'تقودها القصة',
            education: 'يقودها الشرح',
            comparison: 'يقودها المقارنة',
            inspiration: 'يقودها الإلهام',
            repeatPurchase: 'للطلب المتكرر',
            freshness: 'طازج اليوم',
            occasion: 'للمناسبات',
            consultation: 'للاستشارة',
          },
          categories: {
            starter: {
              name: 'بداية عامة',
              description: 'واجهات متوازنة للتجار الذين يريدون انطلاقة جاهزة.',
            },
            seasonal: {
              name: 'موسمي',
              description: 'تخطيطات تبرز عروض الصيف والشتاء والحملات.',
            },
            story: {
              name: 'قصة المتجر',
              description: 'واجهات تحريرية للحرفة والهوية وبناء الثقة.',
            },
            'jewellery-accessories': {
              name: 'مجوهرات وإكسسوارات',
              description: 'قوالب ثقة للخواتم والهدايا والساعات والإكسسوارات.',
            },
            fashion: {
              name: 'أزياء',
              description: 'تصفح سريع للملابس والأحذية والبوتيكات.',
            },
            'beauty-wellness': {
              name: 'جمال وعناية',
              description: 'تخطيطات حسب الروتين للعناية والتجميل والرفاه.',
            },
            electronics: {
              name: 'إلكترونيات',
              description: 'تخطيطات مناسبة للمقارنة بين الأجهزة والإكسسوارات والمواصفات.',
            },
            'home-decor': {
              name: 'بيت وديكور',
              description: 'تخطيطات ملهمة للديكور والأثاث ومنتجات البيت.',
            },
            'food-grocery': {
              name: 'بقالة وطعام',
              description: 'تخطيطات كثيفة للطلبات اليومية والعروض المتكررة.',
            },
            'bakery-prepared-food': {
              name: 'مخبوزات وطعام جاهز',
              description: 'تخطيطات تبدأ بالطازج للمخابز والمطابخ وقوائم اليوم.',
            },
            gifts: {
              name: 'هدايا',
              description: 'قوالب تقودها المناسبة للهدايا والباقات المختارة.',
            },
            services: {
              name: 'خدمات',
              description: 'تخطيطات ثقة واستشارة للخدمات والمواعيد والاستوديوهات.',
            },
          },
          saved: {
            title: 'قوالب محفوظة',
            description: 'احفظوا المسودة الحالية وأعيدوا استخدامها للمواسم أو الفروع أو الحملات.',
            label: 'احفظوا قالبكم',
            placeholder: 'مثال: شتاء 2027',
            savedTitle: 'قوالبكم المحفوظة',
            loading: 'جارٍ تحميل القوالب المحفوظة...',
            empty: 'لا توجد قوالب محفوظة بعد.',
            updatedAt: 'تم التحديث {{value}}',
          },
          messages: {
            applied: 'تم تطبيق القالب على المسودة.',
            saved: 'تم حفظ القالب.',
            deleted: 'تم حذف القالب المحفوظ.',
            notFound: 'هذا القالب المحفوظ لم يعد متاحا.',
            applyFailed: 'تعذر تطبيق هذا القالب.',
            saveFailed: 'تعذر حفظ هذا القالب.',
            deleteFailed: 'تعذر حذف هذا القالب.',
          },
        },
        design: {
          title: 'التصميم',
          description: 'شكّل مظهر واجهة المتجر.',
          themeSummary: 'النمط الحالي',
          chooseTheme: 'اختيار النمط',
          colorOption: '{{role}}: {{color}}',
          baseSize: 'حجم الخط الأساسي',
          baseSizeOptions: {
            compact: 'مضغوط',
            comfortable: 'مريح',
            large: 'كبير',
          },
          groups: {
            theme: 'النمط',
            colors: 'الألوان',
            typography: 'الخطوط',
            buttons: 'الأزرار',
            cards: 'البطاقات',
            spacing: 'التباعد',
          },
          defaults: {
            title: 'تصاميم جاهزة',
            description: 'ابدأ من تصميم كامل لواجهة المتجر أو احفظ هذه المسودة لإعادة استخدامها.',
            actions: {
              apply: 'تطبيق',
              save: 'حفظ التصميم الحالي',
              delete: 'حذف {{name}}',
            },
            tags: {
              balanced: 'متوازن',
              quickStart: 'بداية سريعة',
              seasonal: 'موسمي',
              offers: 'عروض',
              trust: 'ثقة',
              catalog: 'كتالوج',
              compact: 'مضغوط',
              story: 'قصة',
              spacious: 'واسع',
              editorial: 'تحريري',
              newArrivals: 'وصل حديثا',
              specs: 'مواصفات',
            },
            items: {
              'dukanti-starter': {
                name: 'بداية دوكانتي',
                description: 'واجهة متجر متوازنة للبيع اليومي مع أقسام مألوفة.',
              },
              'summer-market': {
                name: 'سوق الصيف',
                description: 'تخطيط مشرق يبرز العروض والحملات الموسمية.',
              },
              'winter-warmth': {
                name: 'دفء الشتاء',
                description: 'أقسام قصة وثقة أدفأ لتصفح موسمي أهدأ.',
              },
              'boutique-catalog': {
                name: 'كتالوج بوتيك',
                description: 'شبكات منتجات مضغوطة للمتاجر التي تريد تصفحا أسرع.',
              },
              'galilee-story': {
                name: 'قصة الجليل',
                description: 'مسار واسع بطابع تحريري للمتاجر التي تبدأ بالحرفة والهوية.',
              },
              'jewellery-atelier': {
                name: 'مشغل المجوهرات',
                description: 'واجهة ثقة للخواتم والساعات والهدايا والإكسسوارات.',
              },
              'fashion-boutique': {
                name: 'بوتيك أزياء',
                description: 'تصفح موسمي سريع للملابس والأحذية ومجموعات الإكسسوارات.',
              },
              'beauty-care': {
                name: 'عناية وجمال',
                description: 'مسار حسب الروتين للعناية بالبشرة والتجميل ومنتجات الرفاه.',
              },
              'electronics-hub': {
                name: 'مركز الإلكترونيات',
                description: 'واجهة مناسبة للمقارنة بين الأجهزة والإكسسوارات والعروض.',
              },
              'home-decor': {
                name: 'ديكور البيت',
                description: 'مسار إلهامي تحريري للديكور والأثاث ومنتجات البيت.',
              },
              'food-grocery': {
                name: 'بقالة وطعام',
                description: 'تخطيط كثيف يبرز الاحتياجات اليومية والطلبات المتكررة.',
              },
              'bakery-kitchen': {
                name: 'مخبز ومطبخ',
                description: 'واجهة تبدأ بالطازج للمخابز والمطابخ وقوائم اليوم.',
              },
              'gift-shop': {
                name: 'متجر هدايا',
                description: 'تصفح حسب المناسبة للهدايا والباقات والمجموعات المختارة.',
              },
              'service-studio': {
                name: 'استوديو خدمات',
                description: 'واجهة ثقة وأسئلة شائعة للخدمات والمواعيد والاستشارات.',
              },
            },
            custom: {
              label: 'احفظ تصميمك',
              placeholder: 'مثال: شتاء 2027',
              savedTitle: 'تصاميم محفوظة',
              loading: 'جارٍ تحميل التصاميم المحفوظة...',
              empty: 'لا توجد تصاميم محفوظة بعد.',
              updatedAt: 'تم التحديث {{value}}',
            },
            messages: {
              applied: 'تم تطبيق التصميم الجاهز على المسودة.',
              saved: 'تم حفظ التصميم الجاهز.',
              deleted: 'تم حذف التصميم المحفوظ.',
              notFound: 'هذا التصميم المحفوظ لم يعد متاحا.',
              applyFailed: 'تعذر تطبيق هذا التصميم الجاهز.',
              saveFailed: 'تعذر حفظ هذا التصميم الجاهز.',
              deleteFailed: 'تعذر حذف هذا التصميم الجاهز.',
            },
          },
        },
        sections: {
          title: 'الأقسام',
          description: 'تحكم ببنية الصفحة والظهور ونقاط الإضافة.',
          add: 'إضافة قسم',
          empty: 'لا توجد أقسام متاحة لهذه الصفحة.',
          alwaysVisible: 'ظاهر دائما',
          more: 'إجراءات إضافية لـ {{section}}',
          reorder: 'إعادة ترتيب {{section}}. اسحب أو استخدم سهم الأعلى وسهم الأسفل.',
        },
        settings: {
          title: 'الإعدادات',
          description: 'عدّل التنقل والبحث والمشاركة في واجهة المتجر.',
          navigation: 'التنقل',
          seo: 'البحث والمشاركة',
          autosaveReady: 'يتم الحفظ التلقائي بعد كل تعديل صالح.',
          invalidLocalBuffers: 'أصلح الحقل المحدد قبل أن يستمر الحفظ التلقائي.',
        },
        gallery: {
          title: 'إضافة قسم',
          description: 'اختر قسما لهذه الصفحة.',
          searchPlaceholder: 'ابحث في الأقسام',
          categoryAriaLabel: 'تصنيفات الأقسام',
          empty: 'لا توجد أقسام تطابق هذا التصنيف.',
          summary: {
            all: 'أنواع الأقسام المتاحة: {{count}}',
            category: 'أقسام {{category}}: {{count}}',
            search: 'نتائج البحث: {{count}}',
          },
          status: {
            available: 'متاح للإضافة',
            blocked: 'غير متاح هنا',
          },
          categoryDescriptions: {
            all: 'تصفحوا كل أنواع الأقسام المدعومة لهذه المسودة.',
            featured: 'ابدأوا بأقسام هوية واجهة المتجر الأساسية.',
            products: 'أضيفوا رفوف منتجات تستخدم مصادر المنتجات العامة.',
            categories: 'أضيفوا أقسام اكتشاف التصنيفات المبنية على التصنيفات العامة.',
            marketing: 'أضيفوا أقسام عروض وترويج تلتزم بعقود الحملات الحالية.',
            content: 'أضيفوا أقسام القصة والثقة والأسئلة والنشرة والمحتوى التحريري.',
            trust: 'أضيفوا أقسام إثبات تلخص إشارات ثقة ظاهرة للمتسوقين.',
            global: 'راجعوا أقسام الهيكل العام التي تتحكم بها عقود الباني.',
            layout: 'أضيفوا أقسام بنيوية فقط عندما تدعمها الصفحة الحالية.',
            advanced: 'تبقى الأقسام المتقدمة محكومة بنفس عقود واجهة المتجر.',
          },
          categories: {
            all: 'كل الأقسام',
            featured: 'مميز',
            products: 'المنتجات',
            categories: 'التصنيفات',
            marketing: 'التسويق',
            content: 'المحتوى',
            trust: 'الثقة',
            global: 'عام',
            layout: 'التخطيط',
            advanced: 'متقدم',
          },
        },
        inspector: {
          close: 'إغلاق اللوحة',
          tabList: 'مجموعات إعدادات اللوحة',
          tabs: {
            content: 'المحتوى',
            design: 'التصميم',
            settings: 'الإعدادات',
          },
          empty: {
            title: 'اختر قسما لتعديله',
            body: 'اختر قسما من لوحة واجهة المتجر الحقيقية أو من قائمة البنية.',
          },
          hero: {
            kicker: 'قسم الواجهة',
            mediaTitle: 'وسائط الواجهة',
            mediaHelp: 'اختر صورة الحاسوب أولا، ثم أضف قصّة للهاتف عندما تساعد التكوين.',
            desktopRecommendation: 'المقاس الموصى به للحاسوب: 1440 × 720 بكسل، قص أفقي.',
            mobileRecommendation: 'المقاس الموصى به للهاتف: 900 × 1200 بكسل، قص مركزي.',
            mobileCrop: 'قصّة الهاتف اختيارية',
            mediaSelected: 'تم اختيار صورة',
            mediaAvailable: 'متاحة لصورة الواجهة هذه',
            mediaUnavailable: 'اختر صورة أخرى لقسم الواجهة هذا.',
            mediaCurrent: 'صورة الواجهة الحالية',
            mediaMissing: 'لم يتم اختيار صورة بعد.',
            noImage: 'لا توجد صورة مختارة',
            browseLibrary: 'تصفح مكتبة الصور',
            changeImage: 'تغيير الصورة',
            mediaUploadHint: 'JPEG أو PNG أو WebP. حتى 5MB و4096 بكسل.',
            copyTitle: 'نص مترجم',
            copyHelp: 'عدّل لغة واحدة كل مرة. تبقى العربية والعبرية والإنجليزية معا لهذه الشريحة.',
            localeTabs: 'لغات محتوى الواجهة',
            characterCount: '{{count}} / {{max}} حرفا',
            previewLabel: 'معاينة التخطيط',
            scheduleTimezone: 'تظهر الأوقات بتوقيت إسرائيل المحلي وتحفظ بصيغة UTC.',
            scheduleInvalid: 'أدخل تاريخا ووقتا كاملين قبل حفظ هذا الجدول.',
            specificCategoryHelp:
              'يرتبط هذا الزر بالتصنيف المختار. غيّر التصنيف من منتقي التصنيفات عندما يتوفر هذا التحكم.',
            selectedCategory: 'التصنيف المختار: {{category}}',
            categorySearch: 'ابحث في التصنيفات',
            title: 'محتوى الواجهة',
            description: 'عدّل وسائط الواجهة والنصوص والأزرار.',
          },
        },
        overlay: {
          editShort: 'تعديل',
          edit: 'تعديل {{section}}',
          drag: 'سحب {{section}}',
          more: 'إجراءات إضافية لـ {{section}}',
          addAfter: 'إضافة قسم بعد {{section}}',
        },
        publish: {
          readyTitle: 'جاهز للنشر',
          readyDescription: 'انشر آخر مسودة محفوظة إلى واجهة المتجر المباشرة.',
          blockedTitle: 'أصلح {{count}} مشاكل قبل النشر',
          blockedDescription: 'راجع كل مشكلة، ثم انشر عندما تصبح المسودة جاهزة.',
          failedTitle: 'فشل النشر',
          failedRetry: 'فشل النشر. لم يتغير شيء في واجهة المتجر المباشرة.',
          publishedTitle: 'تم نشر المتجر',
          publishedDescription: 'واجهة المتجر المباشرة تعرض هذه المسودة الآن.',
          confirm: 'نشر المتجر',
          copyLink: 'نسخ رابط المتجر',
          viewLiveStore: 'عرض المتجر المباشر',
          noBlockingIssues: 'لم يتم العثور على مشاكل تمنع النشر.',
          summary: {
            store: 'المتجر',
            link: 'رابط المتجر',
            sections: 'الأقسام',
            sectionCount: '{{count}} أقسام',
            devices: 'أوضاع العرض المتاحة',
            deviceViews: 'حاسوب، جهاز لوحي، هاتف',
            impact: 'الأثر على المتجر المباشر',
          },
          impact: {
            ready: 'لن يتغير شيء للمتسوقين حتى تؤكد.',
            blocked: 'يبقى المتجر المباشر كما هو أثناء إصلاح المشاكل.',
            savingDraft: 'يتم حفظ هذه المسودة أولا؛ المتسوقون ما زالوا يرون المتجر الحالي.',
            validating: 'يتم فحص المحتوى العام الآمن قبل أن يظهر أي شيء مباشرة.',
            publishing: 'النشر يستبدل المتجر المباشر الآن.',
            published: 'يمكن للمتسوقين رؤية هذه المسودة المنشورة الآن.',
            failed: 'المسودة المحفوظة ما زالت متاحة؛ المتجر المباشر لم يتغير.',
          },
          issue: {
            hero: 'قسم الواجهة',
            fixHero: 'أضف محتوى الواجهة قبل النشر.',
          },
        },
        errors: {
          validationFailed: 'أصلح الحقل المحدد قبل متابعة الحفظ التلقائي.',
        },
        conflict: {
          replaceLocalChanges:
            'هل تريد تحميل أحدث نسخة محفوظة من المتجر؟ سيتم تجاهل تغييراتك المحلية.',
          staleDraft: 'تغيرت هذه المسودة من مكان آخر. حدّث قبل النشر.',
        },
      },
      builder: {
        title: 'واجهة المتجر',
        subtitle: 'رتّب أقسام الصفحة الرئيسية وحدد ما يظهر للمتسوقين.',
        sectionListTitle: 'أقسام الصفحة الرئيسية',
        source: {
          draft: 'تعديل مسودة محفوظة',
          published: 'تعديل النسخة المنشورة',
          default: 'تعديل الواجهة الافتراضية',
        },
        sourceDescriptors: {
          cardTitle: 'المصدر',
          workspaceTitle: 'إرشادات المصدر',
          metrics: {
            selectedCount: '{{count}} محدد',
            visibleLimit: 'يعرض حتى {{count}}',
          },
          badges: {
            automatic: 'تلقائي',
            manual: 'اختيار يدوي',
            customCollection: 'مرتبط بمجموعة',
            publishedEligibility: 'أهلية النشر',
            hidden: 'مخفي',
            disabled: 'معطل',
            draftDeleted: 'محذوف في المسودة',
            nonRendered: 'لا يظهر',
            invalid: 'يحتاج مراجعة',
          },
          warnings: {
            emptyManualSelection: 'اختر عنصرا واحدا على الأقل قبل المعاينة أو النشر.',
            invalidSourceShape: 'إعداد المصدر غير صالح. أعد تطبيق المصدر قبل المعاينة أو النشر.',
            publishedEligibilityRisk: 'المعاينة والنشر يستخدمان فقط العناصر التي تبقى عامة ومؤهلة.',
            customCollectionReadinessRisk:
              'تتحقق المعاينة والنشر من أن هذه المجموعة ما زالت تضم منتجات منشورة.',
            hiddenSection: 'هذا القسم مخفي في الباني ولا يظهر للمتسوقين.',
            disabledSection: 'هذا القسم معطل ولن يظهر حتى يتم إصلاح عقد القسم.',
            draftDeletedSection: 'هذا القسم محذوف في المسودة. استعده قبل تعديل المصدر.',
            nonRenderedSection: 'هذا القسم لا يظهر حاليا في المعاينة.',
          },
          modes: {
            productAutoBestSellers: {
              label: 'الأكثر مبيعا',
              summary: 'سكة منتجات تلقائية من المنتجات العامة الأكثر مبيعا.',
              guidance: 'تستخدم ترتيب المنتجات العام الموجود والحد المضبوط.',
            },
            productAutoTrendingNow: {
              label: 'الرائج الآن',
              summary: 'سكة منتجات تلقائية من المنتجات العامة الرائجة.',
              guidance: 'تستخدم ترتيب المنتجات العام الموجود والحد المضبوط.',
            },
            productAutoNewArrivals: {
              label: 'وصل حديثا',
              summary: 'سكة منتجات تلقائية من أحدث المنتجات العامة.',
              guidance: 'تستخدم ترتيب المنتجات العام الموجود والحد المضبوط.',
            },
            productAutoSpecialOffers: {
              label: 'العروض الخاصة',
              summary: 'سكة منتجات تلقائية من المنتجات العامة ذات العروض النشطة.',
              guidance: 'تستخدم ترتيب المنتجات العام الموجود والحد المضبوط.',
            },
            productManualSelection: {
              label: 'منتجات مختارة يدويا',
              summary: 'سكة منتجات يدوية من منتجات عامة مختارة.',
              guidance: 'تظهر فقط المنتجات المختارة التي تبقى منشورة ومؤهلة.',
            },
            productCustomCollection: {
              label: 'مجموعة مخصصة',
              summary: 'سكة منتجات مرتبطة بمجموعة مخصصة مضبوطة.',
              guidance: 'يمكن أن تظهر للمتسوقين فقط المنتجات المنشورة من المجموعة المضبوطة.',
            },
            categoryAutoPublic: {
              label: 'تصنيفات عامة',
              summary: 'سكة تصنيفات تلقائية من التصنيفات العامة المنشورة.',
              guidance: 'تستخدم ترتيب التصنيفات العام الموجود والحد المضبوط.',
            },
            categoryManualSelection: {
              label: 'تصنيفات مختارة يدويا',
              summary: 'سكة تصنيفات يدوية من تصنيفات عامة مختارة.',
              guidance: 'تظهر فقط التصنيفات المختارة التي تبقى منشورة ومؤهلة.',
            },
            adsAutoActive: {
              label: 'إعلانات نشطة',
              summary: 'موضع إعلانات تلقائي من الإعلانات الترويجية النشطة.',
              guidance: 'يستخدم ترتيب الإعلانات الموجود والحد المضبوط.',
            },
            adsManualSelection: {
              label: 'إعلانات مختارة يدويا',
              summary: 'موضع إعلانات يدوي من إعلانات ترويجية مختارة.',
              guidance: 'تظهر فقط الإعلانات المختارة التي تبقى نشطة ومؤهلة.',
            },
            offersAutoLiveCampaigns: {
              label: 'حملات مباشرة',
              summary: 'سكة عروض تلقائية من حملات العروض المباشرة.',
              guidance: 'تستخدم محلل الحملات الموجود والحد المضبوط.',
            },
            invalidSource: {
              label: 'مصدر غير صالح',
              summary: 'هذا القسم التجاري لديه إعداد مصدر لا يستطيع الباني قراءته.',
              guidance: 'أعد تطبيق إعدادات المصدر قبل المعاينة أو النشر.',
            },
          },
        },
        states: {
          clean: 'لا توجد تغييرات غير محفوظة',
          dirty: 'لديك تغييرات غير محفوظة',
          saving: 'جارٍ حفظ التغييرات',
          saved: 'تم حفظ المسودة',
          failed: 'تعذر حفظ التغييرات',
          stale: 'تغيّرت الواجهة من مكان آخر. حدّث الصفحة أو أعد الضبط قبل النشر.',
          validationBlocked: 'أصلح مشاكل الأقسام قبل النشر',
        },
        actions: {
          moveUp: 'تحريك للأعلى',
          moveDown: 'تحريك للأسفل',
          moveUpSection: 'تحريك {{section}} للأعلى',
          moveDownSection: 'تحريك {{section}} للأسفل',
          enableSection: 'إظهار القسم',
          hideSection: 'إخفاء القسم',
          enableNamedSection: 'إظهار {{section}}',
          hideNamedSection: 'إخفاء {{section}}',
          reset: 'إعادة الضبط',
          refresh: 'تحديث',
          openPreview: 'فتح المعاينة',
          openSectionSettings: 'فتح إعدادات {{section}}',
        },
        reorder: {
          position: 'الموقع {{position}} من {{count}}',
          movedUp: 'تم تحريك {{section}} للأعلى.',
          movedDown: 'تم تحريك {{section}} للأسفل.',
          movedBefore: 'تم نقل {{section}} قبل {{target}}.',
          movedAfter: 'تم نقل {{section}} بعد {{target}}.',
          blockedBoundary: 'هذا القسم موجود عند حد موضعه.',
          blockedCrossPlacement: 'يمكن ترتيب الأقسام داخل موضعها الحالي فقط.',
          blockedProtected: 'لا يمكن إعادة ترتيب هذا القسم المحمي.',
          blockedDisabled: 'لا يمكن إعادة ترتيب هذا القسم المعطل.',
          blockedDeleted: 'استعد هذا القسم المحذوف من المسودة قبل إعادة ترتيبه.',
          blockedInvalid: 'تغيير ترتيب هذا القسم غير صالح.',
          blockedBusy: 'انتظر انتهاء الإجراء الحالي في الباني قبل إعادة الترتيب.',
          blockedStale: 'حدّث الواجهة القديمة أو أعد ضبطها قبل إعادة الترتيب.',
          blockedWorkspace: 'طبّق أو ألغ تغييرات مساحة العمل قبل ترتيب الأقسام.',
          blockedLifecycle: 'طبّق أو ألغ تغيير دورة الحياة المرحلي قبل إعادة الترتيب.',
          invalidRowLabel: 'قسم غير صالح',
          invalidRowDescription: 'هذا الصف مقفل لأن عقد القسم تعذر التحقق منه.',
          aria: {
            moveUp: 'تحريك {{section}} للأعلى',
            moveDown: 'تحريك {{section}} للأسفل',
            locked: 'إعادة ترتيب القسم مقفلة',
          },
        },
        liveCanvas: {
          title: 'لوحة العرض الحية',
          description: 'تعرض واجهة المتجر من إعدادات البناء المطبقة.',
          iframeTitle: 'لوحة عرض باني واجهة المتجر',
          status: {
            idle: 'اللوحة ساكنة',
            loadingFrame: 'جار تحميل الإطار',
            waitingReady: 'بانتظار اللوحة',
            initializing: 'جار تهيئة اللوحة',
            loading: 'جار تحميل اللوحة',
            ready: 'اللوحة جاهزة',
            syncing: 'جار مزامنة التغييرات',
            synced: 'تمت مزامنة التغييرات',
            timeout: 'لم تستجب اللوحة',
            timeoutWithRetry: 'لم تستجب اللوحة. أعد محاولة اللوحة.',
            invalidPayload: 'رفضت اللوحة هذا الإعداد',
            renderFailed: 'تعذر عرض اللوحة',
            lostFrame: 'أعيد تحميل اللوحة',
            permissionDenied: 'لوحة العرض الحية غير متاحة',
          },
          actions: {
            retry: 'أعد محاولة اللوحة',
            reloadFrame: 'أعد تحميل الإطار',
            openPreview: 'فتح المعاينة',
          },
          controls: {
            toolbarLabel: 'أدوات معاينة اللوحة',
            previewModesLabel: 'مقاسات المعاينة',
            device: {
              desktop: 'سطح المكتب',
              tablet: 'جهاز لوحي',
              mobile: 'هاتف',
            },
            deviceAction: {
              desktop: 'التبديل إلى معاينة سطح المكتب',
              tablet: 'التبديل إلى معاينة الجهاز اللوحي',
              mobile: 'التبديل إلى معاينة الهاتف',
            },
            zoomControlsLabel: 'أدوات التكبير',
            zoomIn: 'تكبير',
            zoomOut: 'تصغير',
            zoomReset: 'إعادة ضبط التكبير',
            zoomFit: 'ملاءمة',
            zoomFitLabel: 'ملاءمة اللوحة للعرض المتاح',
            zoomValue: '{{value}}٪',
            zoomLabel: 'تكبير {{value}}٪',
            currentState: '{{device}} · عرض {{width}} بكسل · تكبير {{zoom}}٪',
          },
          selection: {
            selected: 'القسم المحدد: {{section}}',
            none: 'لا يوجد قسم محدد',
            clickToEdit: 'اختر قسما من اللوحة لتعديل إعداداته هنا.',
            unavailable: 'لا يمكن اختيار هذا القسم من اللوحة.',
            invalid: 'تم تجاهل اختيار غير صالح من اللوحة.',
            applied: 'تم تطبيق التغييرات على اللوحة الحية.',
            unappliedPending: 'طبّق أو ألغ تغييرات مساحة العمل قبل اختيار قسم آخر.',
            chromeLabel: 'محدد في اللوحة',
            editUnavailable: 'لا يمكن تعديل هذا القسم من لوحة العرض.',
          },
          errors: {
            invalidOrigin: 'مصدر اللوحة غير موثوق.',
            invalidNonce: 'تعذر التحقق من جلسة اللوحة.',
            invalidMessage: 'رسالة اللوحة غير صالحة.',
            invalidConfig: 'إعداد اللوحة غير صالح.',
            invalidSection: 'لا يمكن تحديد هذا القسم في اللوحة.',
          },
        },
        inlineText: {
          title: 'محرر النص داخل اللوحة',
          localeTabs: 'لغات النص',
          characterCount: '{{count}} / {{max}}',
          locales: {
            ar: 'العربية',
            he: 'العبرية',
            en: 'الإنجليزية',
          },
          actions: {
            apply: 'تطبيق',
            cancel: 'إلغاء',
          },
          fields: {
            heroHeadline: 'عنوان قسم البطل',
            heroEyebrow: 'النص العلوي لقسم البطل',
            heroDescription: 'وصف قسم البطل',
            heroPrimaryActionLabel: 'زر البطل الأساسي',
            contentBenefitsHeading: 'عنوان المزايا',
            contentBenefitsBody: 'نص المزايا',
            contentBenefitTitle: 'عنوان الميزة',
            contentBenefitBody: 'نص الميزة',
            contentFaqHeading: 'عنوان الأسئلة الشائعة',
            contentFaqBody: 'مقدمة الأسئلة الشائعة',
            contentFaqQuestion: 'سؤال شائع',
            contentFaqAnswer: 'إجابة شائعة',
            contentAboutHeading: 'عنوان عن المتجر',
            contentAboutParagraph: 'فقرة عن المتجر',
            contentTestimonialsHeading: 'عنوان الاقتباسات',
            contentTestimonialsBody: 'مقدمة الاقتباسات',
            contentTestimonialQuote: 'نص الاقتباس',
            contentTestimonialName: 'اسم الاقتباس',
            contentTestimonialContext: 'سياق الاقتباس',
            contentNewsletterHeading: 'عنوان دعوة المتابعة',
            contentNewsletterBody: 'نص دعوة المتابعة',
            contentNewsletterButtonLabel: 'زر دعوة المتابعة',
            contentEditorialBannerHeading: 'عنوان اللافتة',
            contentEditorialBannerBody: 'نص اللافتة',
            contentEditorialBannerButtonLabel: 'زر اللافتة',
          },
          errors: {
            unknownField: 'لا يمكن تعديل حقل النص هذا.',
            wrongSectionType: 'حقل النص هذا لا يتبع القسم المحدد.',
            staleSection: 'حدّث الباني قبل تعديل هذا النص.',
            nonEditableField: 'لا يمكن تعديل هذا النص من اللوحة.',
            missingRequiredLocale: 'أكمل العربية والعبرية والإنجليزية قبل التطبيق.',
            unsafeText:
              'استخدم نصا عاديا فقط. يتم حظر HTML والسكربت وروابط ماركداون والروابط الخام.',
            oversizedText: 'هذا النص أطول من الحد المسموح.',
            invalidValue: 'قيمة النص غير صالحة.',
            invalidConfig: 'تغيير النص لا يجتاز تحقق القسم.',
          },
        },
        inlineMedia: {
          title: 'اختيار الوسائط داخل اللوحة',
          actions: {
            apply: 'تطبيق',
            cancel: 'إلغاء',
          },
          fields: {
            heroDesktop: 'صورة شريحة البطل لسطح المكتب',
            heroMobile: 'صورة شريحة البطل للهاتف',
            trustBadgeImage: 'صورة شارة الثقة',
            editorialBannerDesktop: 'صورة اللافتة لسطح المكتب',
            editorialBannerMobile: 'صورة اللافتة للجوال',
          },
          errors: {
            unknownField: 'لا يمكن تعديل حقل الوسائط هذا.',
            wrongSectionType: 'حقل الوسائط هذا لا يتبع القسم المحدد.',
            staleSection: 'حدّث الباني قبل استبدال هذه الوسائط.',
            nonEditableField: 'لا يمكن تعديل هذه الوسائط من اللوحة.',
            invalidReference: 'اختيار الوسائط هذا غير متاح لواجهة المتجر.',
            invalidConfig: 'تغيير الوسائط لا يجتاز تحقق القسم.',
          },
        },
        inlineRichContent: {
          targetOpened: 'تم فتح حقل المحتوى المنسق: {{field}}',
          fields: {
            contentBenefitsBody: 'نص المزايا',
            contentBenefitBody: 'نص الميزة',
            contentFaqBody: 'مقدمة الأسئلة الشائعة',
            contentFaqAnswer: 'إجابة شائعة',
            contentAboutParagraph: 'فقرة عن المتجر',
            contentTestimonialsBody: 'مقدمة الاقتباسات',
            contentTestimonialQuote: 'نص الاقتباس',
            contentNewsletterBody: 'نص دعوة المتابعة',
          },
          errors: {
            unknownField: 'لا يمكن تعديل حقل المحتوى المنسق هذا.',
            wrongSectionType: 'حقل المحتوى المنسق هذا لا يتبع القسم المحدد.',
            staleSection: 'حدّث الباني قبل تعديل هذا المحتوى المنسق.',
            nonEditableField: 'لا يمكن تعديل هذا المحتوى المنسق من اللوحة.',
            invalidConfig: 'نقطة دخول المحتوى المنسق لا تجتاز تحقق القسم.',
          },
        },
        inlineQuick: {
          title: 'عرض سريع',
          description: 'عناصر تحكم العرض السريع لقسم {{section}}.',
          actions: {
            open: 'فتح عناصر تحكم العرض السريع لقسم {{section}}',
            close: 'إغلاق عناصر تحكم العرض السريع',
          },
          errors: {
            unavailable: 'عناصر تحكم العرض السريع غير متاحة لهذا القسم.',
          },
        },
        visibility: {
          enabled: 'ظاهر للمتسوقين',
          hidden: 'مخفي عن المتسوقين',
          disabled: 'معطّل',
        },
        placement: {
          globalHeader: 'رأس الصفحة',
          homeMain: 'محتوى الصفحة',
          globalFooter: 'تذييل الصفحة',
          mobileNav: 'تنقل الهاتف',
          globalAnnouncementBar: 'فوق رأس الصفحة',
        },
        empty: 'لا توجد أقسام قابلة للتحرير لهذه الصفحة.',
        blocked: {
          invalidMove: 'لا يمكن نقل هذا القسم إلى موضع آخر.',
          disabledSection: 'هذا القسم معطّل ولا يمكن تغييره من هنا.',
          unsupportedSection: 'هذا القسم غير مدعوم ولا يمكن نشره.',
          unsupportedEngineVersion: 'لا يمكن تعديل إصدار واجهة المتجر هذا من هنا.',
          unsupportedSectionType: 'نوع هذا القسم غير مدعوم.',
          invalidPlacement: 'لا يمكن وضع هذا القسم هنا.',
          invalidConfig: 'تغيير دورة حياة هذا القسم غير صالح للصفحة الحالية.',
          protectedSection: 'لا يمكن تغيير هذا القسم المحمي من هنا.',
          duplicateProtectedSection: 'هذا القسم المحمي موجود بالفعل.',
          notDraftDeleted: 'يمكن استعادة الأقسام المحذوفة من المسودة فقط.',
        },
        validation: {
          issueCount: '{{count}} مشكلة في الأقسام',
        },
        history: {
          actions: {
            undo: '',
            redo: '',
          },
          tooltips: {
            undoCommand: '',
            redoCommand: '',
          },
          disabled: {
            noUndo: '',
            noRedo: '',
            busy: '',
            stale: '',
            workspaceDirty: '',
            pendingLifecycle: '',
            unavailable: '',
            invalidConfig: '',
            invalidHistory: '',
          },
          commands: {
            reorderSection: '',
            canvasReorderSection: '',
            applyLifecycle: '',
            applySettings: '',
            applyDesignDefault: '',
            applyInlineText: '',
            applyInlineMedia: '',
            applyTheme: '',
            resetTheme: '',
            applySeo: '',
            resetSeo: '',
            applyChrome: '',
            resetChrome: '',
          },
          messages: {
            undone: '',
            redone: '',
            blocked: '',
            noChange: '',
          },
        },
        shell: {
          regions: {
            toolbar: 'شريط الأدوات',
            sections: 'الأقسام',
            canvas: 'منطقة المعاينة',
            workspace: 'مساحة العمل',
            status: 'الحالة',
          },
          canvas: {
            title: 'المعاينة الحية ستتوفر لاحقا',
            body: 'استخدم المعاينة لرؤية الواجهة الحقيقية. ستستضيف هذه المنطقة التحرير الحي في إصدار لاحق.',
            selectedSection: 'القسم المحدد: {{section}}',
            noSelection: 'اختر قسما لعرض مساحة تحريره.',
          },
          workspace: {
            emptyTitle: 'لا يوجد قسم محدد',
            emptyBody: 'اختر قسما من اللوحة لعرض الإعدادات.',
            readOnlyTitle: 'قسم للعرض فقط',
            readOnlyBody: 'يمكن مراجعة هذا القسم هنا، لكن لا يمكن تعديله في هذا الإصدار.',
            editableTitle: 'إعدادات قابلة للتعديل',
            footerUnsaved: 'توجد تغييرات غير مطبقة في مساحة العمل',
            applyBeforeSwitch: 'طبّق التغييرات أو ألغها قبل اختيار قسم آخر.',
            sectionSelectedFromCanvas: 'تم اختيار {{section}} من اللوحة الحية.',
            applyBeforeCanvasUpdate:
              'توجد تغييرات غير مطبقة. لن تظهر التغييرات في اللوحة حتى تضغط تطبيق.',
            metadata: 'بيانات القسم',
            metadataLabels: {
              placement: 'الموضع',
              status: 'الحالة',
              visibility: 'ظهور الأجهزة',
              dataSource: 'مصدر البيانات',
              viewAllTarget: 'وجهة عرض الكل',
              lifecycle: 'مرحلة القسم',
            },
            metadataValues: {
              none: 'غير محدد',
              dataSourceWithLimit: '{{source}} · {{count}}',
              dataSourceWithSection: '{{source}} · {{section}}',
              dataSources: {
                none: 'بدون مصدر',
                storeIdentity: 'هوية المتجر',
                homeMerchandising: 'منتجات الصفحة الرئيسية',
                publicCategories: 'تصنيفات عامة',
                merchandisingSection: 'قسم منتجات',
                promotionalAds: 'إعلانات المتجر',
                liveOfferCampaigns: 'عروض مباشرة',
                storeReviewSummary: 'ملخص تقييمات المتجر',
              },
              viewAll: {
                collection: 'صفحة المجموعة',
                sales: 'صفحة التخفيضات',
              },
              lifecycle: {
                active: 'نشط',
                draftAdded: 'أضيف في المسودة',
                draftDeleted: 'محذوف في المسودة',
                restored: 'مستعاد',
              },
            },
            revisions: 'النسخ',
          },
          deferred: {
            addSection: 'إضافة قسم ستتوفر لاحقا',
            liveCanvas: 'التحرير الحي على اللوحة سيتوفر لاحقا',
            dragDrop: 'السحب والإفلات سيتوفر لاحقا',
            inlineEditing: 'التحرير داخل المعاينة سيتوفر لاحقا',
            undoRedo: '',
            zoom: 'التحكم بالتكبير سيتوفر لاحقا',
          },
          device: {
            desktop: 'سطح المكتب',
            tablet: 'الجهاز اللوحي',
            mobile: 'الهاتف',
          },
          zoom: {
            fit: 'ملاءمة',
            value: '{{value}}٪',
          },
          status: {
            selectedSection: 'تحرير {{section}}',
            noSelection: 'لا يوجد قسم محدد',
            validationOk: 'لا توجد مشكلات مانعة',
            loading: 'جار تحميل المحرر',
            failedLoad: 'تعذر تحميل المحرر',
            empty: 'لا توجد أقسام قابلة للتعديل',
            dirty: 'توجد تغييرات غير محفوظة',
            workspaceDirty: 'طبّق تغييرات مساحة العمل أو ألغها',
            saving: 'جار حفظ المسودة',
            saved: 'تم حفظ المسودة',
            saveFailed: 'فشل حفظ المسودة',
            validationBlocked: 'أصلح المشكلات قبل المتابعة',
            staleConflict: 'تغيرت الواجهة في مكان آخر',
            previewing: 'جار إنشاء المعاينة',
            previewFailed: 'فشل إنشاء المعاينة',
            publishing: 'جار النشر',
            validatingPublish: 'جار فحص جاهزية النشر',
            savingPublishDraft: 'جار حفظ المسودة قبل النشر',
            publishBlockedReadiness: 'النشر متوقف بسبب الجاهزية',
            publishBlockedStale: 'يلزم التحديث قبل النشر',
            rollingBack: 'جار الرجوع إلى نسخة سابقة',
            rollbackFailed: 'فشل الرجوع إلى النسخة السابقة',
            restoringDraft: 'جار استعادة المسودة',
            restoreDraftFailed: 'فشل استعادة المسودة',
            publishSuccess: 'تم النشر',
            publishFailed: 'فشل النشر',
            permissionDenied: 'لا توجد صلاحية',
          },
          actions: {
            applyWorkspace: 'تطبيق',
            cancelWorkspace: 'إلغاء',
            discardWorkspace: 'تجاهل تغييرات مساحة العمل',
            retryOperation: 'إعادة المحاولة',
            selectSection: 'اختيار {{section}}',
            disabledControl: '{{control}} غير متاح في هذا الإصدار',
          },
        },
      },
      fieldGroups: {
        content: 'المحتوى',
        dataSource: 'مصدر البيانات',
        layout: 'التخطيط',
        appearance: 'المظهر',
        visibility: 'الظهور',
      },
      settings: {
        title: 'إعدادات القسم',
        description: 'عدّل إعدادات {{section}}.',
        actions: {
          apply: 'تطبيق',
          cancel: 'إلغاء',
        },
        fields: {
          status: 'حالة القسم',
          deviceVisibility: 'الظهور حسب الجهاز',
          categoryLimit: 'عدد الأقسام الظاهرة',
          categoryOrderMode: 'ترتيب التصنيفات',
          categoryLayoutMode: 'تخطيط التصنيفات',
          categoryImageShape: 'شكل صورة التصنيف',
          categoryDensity: 'تباعد التصنيفات',
          adsLimit: 'عدد الإعلانات الظاهرة',
          adsOrderMode: 'ترتيب الإعلانات',
          adsLayoutPreset: 'تخطيط الإعلانات',
          adsOrientation: 'اتجاه الإعلان',
          adsImageFit: 'ملاءمة صورة الإعلان',
          adsDensity: 'تباعد الإعلانات',
          adsShowTitle: 'إظهار عنوان الإعلان',
          adsShowDestinationCue: 'إظهار تلميح الوجهة',
          categoryHeading: 'عنوان القسم',
          categoryShowProductCount: 'إظهار عدد المنتجات',
          categoryShowDescription: 'إظهار الأوصاف',
          liveOfferLimit: 'عدد العروض الظاهرة',
          productSourceMode: 'مصدر المنتجات',
          productPicker: 'المنتجات',
          productLimit: 'عدد المنتجات الظاهرة',
          productLayoutMode: 'تخطيط المنتجات',
          productImageShape: 'شكل صورة المنتج',
          productDensity: 'تباعد المنتجات',
          productImageFit: 'ملاءمة صورة المنتج',
          productShowPrice: 'إظهار الأسعار',
          productShowSaleBadge: 'إظهار شارات التخفيض',
          productShowAvailabilityBadge: 'إظهار شارات التوفر',
          categoryPicker: 'التصنيفات',
          promotionalAdPicker: 'إعلانات المتجر',
          trustBadgeImage: 'صورة شارة الثقة',
          heroSlides: 'شرائح البطل',
          contentSection: 'قسم المحتوى',
          collectionPicker: 'المجموعة',
          newsletterCollection: 'جمع متابعي النشرة',
          mediaPickerUnsupported: 'منتقي الصور غير متاح لهذا القسم.',
        },
        pickers: {
          searchPlaceholder: 'ابحث في المحتوى العام',
          mediaSearchPlaceholder: 'ابحث في الصور العامة',
          loading: 'جارٍ تحميل الخيارات...',
          loadingMedia: 'جارٍ تحميل الصور...',
          retry: 'إعادة المحاولة',
          emptyProducts: 'لا توجد منتجات منشورة تطابق البحث.',
          emptySelectedProducts: 'اختر منتجا واحدا على الأقل قبل تطبيق هذا الرف اليدوي.',
          customCollectionSearchPlaceholder: 'ابحث في المجموعات المخصصة',
          createCustomCollection: 'إنشاء مجموعة',
          loadingCustomCollections: 'جارٍ تحميل المجموعات المخصصة...',
          customCollectionsUnavailable: 'تعذر تحميل المجموعات المخصصة. حاول مرة أخرى.',
          emptyCustomCollections: 'لا توجد مجموعات مخصصة بعد.',
          emptyCustomCollectionProducts: 'أضف منتجا منشورا واحدا على الأقل لهذه المجموعة.',
          customCollectionProductCount: '{{count}} منتجات',
          editCustomCollection: 'تعديل المجموعة',
          customCollectionNameAr: 'اسم المجموعة بالعربية',
          customCollectionNameHe: 'اسم المجموعة بالعبرية',
          customCollectionNameEn: 'اسم المجموعة بالإنجليزية',
          customCollectionDescriptionAr: 'وصف المجموعة بالعربية',
          customCollectionDescriptionHe: 'وصف المجموعة بالعبرية',
          customCollectionDescriptionEn: 'وصف المجموعة بالإنجليزية',
          customCollectionSaveFailed: 'تعذر حفظ المجموعة.',
          saveCustomCollection: 'حفظ المجموعة',
          emptyCategories: 'لا توجد تصنيفات عامة تطابق البحث.',
          emptyCollections: 'لا توجد مجموعات متاحة.',
          emptyMedia: 'لا توجد صور عامة تطابق البحث.',
          emptyPromotionalAds: 'لا توجد إعلانات نشطة مؤهلة تطابق البحث.',
          emptyMediaSelection: 'لم يتم اختيار صورة بعد.',
          selectedMedia: 'صورة مختارة',
          safeMediaReference: 'مرجع صورة آمن',
          mediaError: 'تعذر تحميل الصور العامة.',
          mediaDefaultLabel: 'صورة بدون اسم',
          uploadMedia: 'رفع صورة',
          replaceMedia: 'استبدال الصورة',
          removeMedia: 'إزالة الصورة',
          refreshMedia: 'تحديث الصور',
          mediaUploadHint: 'JPEG أو PNG أو WebP. حتى 5MB و4096 بكسل.',
          mediaUploading: 'جارٍ رفع الصورة...',
          mediaRemoving: 'جارٍ إزالة الصورة...',
          mediaUnavailable: 'الصورة غير متاحة',
          mediaUnavailableDescription: 'اختر صورة أخرى قبل تطبيق هذا القسم.',
          mediaInUse:
            'هذه الصورة مستخدمة في واجهة المتجر المحفوظة. امسحها أو استبدلها ثم احفظ قبل الإزالة.',
          mediaRemoveConfirm: 'إزالة هذه الصورة من مكتبة الصور؟',
          mediaRemoveConfirmDescription: 'هذا لا يمسح الأقسام المحفوظة التي تستخدمها.',
          mediaSelect: 'اختيار الصورة',
          mediaSelected: 'مختارة',
          mediaUploadFailed: 'تعذر رفع الصورة.',
          mediaRemoveFailed: 'تعذر إزالة الصورة.',
          mediaInvalidType: 'استخدم JPEG أو PNG أو WebP فقط.',
          mediaTooLarge: 'الصورة أكبر من 5MB.',
          mediaDimensionsInvalid: 'يجب أن تكون أبعاد الصورة بين 1 و4096 بكسل.',
          mediaRequired: 'اختر صورة للرفع.',
          selectedCount: '{{count}} من {{max}} مختارة',
          unavailableSelectedProduct: 'منتج غير متاح',
          promotionalAdsSearchPlaceholder: 'ابحث في الإعلانات النشطة',
          selectedPromotionalAdsCount: '{{count}} من {{max}} إعلانات مختارة',
          emptySelectedPromotionalAds: 'لم يتم اختيار إعلانات بعد.',
          loadingPromotionalAds: 'جارٍ تحميل الإعلانات النشطة...',
          promotionalAdsUnavailable: 'تعذر تحميل الإعلانات النشطة. حاول مرة أخرى.',
          removeSelection: 'إزالة الاختيار',
          clearSelection: 'مسح الاختيار',
          moveSelectionUp: 'تحريك الاختيار للأعلى',
          moveSelectionDown: 'تحريك الاختيار للأسفل',
          categoryFilterAll: 'كل التصنيفات',
          categoryFilterButton: 'تصفية حسب التصنيف',
          categoryProductCount: '{{count}} منتجات',
          availability: {
            inStock: 'متوفر',
            outOfStock: 'نفدت الكمية',
          },
          source: {
            collection: 'مجموعة',
            manualProducts: 'منتجات مختارة',
            customCollection: 'مجموعة مخصصة',
            autoCategories: 'تصنيفات تلقائية',
            manualCategories: 'تصنيفات مختارة',
            autoPromotionalAds: 'إعلانات نشطة تلقائية',
            autoPromotionalAdsHelp:
              'يستخدم الإعلانات النشطة من العروض حسب ترتيب العرض التجاري. إنشاء الإعلانات والصور والوجهات والتفعيل والترتيب تبقى كلها في إدارة العروض.',
            manualPromotionalAds: 'إعلانات مختارة',
          },
        },
        boundaries: {
          adsPresentationOnlyTitle: 'إعلانات المتجر تبقى في إدارة العروض',
          adsPresentationOnly:
            'يتحكم الباني بطريقة عرض هذا القسم للإعلانات. أنشئ الإعلانات وحدد الوجهات وارفع صور الإعلان وفعل الإعلانات وغير ترتيبها التجاري من إدارة العروض.',
          manageAdsLink: 'إدارة الإعلانات',
        },
        visibility: {
          all: 'كل الأجهزة',
          desktop: 'الحاسوب فقط',
          tablet: 'الجهاز اللوحي فقط',
          mobile: 'الهاتف فقط',
          none: 'لا يوجد جهاز محدد',
          devices: {
            desktop: 'الحاسوب',
            tablet: 'الجهاز اللوحي',
            mobile: 'الهاتف',
          },
          deviceActions: {
            desktop: 'إظهار على الحاسوب',
            tablet: 'إظهار على الجهاز اللوحي',
            mobile: 'إظهار على الهاتف',
          },
        },
        help: {
          deviceVisibility: 'اختر أحجام الشاشات التي يظهر فيها هذا القسم.',
          trustBadgeImage: 'اختر صورة عامة معتمدة لهذا القسم.',
          categoryLimit: 'اختر عدد الأقسام التي تظهر في هذا الشريط.',
          categoryOrderMode:
            'التصنيفات التلقائية تتبع ترتيب إدارة التصنيفات، والتصنيفات المختارة تتبع ترتيب هذه القائمة.',
          categoryLayoutMode: 'اختر عرض التصنيفات كشريط تمرير أو كشبكة متجاوبة.',
          categoryImageShape: 'اختر إطار الصورة المستخدم في بطاقات التصنيفات.',
          categoryDensity: 'اختر مقدار التباعد داخل شريط التصنيفات.',
          adsLimit: 'اختر عدد إعلانات المتجر التي تظهر في هذا القسم.',
          adsOrderMode:
            'الإعلانات التلقائية تتبع ترتيب مدير العروض، والإعلانات المختارة تتبع قائمة هذا القسم.',
          adsLayoutPreset: 'اختر طريقة ترتيب إعلانات المتجر.',
          adsOrientation:
            'الإعلان الأفقي يمتد بعرض واجهة المتجر، والإعلان العمودي يظهر داخل إطار طولي في الوسط.',
          adsImageFit: 'اختر طريقة ملاءمة صور الإعلانات داخل الإطار.',
          adsDensity: 'اختر مقدار التباعد داخل قسم إعلانات المتجر.',
          adsShowTitle: 'أظهر أو أخف عنوان الإعلان العام.',
          adsShowDestinationCue: 'أظهر أو أخف تلميح وجهة عام.',
          categoryHeading:
            'اختياري. يظهر فوق الفئات بدل العنوان الافتراضي. اتركوا الحقول الثلاثة فارغة للعودة إلى العنوان الافتراضي.',
          categoryShowProductCount: 'أظهر أو أخف عدد المنتجات العامة لكل تصنيف.',
          categoryShowDescription:
            'أظهر الأوصاف العامة الآمنة التي أضفتها للتصنيفات في إدارة التصنيفات.',
          liveOfferLimit: 'اختر عدد العروض المباشرة التي تظهر في هذا الشريط.',
          productLimit: 'اختر عدد المنتجات التي تظهر في هذا الشريط.',
          productLayoutMode: 'اختر عرض المنتجات كشريط تمرير أو كشبكة متجاوبة.',
          productImageShape: 'اختر إطار الصورة المستخدم في بطاقات المنتجات.',
          productDensity: 'اختر مقدار التباعد داخل شريط المنتجات.',
          productImageFit: 'اختر طريقة ملاءمة صور المنتجات داخل الإطار.',
          productShowPrice: 'أظهر أو أخف سعر المنتج العام.',
          productShowSaleBadge: 'أظهر أو أخف شارات التخفيض العامة عندما يكون المنتج مخفضًا.',
          productShowAvailabilityBadge: 'أظهر أو أخف شارات توفر المخزون العامة.',
          heroSlides: 'أضف حتى ثلاث شرائح مترجمة مع وجهات آمنة وصور عامة معتمدة.',
          contentSection:
            'اكتب محتوى مترجما من التاجر فقط باستخدام اختيارات معتمدة. يتم رفض HTML والروابط المخصصة والسكربتات والأنماط وبيانات الزبائن.',
        },
        hero: {
          emptyTitle: 'يظهر بديل هوية المتجر',
          emptyBody:
            'أضف شريحة عندما تريد استبدال بطل المتجر الافتراضي. حتى ذلك الوقت سيرى المتسوقون اسم المتجر ووصفه.',
          addSlide: 'إضافة شريحة',
          removeSlide: 'إزالة الشريحة',
          slideLabel: 'الشريحة {{index}}',
          enabled: 'ظاهرة',
          headline: 'العنوان الرئيسي',
          eyebrow: 'النص العلوي',
          description: 'الوصف',
          primaryAction: 'الزر الأساسي',
          secondaryAction: 'الزر الثانوي',
          addSecondaryAction: 'إضافة زر ثانوي',
          removeSecondaryAction: 'إزالة الزر الثانوي',
          buttonLabel: 'نص الزر',
          desktopMedia: 'صورة الحاسوب',
          mobileMedia: 'صورة الهاتف',
          destination: 'الوجهة',
          categoryId: 'معرّف التصنيف',
          overlay: 'التغطية',
          contentPosition: 'موضع المحتوى',
          textAlignment: 'محاذاة النص',
          layoutPreset: 'نمط التخطيط',
          scheduleTitle: 'نافذة الجدولة',
          scheduleHelp:
            'نافذة اختيارية بتوقيت إسرائيل. يتم حفظها كوقت UTC وتظهر للمتسوقين فقط عندما تكون نشطة.',
          startsAt: 'تبدأ في',
          endsAt: 'تنتهي قبل',
          clearSchedule: 'مسح الجدولة',
          scheduleInvalidRange: 'يجب أن يكون وقت الانتهاء بعد وقت البدء.',
          scheduleStates: {
            always: 'نشطة دائما',
            active: 'نشطة الآن',
            upcoming: 'مجدولة لوقت لاحق',
            expired: 'انتهت',
          },
          locales: {
            ar: 'العربية',
            he: 'العبرية',
            en: 'الإنجليزية',
          },
          targets: {
            storeHome: 'صفحة المتجر',
            storeCategories: 'التصنيفات',
            storeSales: 'التخفيضات',
            bestSellers: 'الأكثر مبيعا',
            trendingNow: 'الرائج الآن',
            newArrivals: 'وصل حديثا',
            storeCategory: 'تصنيف محدد',
            cart: 'السلة',
            customerAccount: 'حساب الزبون',
            customerOrders: 'طلبات الزبون',
            whatsapp: 'واتساب',
            phone: 'الهاتف',
          },
          overlays: {
            none: 'بدون',
            soft: 'خفيفة',
            medium: 'متوسطة',
            strong: 'قوية',
          },
          positions: {
            start: 'البداية',
            center: 'الوسط',
            end: 'النهاية',
          },
          alignments: {
            start: 'البداية',
            center: 'الوسط',
            end: 'النهاية',
          },
          layoutPresets: {
            immersive: 'غامر',
            balanced: 'متوازن',
            compact: 'مضغوط',
          },
        },
        content: {
          emptyBody: 'هذا النص الاختياري فارغ للمتسوقين حتى تضيف نسخة مترجمة.',
          addItem: 'إضافة عنصر',
          removeItem: 'إزالة العنصر',
          moveItemUp: 'تحريك العنصر للأعلى',
          moveItemDown: 'تحريك العنصر للأسفل',
          itemLabel: 'العنصر {{index}}',
          heading: 'العنوان',
          body: 'النص',
          paragraph: 'فقرة',
          title: 'عنوان العنصر',
          question: 'السؤال',
          answer: 'الجواب',
          quote: 'الاقتباس',
          name: 'اسم العرض',
          context: 'السياق',
          buttonLabel: 'نص الزر',
          icon: 'الأيقونة',
          layout: 'التخطيط',
          tone: 'النبرة',
          cta: 'دعوة لاتخاذ إجراء',
          ctaEnabled: 'إظهار الزر',
          collectionEnabled: 'جمع المتابعين',
          collectionContactMethods: 'وسائل التواصل المقبولة',
          collectionEmail: 'البريد الإلكتروني',
          collectionPhone: 'هاتف إسرائيلي',
          collectionConsentVersion: 'نسخة الموافقة {{version}}',
          newsletterNote:
            'يبقى الجمع متوقفًا حتى تفعّله هنا ثم تحفظ وتنشر. يجب أن يوافق المتسوق قبل الإرسال.',
          testimonialNote:
            'استخدم نصًا يكتبه التاجر فقط. لا يتم ربط بيانات زبائن أو طلبات أو تقييمات أو هواتف أو بريد هنا.',
          unsafeNote:
            'التنسيق الآمن فقط. يتم رفض HTML وMarkdown والروابط الخام والسكربتات والأنماط وعلامات التحكم المخفية.',
          editorialBannerNote:
            'اختر صورة لسطح المكتب وصورة للجوال من مكتبة الوسائط العامة. يمكن ترك أي منهما فارغة.',
          media: 'الوسائط',
          mediaDesktop: 'صورة سطح المكتب',
          mediaMobile: 'صورة الجوال',
          richTextControls: 'التنسيق',
          richTextPlain: 'نص عادي',
          richTextBold: 'عريض',
          richTextItalic: 'مائل',
          richTextBulleted: 'قائمة نقطية',
          richTextNumbered: 'قائمة مرقمة',
          richTextApplyLink: 'تطبيق الرابط',
          richTextRemoveLink: 'إزالة الرابط',
          icons: {
            'badge-check': 'شارة تحقق',
            'heart-handshake': 'مصافحة بثقة',
            leaf: 'ورقة',
            'package-check': 'طرد مؤكد',
            'shield-check': 'درع تحقق',
            sparkles: 'لمعان',
            truck: 'شاحنة',
          },
          layouts: {
            cards: 'بطاقات',
            list: 'قائمة',
            accordion: 'أكورديون',
            story: 'قصة',
            quotes: 'اقتباسات',
            banner: 'شريط دعوة',
            split: 'صورة بجانب النص',
            overlay: 'نص فوق الصورة',
          },
          tones: {
            neutral: 'محايدة',
            warm: 'دافئة',
            accent: 'بارزة',
          },
        },
        categoryOrderMode: {
          categoryDisplayOrder: 'ترتيب إدارة التصنيفات',
          selectedListOrder: 'ترتيب القائمة المختارة',
        },
        categoryLayoutMode: {
          scrollRail: 'شريط تمرير',
          responsiveGrid: 'شبكة متجاوبة',
        },
        categoryImageShape: {
          circle: 'دائرة',
          roundedSquare: 'مربع ناعم',
        },
        categoryDensity: {
          comfortable: 'مريح',
          compact: 'مضغوط',
        },
        productLayoutMode: {
          scrollRail: 'شريط تمرير',
          responsiveGrid: 'شبكة متجاوبة',
        },
        productImageShape: {
          square: 'مربع',
          roundedSquare: 'مربع ناعم',
        },
        productDensity: {
          comfortable: 'مريح',
          compact: 'مضغوط',
        },
        productImageFit: {
          cover: 'تغطية',
          contain: 'احتواء',
        },
        adsOrderMode: {
          businessDisplayOrder: 'ترتيب مدير العروض',
          selectedListOrder: 'ترتيب القائمة المختارة',
        },
        adsLayoutPreset: {
          carousel: 'شريط تمرير',
          stackedCards: 'بطاقات متراكبة',
        },
        adsOrientation: {
          horizontal: 'أفقي',
          vertical: 'عمودي',
        },
        adsImageFit: {
          cover: 'تغطية',
          contain: 'احتواء',
        },
        adsDensity: {
          comfortable: 'مريح',
          compact: 'مضغوط',
        },
        readOnly: {
          dataSource: 'مصدر البيانات',
          placement: 'الموضع',
        },
        messages: {
          applied: 'تم تطبيق إعدادات القسم.',
          cancelled: 'تم إلغاء تغييرات الإعدادات.',
        },
        aria: {
          sectionSettingsSurface: 'مساحة إعدادات القسم',
          applySettingChanges: 'تطبيق تغييرات إعدادات القسم',
          cancelSettingChanges: 'إلغاء تغييرات إعدادات القسم',
        },
        errors: {
          sectionNotEditable: 'لا يمكن تعديل هذا القسم من هنا.',
          deletedSectionReadOnly: 'هذا القسم محذوف من المسودة. استعده قبل تعديل إعداداته.',
          duplicateInvalidReadOnly:
            'هذا القسم مكرر بشكل غير صالح. أصلح التكرار قبل تعديل إعداداته.',
          unsupportedField: 'لا يمكن تعديل هذا الحقل من هنا.',
          staleBuilder: 'تغيرت الواجهة من مكان آخر. حدّث الصفحة قبل تعديل الإعدادات.',
          busyBuilder: 'انتظر حتى تنتهي العملية الحالية قبل تعديل الإعدادات.',
          invalidPatchSafe: 'لم يتم تطبيق هذا التغيير. بقيت الإعدادات السابقة كما هي.',
          lastVisibleDevice:
            'أبقِ جهازا واحدا ظاهرا على الأقل. استخدم حالة القسم لإخفائه في كل الأجهزة.',
          invalidInteger: 'أدخل رقما صحيحا.',
          outOfRange: 'اختر رقما ضمن النطاق المسموح.',
          invalidReference: 'المرجع غير صالح: هذا الاختيار لم يعد متاحا.',
          customCollectionNameRequired: 'أدخل اسم المجموعة بالعربية على الأقل.',
          emptyCustomCollection: 'أضف منتجا منشورا واحدا على الأقل قبل اختيار هذه المجموعة.',
          emptyProductSelection: 'اختر منتجا واحدا على الأقل قبل تطبيق هذا الرف اليدوي.',
          invalidHeroConfig:
            'أكمل كل شريحة ظاهرة في قسم البطل بالعربية والعبرية والإنجليزية قبل التطبيق.',
          invalidContentConfig:
            'أكمل المحتوى المطلوب بالعربية والعبرية والإنجليزية وأزل النص غير الآمن قبل التطبيق.',
          crossStoreReference: 'هذا الاختيار غير متاح لهذا المتجر.',
          unpublishedReference: 'هذا الاختيار غير منشور.',
          deletedReference: 'تمت إزالة هذا الاختيار.',
          disabledReference: 'هذا الاختيار معطّل.',
          emptyCategoryReference: 'هذا التصنيف لا يحتوي على منتجات عامة.',
          emptyCollectionReference: 'هذه المجموعة لا تحتوي على منتجات عامة.',
          unsafeAdsDestination: 'وجهة هذا الإعلان غير متاحة.',
          missingAdsMedia: 'صورة هذا الإعلان غير متاحة.',
          duplicateReference: 'هذا الاختيار موجود مسبقا.',
          tooManyReferences: 'أزل اختيارا قبل إضافة اختيار آخر.',
          unsupportedContentKind: 'هذا النوع من المحتوى غير مدعوم هنا.',
          categoryHeadingLocales:
            'أدخلوا العنوان بالعربية والعبرية والإنجليزية (حتى 120 حرفًا لكل لغة)، أو اتركوا الثلاثة فارغة.',
        },
      },
      publicContent: {
        errors: {
          invalidReference: 'المرجع غير صالح: هذا الاختيار لم يعد متاحا.',
          crossStoreReference: 'هذا الاختيار غير متاح لهذا المتجر.',
          unpublishedReference: 'هذا الاختيار غير منشور.',
          deletedReference: 'تمت إزالة هذا الاختيار.',
          disabledReference: 'هذا الاختيار معطّل.',
          emptyCategoryReference: 'هذا التصنيف لا يحتوي على منتجات عامة.',
          emptyCollectionReference: 'هذه المجموعة لا تحتوي على منتجات عامة.',
          unsafeAdsDestination: 'وجهة هذا الإعلان غير متاحة.',
          missingAdsMedia: 'صورة هذا الإعلان غير متاحة.',
          duplicateReference: 'هذا الاختيار موجود مسبقا.',
          tooManyReferences: 'أزل اختيارا قبل إضافة اختيار آخر.',
          unsupportedContentKind: 'هذا النوع من المحتوى غير مدعوم هنا.',
        },
      },
      newsletterSubscribers: {
        title: 'جهات متابعة النشرة',
        description: 'آخر جهات التواصل التي وافقت وأُرسلت من نماذج دعوة النشرة المنشورة.',
        loading: 'جارٍ تحميل الجهات...',
        empty: 'لم يتم جمع أي جهة بعد.',
        loadError: 'تعذّر تحميل الجهات.',
        exportEmpty: 'لا توجد جهات للتصدير.',
        exportReady: 'ملف CSV جاهز.',
        suppressFailed: 'تعذّر كتم هذه الجهة.',
        columns: {
          contact: 'وسيلة التواصل',
          status: 'الحالة',
          locale: 'اللغة',
          source: 'قسم المصدر',
          created: 'تاريخ الإضافة',
        },
        actions: {
          refresh: 'تحديث الجهات',
          export: 'تصدير CSV',
          suppress: 'كتم الجهة',
        },
        contactTypes: {
          email: 'بريد إلكتروني',
          phone: 'هاتف',
        },
        statuses: {
          active: 'نشطة',
          suppressed: 'مكتومة',
        },
      },
      status: {
        draft: 'مسودة',
        published: 'منشور',
        archived: 'مؤرشف',
      },
      readiness: {
        title: 'جاهزية النشر',
        ready: 'جاهز للمعاينة والنشر',
        blocked: 'الجاهزية محظورة',
        checking: 'يتم فحص الجاهزية...',
        warningCount: '{{count}} تحذيرات',
        blockerCount: '{{count}} عوائق',
        publishBlocked: 'النشر محظور حتى إصلاح مشاكل الجاهزية.',
        previewBlocked: 'المعاينة محظورة حتى إصلاح مشاكل الجاهزية.',
        focusSection: 'الانتقال إلى القسم',
        focusPage: 'الانتقال إلى إعدادات الصفحة',
        pageIssue: 'مشكلة في الصفحة',
        severity: {
          blocker: 'عائق',
          warning: 'تحذير',
        },
        errors: {
          freshnessUnknown: 'تعذّر تأكيد الجاهزية. افحص مرة أخرى قبل المتابعة.',
          publishBlocked: 'فشل فحص جاهزية النشر. أصلح العوائق وحاول مرة أخرى.',
          previewBlocked: 'فشل فحص جاهزية المعاينة. أصلح العوائق وحاول مرة أخرى.',
        },
        issues: {
          invalidConfiguration: 'إعدادات واجهة المتجر غير صالحة.',
          invalidThemeSettings: 'إعدادات النمط تحتوي على اختيارات غير مدعومة.',
          invalidNavigationTarget: 'يوجد عنصر تنقل يشير إلى وجهة غير مدعومة.',
          unsafeNavigationUrl: 'رابط ملف التواصل الاجتماعي غير آمن.',
          missingNavigationContact: 'رابط التواصل يحتاج إلى قناة عامة في المتجر.',
          missingStoreLogo: 'حمّل شعار المتجر قبل نشر واجهة المتجر.',
          malformedConfig: 'تعذّرت قراءة إعدادات واجهة المتجر.',
          unsupportedEngineVersion: 'إصدار محرّك واجهة المتجر غير مدعوم.',
          unsupportedSchemaVersion: 'إصدار أحد الأقسام غير مدعوم.',
          unsupportedSection: 'يوجد قسم غير مدعوم.',
          invalidPlacement: 'يوجد قسم في موضع غير صالح.',
          duplicateSectionId: 'يوجد قسمان بنفس المعرّف.',
          duplicateSingleton: 'تم تكرار قسم لا يمكن أن يظهر إلا مرة واحدة.',
          disabledSection: 'قسم معطّل يمنع المعاينة والنشر.',
          hiddenSection: 'قسم مخفي لن يظهر للزبائن.',
          draftDeletedSection: 'قسم محذوف في المسودة سيزال عند النشر.',
          restoredSectionInvalid: 'قسم مستعاد يحتاج إلى محتوى عام صالح.',
          invalidLifecycle: 'حالة دورة حياة أحد الأقسام غير صالحة.',
          invalidOrder: 'ترتيب الأقسام غير صالح.',
          invalidProductReference: 'اختيار منتج لم يعد متاحا للعامة.',
          invalidCategoryReference: 'اختيار تصنيف لم يعد متاحا للعامة.',
          invalidMediaReference: 'اختيار وسائط لم يعد متاحا للعامة.',
          invalidAdsConfig: 'إعدادات إعلانات المتجر غير صالحة.',
          invalidAdsReference: 'اختيار إعلان لم يعد متاحا للعامة.',
          unsafeAdsDestination: 'وجهة إعلان غير متاحة.',
          missingAdsMedia: 'صورة إعلان غير متاحة.',
          invalidHeroConfig: 'إعدادات قسم البطل غير صالحة.',
          invalidHeroDestination: 'وجهة زر في قسم البطل لم تعد متاحة.',
          invalidHeroMediaReference: 'صورة في قسم البطل لم تعد متاحة للعامة.',
          tooManyReferences: 'أحد الأقسام يحتوي على اختيارات كثيرة.',
          unsafePublicConfig: 'يجب إزالة الحقول العامة غير الآمنة قبل المعاينة أو النشر.',
        },
      },
      actions: {
        saveDraft: 'حفظ المسودة',
        savingDraft: 'جارٍ حفظ المسودة...',
        publish: 'نشر',
        publishing: 'جارٍ النشر...',
        preview: 'معاينة',
        createPreviewLink: 'إنشاء رابط معاينة',
        publishDisabledReadiness: 'النشر معطّل لأن الجاهزية تحتوي على عوائق.',
        previewDisabledReadiness: 'المعاينة معطّلة لأن الجاهزية تحتوي على عوائق.',
        rollback: 'استرجاع',
        rollingBack: 'جارٍ الاسترجاع...',
        restoreToDraft: 'استعادة كمسودة',
      },
      messages: {
        draftSaved: 'تم حفظ المسودة.',
        published: 'تم نشر واجهة المتجر.',
        rollbackPublished: 'تم نشر النسخة المسترجعة.',
        draftRestored: 'تمت استعادة النسخة كمسودة. انشرها عندما تصبح جاهزة للمتسوقين.',
        previewLinkCreated: 'تم إنشاء رابط المعاينة.',
        defaultFallbackActive: 'يتم استخدام واجهة المتجر الافتراضية حتى يتم نشر إعدادات.',
        noDraft: 'لا توجد مسودة محفوظة بعد.',
        noRevisions: 'لا توجد نسخ بعد.',
      },
      preview: {
        banner: 'وضع المعاينة',
        expired: 'انتهت صلاحية رابط المعاينة.',
        notAvailable: 'المعاينة غير متاحة.',
        noindexLabel: 'مخفية عن محركات البحث',
      },
      revisions: {
        title: 'سجل النسخ',
        revisionNumber: 'النسخة {{number}}',
        publishedAt: 'نُشرت {{date}}',
        publishedBy: 'نشرها {{name}}',
        rolledBackFrom: 'تم الاسترجاع من النسخة {{number}}',
        restoredFrom: 'نُسخت من النسخة {{number}}',
        sectionCount: '{{count}} أقسام',
        actions: {
          draft_save: 'حفظ مسودة',
          publish: 'نشر',
          rollback: 'استرجاع',
          restore_to_draft: 'استعادة كمسودة',
        },
      },
      publishSummary: {
        title: '',
        description: '',
        pendingTitle: '',
        changedSurfacesTitle: '',
        changedSectionsTitle: '',
        changedSectionLine: '',
        noChangedSurfaces: '',
        noChangedSections: '',
        additionalChangedSections: '',
        publicExposureReminder: '',
        confirm: '',
        labels: {
          draft: '',
          localChanges: '',
          workspaceEdits: '',
          readiness: '',
        },
        values: {
          draftExists: '',
          noDraft: '',
          localChanges: '',
          noLocalChanges: '',
          workspaceEdits: '',
          noWorkspaceEdits: '',
        },
        surfaces: {
          seo: '',
          theme: '',
          navigation: '',
          hero: '',
          categories: '',
          ads: '',
          productRails: '',
          contentSections: '',
          sectionOrder: '',
          sectionLifecycle: '',
        },
        sectionTypes: {
          productRails: '',
        },
        changeKinds: {
          added: '',
          removed: '',
          changed: '',
          moved: '',
          statusChanged: '',
        },
      },
      publishOperation: {
        states: {
          idle: 'جاهز للنشر',
          validating: 'جار فحص الجاهزية',
          savingDraft: 'جار حفظ المسودة',
          publishing: 'جار النشر',
          published: 'تم النشر',
          failedRecoverable: 'فشل النشر',
          blockedReadiness: 'الجاهزية مانعة',
          blockedStale: 'يلزم التحديث',
          blockedPermissions: 'لا توجد صلاحية',
        },
        helpers: {
          idle: 'لن يظهر شيء للعامة حتى تؤكد.',
          validating: 'يتم فحص المسودة الحالية والمراجع العامة.',
          savingDraft: 'يتم حفظ التغييرات المحلية قبل النشر.',
          publishing: 'يتم استبدال الواجهة العامة بالمسودة المعتمدة.',
          published: 'تستخدم الواجهة العامة هذه النسخة الآن.',
          failedRecoverable: 'تم الاحتفاظ بالمسودة. أخطاء الشبكة لا تعني أن الواجهة العامة تغيرت.',
          blockedReadiness: 'أصلح موانع الجاهزية قبل النشر.',
          blockedStale: 'حدّث الحالة قبل النشر حتى لا تستبدل تعديلات أحدث.',
          blockedPermissions: 'هذا الحساب لا يمكنه نشر هذه الواجهة.',
        },
        actions: {
          retry: 'إعادة محاولة النشر',
          reviewIssues: 'مراجعة المشاكل',
          refreshState: 'تحديث الحالة',
          continueEditing: 'متابعة التحرير',
        },
      },
      restoreDialog: {
        title: 'استعادة نسخة كمسودة',
        description: 'راجع ملخص النسخة الآمن قبل استبدال المسودة الحالية.',
        confirm: 'استعادة المسودة',
        restoring: 'جار الاستعادة...',
        publicUnaffected: 'هذا ينشئ مسودة فقط. لن تتغير الواجهة العامة حتى تنشر.',
        labels: {
          status: 'الحالة',
          action: 'الإجراء',
          sections: 'الأقسام',
          date: 'التاريخ',
        },
      },
      errors: {
        invalidConfiguration: 'إعدادات واجهة المتجر غير صالحة.',
        invalidThemeSettings: 'إعدادات النمط تحتوي على اختيارات غير مدعومة.',
        invalidNavigationTarget: 'يوجد عنصر تنقل يشير إلى وجهة غير مدعومة.',
        unsafeNavigationUrl: 'رابط ملف التواصل الاجتماعي غير آمن.',
        missingNavigationContact: 'رابط التواصل يحتاج إلى قناة عامة في المتجر.',
        unsupportedEngineVersion: 'إصدار واجهة المتجر هذا غير مدعوم.',
        unsupportedSchemaVersion: 'إصدار هذا القسم غير مدعوم.',
        invalidPlacement: 'يوجد قسم في موضع غير صالح.',
        duplicateSingleton: 'تم تكرار قسم لا يمكن عرضه إلا مرة واحدة.',
        unsafeRichText: 'أزل النص المنسق غير الآمن قبل الحفظ.',
        unsafeMediaReference: 'أزل مراجع الوسائط غير الآمنة قبل الحفظ.',
        unsafeUrl: 'أزل الروابط غير الآمنة قبل الحفظ.',
        crossStoreReference: 'يوجد قسم يشير إلى محتوى من متجر آخر.',
        draftNotFound: 'تعذر العثور على المسودة.',
        revisionNotFound: 'تعذر العثور على النسخة.',
        previewExpired: 'انتهت صلاحية رابط المعاينة.',
        publishConflict: 'تم تغيير الواجهة بنشر آخر. حدّث الصفحة وحاول مرة أخرى.',
        permissionDenied: 'ليست لديك صلاحية إدارة واجهة هذا المتجر.',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة وحاول مرة أخرى.',
      },
      validation: {
        enabledSection: 'هذا القسم مفعّل وسيظهر للمتسوقين.',
        hiddenSection: 'هذا القسم مخفي ولن يظهر للمتسوقين.',
        disabledSection: 'هذا القسم معطل ولن يظهر للمتسوقين.',
        unsupportedSection: 'هذا القسم غير مدعوم.',
        invalidConfiguration: 'إعدادات هذا القسم غير صالحة.',
        invalidHeroConfig: 'محتوى قسم البطل غير صالح.',
        invalidThemeSettings: 'إعدادات النمط تحتوي على اختيارات غير مدعومة.',
        invalidNavigationTarget: 'يوجد عنصر تنقل يشير إلى وجهة غير مدعومة.',
        unsafeNavigationUrl: 'رابط ملف التواصل الاجتماعي غير آمن.',
        missingNavigationContact: 'رابط التواصل يحتاج إلى قناة عامة في المتجر.',
        invalidPlacement: 'لا يمكن عرض هذا القسم في هذا الموضع.',
        duplicateSection: 'لا يمكن تكرار هذا القسم.',
        unsupportedEngineVersion: 'إصدار واجهة المتجر هذا غير مدعوم.',
        invalidLifecycleAction: 'إجراء دورة حياة هذا القسم غير مسموح.',
        invalidResponsiveVisibility: 'اختر ظهورا صالحا لجهاز واحد على الأقل.',
        invalidWorkspaceTemplate: 'قالب مساحة العمل هذا غير مدعوم.',
        invalidLibraryEntry: 'عنصر مكتبة الأقسام هذا غير مدعوم.',
        unsafePublicConfig: 'يحتوي هذا القسم على حقول لا يجوز نشرها.',
        unsafeMediaReference: 'يحتوي هذا القسم على مرجع وسائط غير آمن.',
        unsafeRichText: 'يحتوي هذا القسم على نص منسق غير آمن.',
        unsafeUrl: 'يحتوي هذا القسم على رابط غير آمن.',
        crossStoreReference: 'يشير هذا القسم إلى متجر آخر.',
      },
      fallback: {
        sectionUnavailable: 'تعذر عرض هذا القسم الآن.',
      },
      seo: {
        title: 'بيانات البحث والمشاركة',
        description: 'اضبط العنوان والوصف والصورة التي تظهر للمتسوقين ومحركات البحث.',
        fields: {
          title: 'عنوان البحث',
          description: 'وصف البحث',
          socialImage: 'صورة المشاركة',
        },
        locales: {
          ar: 'العربية',
          he: 'العبرية',
          en: 'الإنجليزية',
        },
        placeholders: {
          title: 'اكتب عنوانا قصيرا للمتجر',
          description: 'اكتب وصفا آمنا وموجزا للمتجر',
        },
        counters: {
          text: '{{count}} من {{max}}',
        },
        actions: {
          apply: 'تطبيق بيانات البحث',
          cancel: 'إلغاء تغييرات البحث',
          reset: 'إعادة بيانات البحث الافتراضية',
        },
        status: {
          clean: 'لا توجد تغييرات غير مطبقة.',
          dirty: 'طبّق تغييرات البحث أو ألغها قبل الحفظ أو النشر.',
        },
        messages: {
          applied: 'تم تطبيق بيانات البحث على المسودة.',
          reset: 'تمت إعادة بيانات البحث إلى الافتراضي.',
        },
        errors: {
          invalidMetadata: 'لم يتم تطبيق بيانات البحث. بقيت المسودة السابقة كما هي.',
          unsafeText: 'استخدم نصا عاديا فقط بدون روابط أو وسوم.',
          titleTooLong: 'عنوان البحث أطول من الحد المسموح.',
          descriptionTooLong: 'وصف البحث أطول من الحد المسموح.',
          staleBuilder: 'تغيّرت واجهة المتجر من مكان آخر. حدّث الصفحة قبل تعديل بيانات البحث.',
        },
      },
      theme: {
        title: 'نمط الواجهة',
        description: 'تحكم بالمظهر العام لواجهة المتجر من خلال اختيارات دوكانتي المعتمدة.',
        actions: {
          reset: 'إعادة النمط الافتراضي',
        },
        presets: {
          title: 'قوالب المظهر',
          custom: 'مزيج مخصص من رموز المظهر',
          selected: 'محدد',
          apply: 'تطبيق',
          items: {
            'dukanti-default': {
              name: 'دوكانتي المحايدة',
              description: 'بداية هادئة بخلفية محايدة وحواف ناعمة.',
            },
            'olive-grove': {
              name: 'بستان الزيتون',
              description: 'ألوان زيتونية دافئة لمنتجات حرفية وطعام محلي.',
            },
            'saffron-market': {
              name: 'سوق الزعفران',
              description: 'تمييز كهرماني واضح للعروض والواجهات النشطة.',
            },
            'stone-boutique': {
              name: 'بوتيك الحجر',
              description: 'سطوح نظيفة وتباعد مضغوط للمتاجر ذات المنتجات الكثيرة.',
            },
            'galilee-mist': {
              name: 'ضباب الجليل',
              description: 'أزرق زيتوني هادئ ومساحات واسعة لواجهة ناعمة.',
            },
            'heritage-paper': {
              name: 'ورق تراثي',
              description: 'خط تحريري وخلفيات ورقية لقصة متجر أكثر دفئا.',
            },
          },
        },
        fields: {
          palette: 'لوحة الألوان',
          primary: 'اللون الأساسي',
          accent: 'لون التمييز',
          background: 'الخلفية',
          surface: 'السطح',
          text: 'النص',
          typography: 'الخطوط',
          buttonRadius: 'استدارة الأزرار',
          cardRadius: 'استدارة البطاقات',
          spacing: 'تباعد الأقسام',
        },
        palettes: {
          'dukanti-default': 'دوكانتي الافتراضية',
          'olive-grove': 'بستان الزيتون',
          'saffron-market': 'سوق الزعفران',
        },
        colorTokens: {
          'neutral-ink': 'حبر محايد',
          'semantic-status': 'ألوان حالة',
          'neutral-canvas': 'خلفية محايدة',
          'neutral-surface': 'سطح محايد',
          'zaatar-olive': 'زيتوني زعتر',
          'zaatar-deep': 'زعتر عميق',
          'saffron-amber': 'عنبر الزعفران',
          'zaatar-soft': 'زعتر ناعم',
          'olive-mist': 'ضباب زيتوني',
          paper: 'ورق',
          'stone-100': 'حجر دافئ',
          'zaatar-wash': 'غسلة زعتر',
          'stone-700': 'حجر داكن',
          'stone-600': 'حجر ناعم',
        },
        typography: {
          'language-default': 'خط اللغة الافتراضي',
          'heritage-editorial': 'تحريري تراثي',
          'modern-market': 'سوق حديث',
          'clean-commerce': 'تجارة واضحة',
        },
        radius: {
          crisp: 'حاد',
          soft: 'ناعم',
          rounded: 'مستدير',
        },
        spacing: {
          compact: 'مضغوط',
          comfortable: 'مريح',
          spacious: 'واسع',
        },
        messages: {
          applied: 'تم تطبيق نمط الواجهة على المسودة.',
          reset: 'تمت إعادة نمط الواجهة إلى الافتراضي.',
        },
        errors: {
          invalidThemeSettings: 'لم يتم تطبيق هذا النمط. بقيت المسودة السابقة كما هي.',
          staleBuilder: 'تغيّرت واجهة المتجر من مكان آخر. حدّث الصفحة قبل تغيير النمط.',
        },
      },
      chrome: {
        title: 'الرأس والتنقل',
        description: 'اضبط شريط الإعلانات ورأس المتجر وتذييله وتنقل المتسوقين.',
        fields: {
          announcementBar: 'شريط الإعلانات',
          announcementBarEnabled: 'إظهار شريط الإعلانات',
          announcementBarText: 'نص الإعلان',
          announcementBarLink: 'الرابط (اختياري)',
          headerBrand: 'علامة الرأس',
          headerLinks: 'روابط الرأس',
          footerBrand: 'علامة التذييل',
          footerLinks: 'روابط التذييل',
          footerContact: 'تواصل التذييل',
          socialLinks: 'روابط اجتماعية',
          mobileItems: 'تنقل الهاتف',
          target: 'الوجهة',
          collection: 'المجموعة',
          categoryId: 'معرّف التصنيف',
          socialProvider: 'ملف اجتماعي',
          socialUrl: 'رابط الملف',
        },
        placeholders: {
          categoryId: '00000000-0000-0000-0000-000000000000',
        },
        announcementBarLink: {
          none: 'بدون رابط',
        },
        hints: {
          announcementBarText: 'حتى 140 حرفًا لكل لغة. اتركه فارغًا في كل اللغات كي لا يظهر شيء.',
        },
        actions: {
          reset: 'إعادة الرأس والتنقل',
          apply: 'تطبيق التنقل',
          add: 'إضافة',
          remove: 'إزالة',
          moveUp: 'رفع',
          moveDown: 'خفض',
        },
        headerBrand: {
          logo: 'الشعار',
          name: 'الاسم',
          'logo-and-name': 'الشعار والاسم',
        },
        footerBrand: {
          'dukanti-and-store': 'دكانتي والمتجر',
          'store-only': 'المتجر فقط',
          'dukanti-only': 'دكانتي فقط',
        },
        messages: {
          applied: 'تم تطبيق الرأس والتنقل على المسودة.',
          reset: 'تمت إعادة الرأس والتنقل إلى الوضع الافتراضي.',
        },
        errors: {
          invalidNavigation: 'لم يتم تطبيق هذه الإعدادات. بقيت المسودة السابقة كما هي.',
          unsafeSocialUrl: 'استخدم رابط HTTPS مباشرًا لملف إنستغرام أو فيسبوك.',
          missingNavigationContact: 'رابط التواصل هذا يحتاج إلى هاتف أو واتساب عام للمتجر.',
          staleBuilder: 'تغيّرت واجهة المتجر من مكان آخر. حدّث الصفحة قبل تغيير الرأس والتنقل.',
          invalidAnnouncementText:
            'يجب أن يكون نص الإعلان نصًا عاديًا لا يتجاوز 140 حرفًا وبدون روابط.',
        },
      },
    },
    dashboard: {
      title: 'لوحة التحكم',
      subtitle: 'تابع حالة المتجر والمهام المهمة من مكان واحد',
      storeCreatedBanner: 'تم إنشاء متجرك بنجاح!',
      nextStep: 'الخطوة التالية: أضف منتجك الأول',
      addProduct: 'إضافة منتج',
      viewProducts: 'عرض المنتجات',
      storeUrl: 'رابط المتجر',
      logoUploadWarning:
        'تم إنشاء متجرك بنجاح، لكن فشل رفع الشعار. يمكنك إضافته لاحقًا من إعدادات المتجر.',
      metrics: {
        loadingValue: 'جارٍ التحميل',
        errorValue: 'غير متاح',
        loadingHelper: 'يتم تحميل هذا الملخص الآن',
        errorHelper: 'تعذر تحميل هذا الملخص',
        products: {
          title: 'المنتجات',
          helper: '{{published}} منشور من {{count}} معروض',
          ariaLabel: 'فتح المنتجات',
        },
        orders: {
          title: 'طلبات جديدة',
          helper: 'أول صفحة من الطلبات الجديدة الواردة',
          ariaLabel: 'فتح الطلبات الجديدة',
        },
        stock: {
          title: 'خيارات المنتجات النشطة التي تحتاج متابعة',
          helper: 'خيارات نشطة: {{out}} غير متوفرة · {{low}} بمخزون منخفض',
          ariaLabel: 'مراجعة مخزون خيارات المنتجات النشطة',
        },
        storefront: {
          title: 'واجهة المتجر',
          published: 'مباشرة',
          draft: 'مسودة',
          helper: 'حالة الواجهة العامة للمتجر',
          ariaLabel: 'فتح واجهة المتجر',
        },
      },
      recentOrders: {
        title: 'أحدث الطلبات الجديدة',
        viewAll: 'عرض كل الطلبات',
        loading: 'جار تحميل الطلبات',
        empty: 'لا توجد طلبات جديدة الآن',
        error: 'تعذر تحميل الطلبات الجديدة',
      },
      stockAttention: {
        title: 'خيارات المنتجات النشطة التي تحتاج متابعة',
        viewStock: 'مراجعة المخزون النشط',
        loading: 'جار تحميل المخزون',
        empty: 'لا توجد خيارات منتجات نشطة غير متوفرة أو بمخزون منخفض.',
        error: 'تعذر تحميل تنبيهات المخزون',
      },
      nextStepCard: {
        title: 'الخطوة التالية',
        description: 'أضف منتجًا جديدًا أو راجع قائمة المنتجات الحالية.',
      },
      snapshotNotice: 'الأرقام المعروضة ملخص تشغيلي من البيانات المتاحة حاليًا.',
    },
    shell: {
      tabTitle: '({{count}}) دكانتي - الإدارة',
      tabTitleDefault: 'دكانتي - الإدارة',
    },
    authBoundary: {
      pendingTitle: 'بانتظار صلاحية الإدارة',
      pendingBody: 'تم تسجيل الدخول، لكن لا توجد عضوية متجر فعّالة لهذا الحساب بعد.',
      unauthorizedTitle: 'لا توجد صلاحية إدارة',
      unauthorizedBody: 'هذا الحساب لا يملك عضوية متجر في دكانتي.',
      missingTitle: 'هذا الحساب ليس حساب تاجر',
      missingBody: 'لإدارة متجر في دكانتي، أنشئ حساب تاجر وانتظر موافقة الفريق قبل إنشاء متجر.',
      signOut: 'تسجيل الخروج',
    },
    barcode: {
      entry: {
        scanReceiving: 'استلام بالباركود',
        searchByBarcode: 'بحث بالباركود',
        scanBarcode: 'مسح باركود',
        productsAction: 'بحث باركود',
        stockAction: 'مسح للاستلام',
      },
      scan: {
        title: 'استلام المنتجات بالباركود',
        subtitle: 'امسح الباركود أو اكتبه للوصول إلى الصنف بسرعة.',
        inputLabel: 'الباركود',
        inputPlaceholder: 'امسح أو اكتب الباركود',
        submit: 'بحث',
        search: { submit: 'admin.barcode.search.submit' },
        scanAnother: 'مسح منتج آخر',
        ready: 'جاهز للمسح',
        normalizedHint: 'يتم تجاهل الفراغات في بداية ونهاية الباركود.',
        cameraOpen: 'مسح بالكاميرا',
        cameraTitle: 'مسح الباركود بالكاميرا',
        cameraDescription: 'وجّه الكاميرا نحو الباركود وثبّت الهاتف للحظة. سيتم التقاطه تلقائيًا.',
        modeGroupLabel: 'نوع الباركود',
        modeStoreLabels: 'ملصقات المتجر',
        modeStoreLabelsDescription:
          'للباركود الذي ينشئه المتجر أو يطبعه داخليًا. هذا هو الخيار الأكثر ثباتًا.',
        modeRetailProducts: 'منتجات تجارية',
        modeRetailProductsDescription:
          'للباركود الموجود على المنتجات الجاهزة من المصنع، مثل EAN أو UPC.',
        modeCompactCodes: 'أكواد صغيرة',
        modeCompactCodesDescription:
          'للأكواد القصيرة على المنتجات الصغيرة. يحتاج قراءة أكثر ثباتًا لتقليل الأخطاء.',
        cameraVideoLabel: 'معاينة الكاميرا المباشرة لمسح الباركود',
        cameraIdle: 'الكاميرا جاهزة.',
        cameraStatusStarting: 'جارٍ تشغيل الكاميرا...',
        cameraStatusScanning: 'جارٍ البحث عن باركود... قرّبه داخل الإطار وثبّت الهاتف.',
        cameraConsensusProgress:
          'تمت قراءة {{count}} من {{required}} قراءات مطابقة. ثبّت الهاتف قليلًا.',
        cameraDetected: 'تم التقاط الباركود.',
        cameraClose: 'إغلاق الماسح',
        cameraTryAgain: 'إعادة المحاولة',
        cameraSecureContextRequired:
          'مسح الكاميرا على الهاتف يحتاج HTTPS. افتح رابط الاختبار المحلي الآمن أو اكتب الباركود.',
        cameraUnsupported: 'مسح الكاميرا غير متاح في هذا المتصفح.',
        cameraPermissionDenied: 'تم حظر الوصول للكاميرا. اسمح بالكاميرا أو اكتب الباركود.',
        cameraDecodeFailed: 'تعذّر تشغيل ماسح الكاميرا. اكتب الباركود أو حاول مرة أخرى.',
      },
      result: {
        // Compatibility aliases for F-045 tests and older call sites.
        known: { title: 'admin.barcode.known.title' },
        unknown: { title: 'admin.barcode.unknown.title' },
        deletedRecoverable: { title: 'admin.barcode.deletedRecoverable.title' },
        knownTitle: 'تم العثور على الصنف',
        unknownTitle: 'باركود غير معروف',
        deletedTitle: 'باركود لصنف محذوف',
        invalidTitle: 'باركود غير صالح',
        product: 'المنتج',
        variant: 'الصنف',
        category: 'التصنيف',
        price: 'السعر',
        stock: 'المخزون',
        status: {
          active: 'نشط',
          disabled: 'معطل',
          outOfStock: 'نفد المخزون',
          unpublished: 'غير منشور',
        },
        editProduct: 'تعديل المنتج',
        updateStock: 'تحديث المخزون',
        createProduct: 'إنشاء منتج بهذا الباركود',
        reuseDeleted: 'استخدام هذا الباركود مجددًا',
      },
      stock: {
        mode: {
          addReceived: 'إضافة كمية مستلمة',
          setExact: 'تعيين المخزون',
        },
        quantityLabel: 'الكمية المستلمة',
        exactLabel: 'المخزون النهائي',
        success: 'تم تحديث المخزون',
        errors: {
          positiveAdd: 'أدخل كمية أكبر من صفر.',
          nonNegative: 'لا يمكن أن يكون المخزون سالبًا.',
          wholeNumber: 'أدخل رقمًا صحيحًا.',
          maxQuantity: 'يجب ألا تتجاوز الكمية {{max}}.',
        },
      },
      errors: {
        lookupFailed: 'تعذر البحث عن الباركود.',
        permissionDenied: 'لا تملك صلاحية استخدام هذا الباركود.',
        networkFailed: 'فشل الاتصال. حاول مرة أخرى.',
        unknown: 'حدث خطأ أثناء البحث عن الباركود.',
      },
    },
    offerCampaigns: {
      title: 'حملات العروض',
      subtitle: 'رتّب المنتجات المخفّضة في حملة محددة الوقت.',
      addNew: 'حملة جديدة',
      adsTab: 'الإعلانات',
      campaignsTab: 'حملات العروض',
      emptyTitle: 'لا توجد حملات عروض بعد',
      emptyDescription: 'أنشئ حملة من المنتجات المخفّضة الموجودة.',
      visibilityNotice: 'يعرض المتجر حتى 3 حملات مباشرة بعد التصنيفات، مرتبة حسب الأقرب انتهاءً.',
      publicLink: 'رابط العرض',
      copyLink: 'نسخ الرابط',
      editCampaign: 'تعديل {{title}}',
      dateRange: 'من {{start}} إلى {{end}}',
      toasts: {
        created: 'تم إنشاء الحملة.',
        updated: 'تم حفظ الحملة.',
        deleted: 'تم حذف الحملة.',
        linkCopied: 'تم نسخ الرابط.',
      },
      form: {
        pageTitleCreate: 'حملة عرض جديدة',
        pageTitleEdit: 'تعديل حملة العرض',
        back: 'الرجوع إلى الحملات',
        titleLabel: 'عنوان الحملة',
        titlePlaceholder: 'مثال: عروض نهاية الأسبوع',
        descriptionLabel: 'وصف قصير',
        descriptionPlaceholder: 'اكتب سبب العرض باختصار',
        startsAtLabel: 'وقت البداية',
        endsAtLabel: 'وقت النهاية',
        activeLabel: 'الحملة مفعّلة',
        sellablesLabel: 'منتجات التخفيض',
        submitCreate: 'إنشاء الحملة',
        submitEdit: 'حفظ الحملة',
      },
      picker: {
        searchLabel: 'البحث عن منتج مخفّض',
        searchPlaceholder: 'اسم المنتج أو الخيار',
        loading: 'جارٍ تحميل المنتجات المخفّضة...',
        empty: 'لا توجد منتجات مخفّضة مؤهلة.',
        selected: 'تم اختيار {{count}}',
        defaultVariant: 'الخيار الأساسي',
        optionWithCategory: '{{category}}: {{variant}}',
        ineligible: 'لم يعد مؤهلًا',
      },
      status: {
        scheduled: 'مجدولة',
        live: 'مباشرة',
        ended: 'انتهت',
        inactive: 'غير مفعّلة',
      },
      delete: {
        title: 'حذف الحملة؟',
        description: 'لن تظهر هذه الحملة للعملاء بعد حذفها.',
        confirm: 'حذف الحملة',
      },
      errors: {
        titleRequired: 'اكتب عنوان الحملة.',
        titleTooLong: 'العنوان طويل جدًا.',
        descriptionTooLong: 'الوصف طويل جدًا.',
        titleInvalid: 'لا يمكن استخدام رموز اتجاه مخفية في النص.',
        invalidWindow: 'وقت النهاية يجب أن يكون بعد وقت البداية.',
        emptySelection: 'اختر منتجًا مخفّضًا واحدًا على الأقل.',
        ineligibleSellable: 'بعض المنتجات المختارة لم تعد مؤهلة للحملة.',
        itemLimitExceeded: 'يمكنك اختيار حتى 48 منتجًا في الحملة الواحدة.',
        duplicateSelection: 'لا يمكن اختيار نفس المنتج أكثر من مرة.',
        permissionDenied: 'لا تملك صلاحية إدارة هذه الحملة.',
        notFound: 'لم يتم العثور على الحملة.',
      },
    },
    promotionKit: {
      tabs: { kit: 'عدة الترويج' },
      title: 'عدة الترويج',
      subtitle: 'جهز رابطًا ورسالة وملصق QR وصورة قصة لمتجرك.',
      target: {
        label: 'ماذا تريد أن تروّج؟',
        search: 'ابحث عن هدف',
        loadMore: 'عرض المزيد',
        groups: {
          storeHome: 'واجهة المتجر',
          product: 'المنتجات',
          category: 'التصنيفات',
          liveOfferCampaign: 'العروض المباشرة',
          salesPage: 'صفحة التخفيضات',
          reviewHighlight: 'التقييمات البارزة',
        },
        unavailable: { targetUnavailable: 'هذا الهدف لم يعد متاحًا للمشاركة.' },
      },
      locale: { label: 'لغة الرسالة' },
      actions: {
        copyUrl: 'نسخ الرابط',
        copyMessage: 'نسخ الرسالة',
        openWhatsapp: 'فتح واتساب',
        downloadPoster: 'تنزيل الملصق',
        printPoster: 'طباعة الملصق',
        downloadStory: 'تنزيل القصة',
      },
      preview: {
        whatsappTitle: 'رسالة واتساب',
        urlTitle: 'الرابط العام',
        posterTitle: 'ملصق QR',
        storyTitle: 'صورة قصة',
      },
      analytics: {
        title: 'نتائج الرابط',
        empty: 'لا توجد نتائج لهذا الرابط بعد.',
        linkVisits: 'زيارات منسوبة للرابط',
        productViews: 'مشاهدات المنتج',
        contactClicks: 'ضغطات التواصل',
        addToCartClicks: 'ضغطات إضافة للسلة',
        orderStartClicks: 'بدايات الطلب',
        countOverflowed: 'وصل العد إلى الحد التقني الأعلى.',
      },
      empty: {
        noPublicTargets: 'انشر متجرك أو أضف منتجًا عامًا لتبدأ.',
        noLiveOffers: 'لا توجد عروض مباشرة الآن.',
        noReviews: 'لا توجد تقييمات ظاهرة مع نص للمشاركة.',
      },
      errors: {
        permissionDenied: 'لا تملك صلاحية إدارة عدة الترويج لهذا المتجر.',
        targetUnavailable: 'هذا الهدف غير متاح للمشاركة الآن.',
        linkUnavailable: 'تعذر تجهيز رابط المشاركة.',
        assetFailed: 'تعذر تجهيز الصورة. جرّب مرة أخرى.',
        clipboardFailed: 'تعذر النسخ. انسخ النص يدويًا.',
      },
      toasts: {
        urlCopied: 'تم نسخ الرابط',
        messageCopied: 'تم نسخ الرسالة',
        posterDownloaded: 'تم تنزيل الملصق',
        storyDownloaded: 'تم تنزيل القصة',
      },
    },
    welcome: 'مرحبًا بك في دكانتي',
    home: {
      hero: 'مرحبًا بك في دكانتي',
      subhero: 'ابدأ متجرك الإلكتروني اليوم',
      signUpCta: 'إنشاء حساب',
      signInCta: 'تسجيل الدخول',
    },
    nav: {
      subscribers: 'المشتركون',
      ariaLabel: 'التنقل الرئيسي',
      dashboard: 'لوحة التحكم',
      settings: 'الإعدادات',
      products: 'المنتجات',
      categories: 'التصنيفات',
      promotions: 'التسويق',
      billing: 'الفوترة',
      orders: 'الطلبات',
      prepareOrder: 'تجهيز طلب',
      reviews: 'التقييمات',
      couriers: 'المندوبون',
      stock: 'المخزون',
      storefront: 'واجهة المتجر',
      addProduct: 'إضافة منتج',
      addProductAria: 'إضافة منتج جديد',
      ordersShortcut: 'الطلبات الجديدة',
      storeWorkspace: 'مساحة المتجر',
      storeFallback: 'متجري',
      accountFallback: 'حساب التاجر',
      storeSettings: 'إعدادات المتجر',
      signOut: 'تسجيل الخروج',
      signOutDialog: {
        title: 'تسجيل الخروج؟',
        body: 'ستحتاج إلى تسجيل الدخول مرة أخرى قبل إدارة متجرك.',
        cancel: 'البقاء مسجلاً',
        confirm: 'تسجيل الخروج',
      },
      openSidebar: 'افتح القائمة',
      closeSidebar: 'أغلق القائمة',
      toggleSidebar: 'تبديل القائمة الجانبية',
      sidebarTitle: 'القائمة الجانبية',
      sidebarDescription: 'تعرض قائمة التنقل الجانبية في الإدارة.',
      skipToContent: 'تخطَّ إلى المحتوى الرئيسي',
      languageSwitcher: 'اللغة',
      unsavedChanges: {
        title: 'لديك تغييرات غير محفوظة',
        body: 'هل تريد المغادرة على أي حال؟ ستفقد التعديلات.',
        stay: 'البقاء',
        leave: 'المغادرة',
      },
    },
    billing: {
      title: 'الفوترة',
      subtitle: 'اختر خطة دكانتي لهذا المتجر.',
      permissionDeniedBody:
        'تغييرات الفوترة محصورة بمالك المتجر. اطلب من المالك فتح هذه الصفحة أو تحديث الاشتراك.',
      currentPlan: {
        title: 'الخطة الحالية',
        none: 'لا يوجد اشتراك فعّال',
        pending: 'بانتظار تأكيد PayPal',
      },
      interval: { monthly: 'شهري', annual: 'سنوي' },
      plan: {
        starter: { name: 'البداية' },
        growth: { name: 'النمو' },
        pro: { name: 'المحترفين' },
        priceMonthly: '{{price}} / شهريًا',
        priceAnnual: '{{price}} / سنويًا',
        activeProducts: '{{count}} منتج نشط',
        mediaStorage: '{{size}} مساحة وسائط',
        aiImageEdits: '{{count}} تعديل صور بالذكاء الاصطناعي',
        promotionTools: { basic: 'مشاركة رابط المتجر الأساسية', full: 'أدوات الترويج كاملة' },
        analytics: { basic: 'تحليلات أساسية', advanced: 'تحليلات متقدمة' },
        support: { standard: 'دعم عادي', priority: 'دعم أولوية' },
      },
      actions: {
        subscribe: 'اشترك',
        upgrade: 'ترقية',
        downgrade: 'تخفيض',
        intervalChange: 'تغيير المدة',
        cancel: 'إلغاء الاشتراك',
        retryPayment: 'إعادة محاولة الدفع',
        updatePayment: 'تحديث الدفع',
        confirmRevision: 'تأكيد التغيير',
        continueApproval: 'متابعة الموافقة',
      },
      paypal: {
        loading: 'جارٍ تحميل موافقة PayPal...',
        closed:
          'تم إغلاق نافذة الموافقة. لم يتم تفعيل أي اشتراك؛ اختر PayPal أو البطاقة مرة أخرى عندما تكون جاهزًا.',
        pendingNotice: 'تبدأ موافقة PayPal من هنا، لكن دكانتي يفعّل الوصول فقط بعد تأكيد الخادم.',
        selectedLabel: 'الخطة المختارة',
        selectedTitle: 'إكمال موافقة {{plan}}',
        selectedSummary: 'خطة {{plan}} بسعر {{price}}',
        paymentMethods: 'اختر طريقة الموافقة على هذا الاشتراك',
      },
      pilot: {
        subtitle: 'دكانتي يشغّل هذا المتجر ضمن تجربة إطلاق مجانية. لا حاجة لأي طريقة دفع الآن.',
        activeTitle: 'وصول التجربة فعّال',
        activeBody:
          'هذا المتجر لديه وصول إطلاق بمستوى Pro حتى {{date}}. خطط الدفع متوقفة خلال التجربة.',
        paidActiveTitle: 'وصول المنصة فعّال',
        paidActiveBody:
          'هذا المتجر ما زال يملك وصول اشتراك موثّق. تغييرات الدفع متوقفة خلال تجربة الإطلاق.',
        expiredTitle: 'انتهى وصول التجربة',
        expiredBody:
          'إجراءات المتجر والواجهة العامة متوقفة حتى تمدد دكانتي الوصول أو تفعّل الفوترة.',
        windowTitle: 'نافذة تجربة 30 يومًا',
        windowBody: 'ينتهي وصول التجربة الحالي في {{date}}.',
        storefrontTitle: 'محرك الواجهة',
        storefrontBody: 'يمكنك متابعة بناء الواجهة ومعاينتها ونشرها ما دام وصول التجربة فعّالًا.',
        storefrontCta: 'فتح محرر الواجهة',
        overageTitle: 'الاستخدام يحتاج مراجعة',
      },
      usage: {
        activeProducts: 'المنتجات النشطة',
        mediaStorage: 'مساحة الوسائط',
        aiEdits: 'تعديلات الصور بالذكاء الاصطناعي',
        noLimit: 'لا توجد سعة مدفوعة متاحة حاليًا.',
      },
      diagnostics: {
        title: 'تشخيص الفوترة',
        environment: 'بيئة PayPal',
        lastSync: 'آخر مزامنة مع PayPal',
        empty: 'غير متاح',
        notStarted: 'لا يوجد اشتراك بعد',
      },
      toast: {
        activated: 'تم تفعيل الاشتراك.',
        reconsentReady: 'موافقة PayPal جاهزة. أكمل الموافقة لتغيير الخطة.',
        cancelled: 'تم إرسال الإلغاء. يبقى الوصول حتى نهاية فترة الدفع.',
        retryStarted: 'بدأت إعادة محاولة الدفع.',
      },
      status: {
        missing: 'الاشتراك مطلوب',
        configurationError: 'الفوترة غير متاحة',
        approvalPending: 'بانتظار الموافقة',
        active: 'فعّال',
        grace: 'الدفع متأخر',
        cancelledPendingPeriodEnd: 'ملغى مع بقاء الوصول حتى نهاية الفترة',
        cancelled: 'ملغى',
        limited: 'محدود',
        suspended: 'معلّق',
        expired: 'منتهي',
      },
      warning: {
        pastDue: 'فشلت الدفعة. يستمر الوصول حتى {{deadline}}.',
        limited: 'الإجراءات المدفوعة محجوبة حتى حل مشكلة الفوترة.',
        overProductLimit: 'هذا المتجر تجاوز حد المنتجات النشطة.',
        overStorageLimit: 'هذا المتجر تجاوز حد مساحة الوسائط.',
        overAiImageEdits: 'استخدم هذا المتجر كل تعديلات الصور لهذه الفترة.',
      },
      dialog: {
        cancel: {
          title: 'إلغاء الاشتراك؟',
          description: 'يبقى الوصول المدفوع متاحًا حتى {{date}}. لا يتم حذف بيانات المتجر الحالية.',
        },
        changePlan: {
          title: 'تغيير الخطة',
          planSummary: '{{plan}} - {{price}}',
          overLimitDescription:
            'بعض الاستخدام الحالي أعلى من الخطة المطلوبة وقد تُحجب الإجراءات المدفوعة الجديدة بعد التغيير.',
          approvalDescription: 'موافقة PayPal جاهزة. افتح PayPal للموافقة على تغيير الخطة.',
          openPayPalApproval: 'فتح موافقة PayPal',
        },
      },
      errors: {
        permissionDenied: 'مالك المتجر فقط يستطيع إدارة الفوترة.',
        paypalUnavailable: 'PayPal غير متاح الآن.',
        configurationMissing: 'الفوترة غير مهيأة لهذه البيئة.',
        activationPending: 'موافقة PayPal قيد الانتظار. الوصول غير فعّال بعد.',
        planMismatch: 'خطة PayPal لا تطابق خطة دكانتي.',
        planAlreadyActive: 'هذه الخطة مفعلة بالفعل.',
        reconsentRequired: 'موافقة PayPal مطلوبة لإكمال هذا التغيير.',
        webhookUnverified: 'فشل التحقق من PayPal.',
        paymentPaused: 'الدفع متوقف بينما تعمل دكانتي بنمط تجربة الإطلاق.',
        retry: 'فشل إجراء الفوترة. حاول مرة أخرى.',
      },
    },
    entitlements: {
      upgradePrompt: {
        title: 'الترقية مطلوبة',
        description: 'رقّ خطة المتجر لاستخدام هذه الميزة.',
      },
      promotionKitBlocked: 'رقّ إلى النمو أو المحترفين لاستخدام أدوات الترويج هذه.',
      productLimitBlocked: 'تم الوصول إلى حد المنتجات النشطة.',
      storageLimitBlocked: 'تم الوصول إلى حد مساحة الوسائط.',
      aiQuotaBlocked: 'تم استخدام حصة تعديلات الصور بالذكاء الاصطناعي.',
      reasons: {
        missingSubscription: 'اختر خطة دكانتي قبل استخدام الميزات المدفوعة.',
        configurationError: 'الفوترة غير مهيأة لهذه البيئة.',
        activationPending: 'موافقة PayPal قيد الانتظار. الوصول غير فعّال بعد.',
        paymentRequired: 'الوصول المدفوع مطلوب لهذا الإجراء.',
        suspended: 'هذا الاشتراك معلّق. عالج الفوترة قبل المتابعة.',
        expired: 'انتهى هذا الاشتراك. جدّد الفوترة قبل المتابعة.',
        cancelled: 'تم إلغاء هذا الاشتراك. اختر خطة لاستعادة الوصول المدفوع.',
        productLimitReached: 'تم الوصول إلى حد المنتجات النشطة.',
        storageLimitReached: 'تم الوصول إلى حد مساحة الوسائط.',
        aiQuotaExhausted: 'تم استخدام حصة تعديلات الصور بالذكاء الاصطناعي.',
        planUpgradeRequired: 'رقّ خطة المتجر للمتابعة.',
        permissionDenied: 'ليست لديك صلاحية استخدام هذه الميزة المدفوعة.',
        ownerRequired: 'مالك المتجر فقط يستطيع إدارة الفوترة.',
        paidBasisMissing: 'إثبات دفعة PayPal غير متاح بعد. حاول مرة أخرى بعد قليل.',
        environmentMismatch: 'إعدادات sandbox/live في PayPal لا تطابق قاعدة بيانات الفوترة هذه.',
      },
    },
    createStore: {
      title: 'إنشاء متجرك',
      subtitle: 'أدخل معلومات متجرك للبدء',
      nameLabel: 'اسم المتجر',
      namePlaceholder: 'مثال: بقالة أبو أحمد',
      descriptionLabel: 'وصف المتجر',
      descriptionPlaceholder: 'صف متجرك ومنتجاتك بإيجاز',
      slugLabel: 'رابط المتجر',
      slugPlaceholder: 'my-store',
      slugHint: 'سيكون رابط متجرك: {{slug}}.{{domain}}',
      slugAvailable: 'هذا الرابط متاح',
      slugChecking: 'جارٍ التحقق...',
      logoLabel: 'شعار المتجر (اختياري)',
      logoHint: 'JPEG أو PNG أو WEBP، بحد أقصى 2 ميغابايت',
      logoRemove: 'إزالة الشعار',
      logoUpload: 'رفع شعار',
      submit: 'إنشاء المتجر',
      submitting: 'جارٍ الإنشاء...',
      welcomeBanner: 'مرحبًا! تفقّد بريدك لتأكيد الحساب.',
      errors: {
        nameRequired: 'اسم المتجر مطلوب',
        nameTooLong: 'اسم المتجر يجب ألا يتجاوز 100 حرف',
        descriptionRequired: 'وصف المتجر مطلوب',
        descriptionTooLong: 'الوصف يجب ألا يتجاوز 500 حرف',
        slugRequired: 'رابط المتجر مطلوب',
        slugTooShort: 'الرابط يجب أن يكون 3 أحرف على الأقل',
        slugTooLong: 'الرابط يجب ألا يتجاوز 60 حرفًا',
        slugInvalidFormat: 'يجب أن يحتوي الرابط على أحرف إنجليزية صغيرة وأرقام وشرطات فقط',
        slugTaken: 'هذا الرابط مستخدم بالفعل',
        slugReserved: 'هذا الرابط محجوز',
        approvalRequired: 'يجب الموافقة على حساب التاجر قبل إنشاء متجر.',
        logoTooLarge: 'حجم الصورة يجب ألا يتجاوز 2 ميغابايت',
        logoInvalidType: 'يجب أن يكون الملف بصيغة JPEG أو PNG أو WEBP',
        logoUploadFailed: 'فشل رفع الشعار. حاول مرة أخرى.',
        networkFailed: 'فشل الاتصال. تحقق من الإنترنت.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    signIn: {
      title: 'تسجيل دخول الإدارة',
      subtitle: 'أدخل بريدك الإلكتروني وسنرسل رمز تحقق.',
      emailLabel: 'البريد الإلكتروني',
      emailPlaceholder: 'merchant@example.com',
      passwordLabel: 'كلمة المرور',
      codeLabel: 'رمز التحقق',
      codeHint: 'أدخل الرمز المكوّن من 6 أرقام.',
      requestCode: 'إرسال الرمز',
      requestingCode: 'جارٍ الإرسال...',
      sentMessage: 'إذا كان البريد يملك صلاحية إدارة، فسيصله رمز تحقق.',
      verifyCode: 'تأكيد الرمز',
      verifyingCode: 'جارٍ التحقق...',
      changeEmail: 'تغيير البريد',
      resendCode: 'إرسال رمز جديد',
      invitationOnly: 'الدخول للتجار المدعوين فقط.',
      showPassword: 'إظهار كلمة المرور',
      hidePassword: 'إخفاء كلمة المرور',
      submit: 'إرسال الرمز',
      submitting: 'جارٍ الإرسال...',
      noAccount: 'الدخول للإدارة يتم عبر دعوة فقط.',
      signUpLink: 'العودة لتسجيل الدخول',
      errors: {
        emailRequired: 'البريد الإلكتروني مطلوب',
        emailInvalid: 'البريد الإلكتروني غير صالح',
        codeRequired: 'رمز التحقق مطلوب',
        codeInvalid: 'أدخل رمزًا من 6 أرقام',
        invalidCode: 'الرمز غير صحيح أو انتهت صلاحيته',
        rateLimited: 'محاولات كثيرة. حاول بعد قليل.',
        passwordRequired: 'كلمة المرور مطلوبة',
        invalidCredentials: 'البريد الإلكتروني أو كلمة المرور غير صحيحة',
        networkFailed: 'فشل الاتصال. تحقق من الإنترنت.',
        serviceUnavailable: 'خدمة تسجيل الدخول لا تستجيب. حاول بعد قليل.',
        unknown: 'حدث خطأ. حاول مرة أخرى.',
      },
    },
    publishStore: {
      ctaLabel: 'نشر المتجر',
      ctaLabelSubmitting: 'جارٍ النشر…',
      unpublishCtaLabel: 'إلغاء النشر',
      unpublishCtaLabelSubmitting: 'جارٍ إلغاء النشر…',
      badge: {
        draft: 'مسودة',
        published: 'منشور',
      },
      draftCard: {
        title: 'جاهز لإطلاق متجرك؟',
        description: 'انشر متجرك ليتمكّن العملاء من زيارته واستعراض منتجاتك.',
      },
      modal: {
        title: 'نشر متجرك؟',
        description: 'سيكون متجرك متاحًا للعملاء على الرابط التالي:',
        confirm: 'تأكيد النشر',
      },
      unpublishModal: {
        title: 'إخفاء المتجر عن العملاء؟',
        description: 'سيرى العملاء صفحة «المتجر غير متاح». يمكنك إعادة النشر في أي وقت.',
        confirm: 'إلغاء النشر',
      },
      publishedCard: {
        title: 'متجرك مباشر الآن',
        urlLabel: 'رابط متجرك العام',
        copy: 'نسخ الرابط',
        copyAriaLabel: 'نسخ رابط المتجر إلى الحافظة',
        viewStore: 'معاينة المتجر',
      },
      toasts: {
        published: 'متجرك مباشر الآن',
        unpublished: 'تم إخفاء المتجر عن العملاء',
        urlCopied: 'تم نسخ الرابط',
      },
      errors: {
        noStockedProducts: 'أضف منتجًا واحدًا على الأقل متوفر في المخزون قبل النشر.',
        noStockedProductsCta: 'إضافة منتج',
        missingContactMethod: 'أضف طريقة تواصل قبل نشر المتجر.',
        missingContactMethodCta: 'الانتقال إلى الإعدادات',
        missingLogo: 'حمّل شعار المتجر قبل نشر متجرك.',
        missingLogoCta: 'تحميل الشعار من الإعدادات',
        subscriptionRequired: 'اختر خطة دكانتي وفعّلها قبل نشر متجرك.',
        activeProductLimitReached:
          'خطتك الحالية لا تسمح بنشر هذا العدد من المنتجات. ألغِ نشر المنتجات الزائدة أو قم بترقية الخطة.',
        // DEPRECATED: use common.errors.permissionDenied
        permissionDenied: 'ليس لديك صلاحية لفعل ذلك.',
        // DEPRECATED: use common.errors.storeNotFound
        storeNotFound: 'هذا المتجر لم يعد موجودًا. يرجى تحديث الصفحة.',
        // DEPRECATED: use common.errors.networkFailed
        networkFailed: 'فشل الاتصال. تحقّق من الشبكة وأعد المحاولة.',
        copyFailed: 'تعذّر نسخ الرابط. حدّد الرابط وانسخه يدويًا.',
        // DEPRECATED: use common.errors.unknown
        unknown: 'حدث خطأ ما. حاول مرة أخرى.',
      },
    },
    storeSettings: {
      fulfillment: {
        saveFailed: 'تعذّر الحفظ. مسودتك محفوظة.',
        saved: 'تم حفظ خيارات التوصيل والاستلام',
        reload: 'إعادة تحميل الإعدادات',
        conflict: 'حُفظت تغييرات أخرى. مسودتك محفوظة؛ أعد تحميل الإعدادات للمراجعة.',
        noMethodsWarning: 'لن يتمكن الزبائن من تأكيد طلبات حتى تفعّل خيارًا.',
        pickupLimit: 'يمكن إضافة مكان استلام واحد حاليًا.',
        removeDescription: 'لن يؤثر ذلك على تفاصيل الطلبات المؤكدة سابقًا.',
        removePickup: 'إزالة مكان الاستلام',
        addPickup: 'إضافة مكان استلام',
        pickupDetailsInvalid: 'أدخل عنوانًا أو تعليمات من 1 إلى 1000 حرف.',
        pickupNameInvalid: 'أدخل اسمًا من 1 إلى 160 حرفًا.',
        pickupDetails: 'العنوان أو تعليمات الاستلام',
        pickupName: 'اسم مكان الاستلام',
        feeInvalid: 'أدخل مبلغًا بين 0 و1000 شيكل بمنزلتين عشريتين كحد أقصى.',
        fixedFeeHelp:
          'رسوم واحدة لجميع الوجهات. اترك الحقل فارغًا لإيقاف التوصيل، أو أدخل 0 لتوصيل مجاني.',
        title: 'التوصيل والاستلام',
      },
      socialProfiles: {
        reload: 'إعادة تحميل الإعدادات',
        forbidden: 'هذه الإعدادات متاحة لمالك المتجر والمسؤولين فقط.',
        title: 'حسابات التواصل الاجتماعي',
        help: 'تُطبّق هذه الإعدادات مباشرةً على المتجر. نصوص القالب والاشتراك تتطلّب النشر.',
        provider: 'المنصة',
        url: 'رابط الحساب',
        add: 'إضافة حساب',
        remove: 'إزالة الحساب',
        saved: 'تم حفظ حسابات التواصل.',
        invalid: 'أدخل رابط حساب Instagram أو Facebook صالحًا.',
        stale: 'تغيّرت هذه الإعدادات في جلسة أخرى. أعد تحميلها ثم حاول مرة أخرى.',
        loadError: 'تعذّر تحميل حسابات التواصل.',
        saveError: 'تعذّر حفظ حسابات التواصل. حاول مرة أخرى.',
        empty: 'لم تُضف حسابات تواصل.',
        max: 'يمكنك إضافة ما يصل إلى أربعة حسابات.',
        instagram: 'Instagram',
        facebook: 'Facebook',
      },
      newsletterCollection: {
        title: 'اشتراكات النشرة',
        description:
          'اجمعوا اشتراكات البريد الإلكتروني بموافقة العملاء عبر قالب منشور يدعم النشرة. لا يرسل هذا رسائل.',
        label: 'السماح بالاشتراك في النشرة',
        enabledHint: 'تظهر عندما يدعم قالبكم المنشور النشرة.',
        disabledHint: 'جمع الاشتراكات متوقف. تُحفظ الاشتراكات السابقة.',
        saving: 'جارٍ الحفظ…',
        savedToast: 'تم حفظ إعداد النشرة.',
        manageSubscribers: 'إدارة المشتركين',
        permissionHint: 'يمكن للمالك والمشرفين فقط تغيير جمع الاشتراكات.',
        error: 'تعذر حفظ الإعداد. حاولوا مجددًا.',
        subscriberTitle: 'مشتركو النشرة',
        export: 'تصدير CSV',
        suppress: 'إيقاف الاشتراك',
        empty: 'لا توجد اشتراكات بعد.',
        loadError: 'تعذر تحميل الاشتراكات.',
        suppressionError: 'تعذر إيقاف هذا الاشتراك.',
      },
      title: 'إعدادات المتجر',
      subtitle: 'حدّث تفاصيل المتجر وطرق التواصل التي يراها زبائنك',
      fixBanner: 'أضف رقم واتساب أو رقم هاتف لتتمكن من نشر متجرك.',
      whatsappLabel: 'رقم واتساب',
      phoneLabel: 'رقم الهاتف',
      countryLabel: 'الدولة',
      callingCodeLabel: 'رمز الاتصال',
      localPhoneLabel: 'رقم الهاتف المحلي',
      whatsappLocalLabel: 'رقم واتساب المحلي',
      phoneLocalLabel: 'رقم الهاتف المحلي',
      phonePlaceholder: '+972501234567',
      phoneHint: 'أدخل رمز الدولة (مثال: +972 للأرقام الإسرائيلية)',
      localPhonePlaceholderIL: '0501234567',
      internationalPhonePlaceholder: '+972501234567',
      phoneHintCountryFirst: 'اختر الدولة ثم اكتب الرقم كما تستخدمه محليًا.',
      submit: 'حفظ',
      submitting: 'جارٍ الحفظ…',
      details: {
        title: 'تفاصيل المتجر',
        description: 'حدّث الاسم والوصف والشعار الذي يظهر لزبائنك.',
        nameLabel: 'اسم المتجر',
        namePlaceholder: 'مثال: بقالة أحمد',
        descriptionLabel: 'وصف المتجر',
        descriptionPlaceholder: 'اكتب وصفًا قصيرًا لمتجرك ومنتجاتك',
        descriptionCount: '{{count}}/{{max}}',
        localityLabel: 'بلدة المتجر',
        localityPlaceholder: 'اختر البلدة',
        localityLoading: 'جارٍ تحميل البلدات…',
        localityHint: 'البلدة التي يقع فيها متجرك.',
        slugLabel: 'رابط المتجر',
        slugLockedWarning:
          'لا يمكن تغيير رابط المتجر بعد إنشائه حتى لا تتعطل الروابط التي شاركتها.',
        logoLabel: 'شعار المتجر',
        logoHint: 'JPEG أو PNG أو WEBP، حتى 2MB',
        logoUpload: 'رفع شعار',
        logoReplace: 'استبدال الشعار',
        logoRemove: 'إزالة الشعار',
        logoUndoRemove: 'التراجع عن الإزالة',
        submit: 'حفظ التفاصيل',
        submitting: 'جارٍ حفظ التفاصيل…',
      },
      manualApproval: {
        title: 'مراجعة الطلبات يدويًا',
        description: 'اطلب مراجعة من التاجر قبل شحن الطلبات الجديدة أو تعيين مندوب لها.',
        checkboxLabel: 'مراجعة الطلبات الجديدة قبل التجهيز',
        enabledHint: 'الطلبات الجديدة ستنتظر الموافقة. الطلبات الحالية لا تتغير.',
        disabledHint: 'الطلبات الجديدة يمكن أن تنتقل مباشرة إلى التجهيز.',
        saving: 'جارٍ حفظ الإعداد…',
        savedToast: 'تم حفظ إعداد المراجعة اليدوية',
      },
      toasts: {
        saved: 'تم الحفظ',
        detailsSaved: 'تم حفظ تفاصيل المتجر',
      },
      errors: {
        nameRequired: 'اسم المتجر مطلوب',
        nameTooLong: 'يجب ألا يزيد اسم المتجر عن 100 حرف',
        descriptionRequired: 'وصف المتجر مطلوب',
        descriptionTooLong: 'يجب ألا يزيد الوصف عن 500 حرف',
        localityRequired: 'بلدة المتجر مطلوبة',
        logoTooLarge: 'يجب ألا تتجاوز الصورة 2MB',
        logoInvalidType: 'يجب أن يكون الملف JPEG أو PNG أو WEBP',
        logoUploadFailed: 'فشل رفع الشعار. حاول مرة أخرى.',
        whatsappInvalid: 'أدخل رقمًا صحيحًا بصيغة دولية (مثال: +972501234567)',
        phoneInvalid: 'أدخل رقمًا صحيحًا بصيغة دولية (مثال: +972501234567)',
        whatsappInvalidForCountry: 'رقم واتساب غير صالح للدولة المختارة',
        phoneInvalidForCountry: 'رقم الهاتف غير صالح للدولة المختارة',
        whatsappInternationalInvalid: 'أدخل رقم واتساب دوليًا صحيحًا مثل +972501234567',
        phoneInternationalInvalid: 'أدخل رقم هاتف دوليًا صحيحًا مثل +972501234567',
        whatsappLocalTooLong: 'رقم واتساب المحلي طويل جدًا',
        phoneLocalTooLong: 'رقم الهاتف المحلي طويل جدًا',
        whatsappInternationalTooLong: 'رقم واتساب الدولي طويل جدًا',
        phoneInternationalTooLong: 'رقم الهاتف الدولي طويل جدًا',
        atLeastOneRequired: 'يجب تقديم وسيلة اتصال واحدة على الأقل',
        networkFailed: 'فشل الاتصال. تحقق من الشبكة وحاول مرة أخرى.',
        unknown: 'حدث خطأ ما. حاول مرة أخرى.',
      },
    },
    // F-003 Phase 4a scaffolding: English placeholder strings in all three
    // locale files so TS type-checking + runtime lookup work. stitch-react
    // fills in the real Arabic / Hebrew strings during Phase 4c (see
    // .dukanti/research/stitch-F-003-add-product/TASKS.md F4d-4).
    products: {
      title: 'المنتجات',
      subtitle: 'تابع النشر والتوفر لكل منتج في نافذة المنتجات المعروضة.',
      addNew: 'إضافة منتج',
      limitNote: 'عرض أول 50 منتجًا',
      summary: {
        all: 'كل المنتجات',
        published: 'منشورة',
        draft: 'مسودات',
        unavailable: 'غير متوفرة',
      },
      filters: {
        label: 'تصفية المنتجات',
        all: 'الكل',
        published: 'منشورة',
        draft: 'مسودات',
        unavailable: 'غير متوفرة',
      },
      table: {
        columns: {
          product: 'المنتج',
          category: 'التصنيف',
          price: 'السعر',
          inventory: 'المخزون',
          publication: 'النشر',
          availability: 'التوفر',
          actions: 'إجراءات',
        },
        inventory: {
          available: '{{available}} من {{inventory}} متاح',
        },
        variantSummary: {
          count: '{{count}} متغيّرات',
          active: '{{count}} نشطة',
          fromPrice: 'ابتداءً من',
          sale: 'تخفيض على متغيّر',
          disabled: 'متغيّرات غير نشطة',
          outOfStock: 'متغيّرات نفدت',
        },
        availability: {
          available: 'متوفر',
          outOfStock: 'نفدت الكمية',
        },
      },
      noResults: {
        title: 'لا توجد منتجات في هذا الفلتر',
        subtitle: 'غيّر الفلتر لعرض منتجات أخرى من أول 50 منتجًا.',
      },
      empty: {
        title: 'ابدأ بإضافة منتجك الأول',
        subtitle: 'متجرك جاهز. أضف منتجًا الآن لتبدأ البيع من دبّورية.',
        cta: 'إضافة منتج',
      },
      badge: {
        draft: 'مسودة',
        published: 'منشور',
        outOfStock: 'نفدت الكمية',
        onSale: 'تخفيض',
        discountPercent: 'خصم {{percent}}%',
      },
      card: {
        inventoryLabel: '{{count}} متوفّر',
        editAction: 'تعديل',
        deleteAction: 'حذف',
        actionsMenu: 'إجراءات المنتج',
      },
      form: {
        title: {
          new: 'إضافة منتج جديد',
          edit: 'تعديل المنتج',
        },
        nameLabel: 'اسم المنتج',
        namePlaceholder: 'مثال: زيت زيتون بكر ممتاز',
        categoryLabel: 'التصنيف',
        categoryPlaceholder: 'اختر تصنيفًا',
        categoryHint: 'كل منتج يجب أن يكون ضمن تصنيف فعّال واحد.',
        categoryLoading: 'جارٍ تحميل التصنيفات...',
        noCategoriesTitle: 'أنشئ تصنيفًا أولًا',
        noCategoriesDescription: 'يحتاج المنتج إلى تصنيف فعّال قبل حفظه.',
        noCategoriesCta: 'إدارة التصنيفات',
        descriptionLabel: 'الوصف',
        descriptionPlaceholder: 'اكتب وصفًا للمنتج...',
        priceLabel: 'السعر',
        priceHint: 'بالشيقل — حتى خانتين عشريتين',
        saleSectionTitle: 'التخفيض',
        saleEnabledLabel: 'تفعيل سعر مخفّض لهذا المنتج',
        salePriceLabel: 'سعر التخفيض',
        salePriceHint: 'يجب أن يكون أقل من السعر العادي',
        currencyLabel: 'العملة',
        inventoryLabel: 'الكمية المتوفرة',
        inventoryHint: 'أدخل 0 إذا كان المنتج غير متوفر',
        barcodeLabel: 'باركود المنتج',
        barcodePlaceholder: 'مثال: ABC-12345',
        barcodeHint: 'اختياري. اقبل الحروف والأرقام وبعض الرموز الآمنة فقط.',
        barcodeCameraAriaLabel: 'مسح باركود المنتج بالكاميرا',
        imagesLabel: 'صور المنتج',
        imagesHint: 'JPEG أو PNG أو WEBP — حتى 5 صور، بحجم أقصى 4 ميغابايت لكل صورة',
        imageAdd: 'إضافة صورة',
        imageRemove: 'إزالة الصورة',
        imageMoveUp: 'تحريك للأعلى',
        imageMoveDown: 'تحريك للأسفل',
        imageDragHandle: 'اسحب لإعادة الترتيب',
        imageRetry: 'إعادة المحاولة',
        imageUploading: 'جارٍ رفع الصورة...',
        imageSlotAlt: 'صورة المنتج رقم {{index}}',
        imagePosition: 'الموضع {{current}}',
        modeSectionTitle: 'طريقة البيع',
        mode: {
          simple: {
            label: 'منتج بسيط',
            hint: 'سعر واحد وكمية واحدة.',
          },
          options: {
            label: 'منتج مع خيارات',
            hint: 'مقاسات أو ألوان أو عبوات أو أي تركيبة.',
          },
        },
        variantsTitle: 'الخيارات والمتغيّرات',
        variantsHint: 'أضف قيم الخيارات لإنشاء صفوف المتغيّرات القابلة للبيع تلقائيًا.',
        templates: {
          title: 'ابدأ من قالب',
          active: 'القالب المختار: {{template}}',
          selected: 'مختار',
          sizes: {
            label: 'المقاسات',
            hint: 'صغير، متوسط، كبير.',
            optionName: 'المقاس',
            valueSmall: 'صغير',
            valueMedium: 'متوسط',
            valueLarge: 'كبير',
          },
          colors: {
            label: 'الألوان',
            hint: 'خيارات ألوان شائعة.',
            optionName: 'اللون',
            valueBlack: 'أسود',
            valueWhite: 'أبيض',
            valueGreen: 'أخضر',
          },
          sizeColor: {
            label: 'المقاس واللون',
            hint: 'إنشاء كل تركيبات المقاس واللون.',
          },
          packageQuantity: {
            label: 'كمية العبوة',
            hint: 'قطعة واحدة أو عبوات متعددة.',
            optionName: 'العبوة',
            valueSingle: 'قطعة واحدة',
            valuePack6: 'عبوة 6',
            valuePack12: 'عبوة 12',
          },
          supplement: {
            label: 'مكمّل',
            hint: 'التركيز وعدد الكبسولات.',
            strengthOptionName: 'التركيز',
            packageOptionName: 'الكبسولات',
            value500mg: '500mg',
            value1000mg: '1000mg',
            value30Capsules: '30 كبسولة',
            value60Capsules: '60 كبسولة',
          },
          volumeWeight: {
            label: 'الحجم أو الوزن',
            hint: 'مقاسات القناني أو المشروبات أو الطعام.',
            optionName: 'الكمية',
            value250ml: '250ml',
            value500ml: '500ml',
            value1kg: '1kg',
          },
          custom: {
            label: 'مخصص',
            hint: 'ابنِ قيم الخيارات بنفسك.',
            optionName: 'الخيار',
            valueOne: 'القيمة',
          },
        },
        addOption: 'إضافة خيار',
        removeOption: 'إزالة الخيار',
        optionGroupLabel: 'مجموعة الخيار {{number}}',
        optionNameLabel: 'اسم الخيار',
        optionNamePlaceholder: 'المقاس، اللون، العبوة...',
        optionValuePlaceholder: 'قيمة الخيار',
        addOptionValue: 'إضافة قيمة',
        removeOptionValue: 'إزالة القيمة',
        variantColumn: 'المتغيّر',
        variantPriceColumn: 'السعر',
        variantSaleColumn: 'التخفيض',
        variantInventoryColumn: 'الكمية',
        variantBarcodeColumn: 'الباركود',
        variantActiveColumn: 'نشط',
        variantImageColumn: 'الصورة',
        variantDefaultColumn: 'افتراضي',
        variantImageNone: 'الصورة الافتراضية',
        variantImageUnavailable: 'ارفع صور المنتج قبل ربط صورة بالمتغيّر.',
        variantSaleToggle: 'تخفيض',
        variantEmpty: 'أضف قيمة خيار مسماة واحدة على الأقل لإنشاء المتغيّرات.',
        variantUnnamed: 'المتغيّر {{number}}',
        variantPriceAriaLabel: 'سعر {{variant}}',
        variantSaleToggleAriaLabel: 'تفعيل التخفيض لـ {{variant}}',
        variantSalePriceAriaLabel: 'سعر التخفيض لـ {{variant}}',
        variantInventoryAriaLabel: 'كمية {{variant}}',
        variantBarcodeAriaLabel: 'باركود {{variant}}',
        variantBarcodeCameraAriaLabel: 'مسح باركود {{variant}} بالكاميرا',
        variantActiveAriaLabel: 'تفعيل {{variant}}',
        variantImageAriaLabel: 'صورة {{variant}}',
        variantDefaultAriaLabel: 'تعيين {{variant}} كافتراضي',
        submitCreate: 'حفظ المنتج',
        submitEdit: 'حفظ التغييرات',
        submitting: 'جارٍ الحفظ...',
        cancel: 'إلغاء',
        back: 'العودة إلى المنتجات',
      },
      delete: {
        title: 'حذف المنتج؟',
        // `<name>{{name}}</name>` is interpolated by react-i18next's <Trans>
        // component in delete-product-dialog.tsx — the <name> wrapper
        // renders the product name in Amiri semibold so it stands out
        // within the paragraph. Keep the `<name>...</name>` markup intact
        // in every locale.
        description: 'هل أنت متأكد من حذف <name>{{name}}</name>؟ لا يمكن التراجع عن هذا الإجراء.',
        confirm: 'حذف',
        confirming: 'جارٍ الحذف...',
        cancel: 'إلغاء',
      },
      barcodeConfirm: {
        replaceConfirm: { title: 'admin.products.barcode.replaceConfirm.title' },
        clearConfirm: { title: 'admin.products.barcode.clearConfirm.title' },
        replaceTitle: 'استبدال الباركود؟',
        replaceDescription: 'الباركود القديم لن يفتح هذا الصنف بعد الحفظ.',
        clearTitle: 'حذف الباركود؟',
        clearDescription: 'لن يتمكن الموظفون من إيجاد هذا الصنف بالباركود بعد الحفظ.',
        deletedTitle: 'استخدام باركود لصنف محذوف؟',
        deletedDescription: 'هذا الباركود كان مرتبطًا بمنتج أو صنف محذوف. أكّد لاستخدامه هنا.',
        oldBarcode: 'الباركود القديم',
        newBarcode: 'الباركود الجديد',
        confirm: 'تأكيد',
        cancel: 'إلغاء',
      },
      detail: {
        notFoundTitle: 'المنتج غير موجود',
        notFoundDescription: 'ربما تم حذفه أو أن الرابط غير صحيح',
        notFoundCta: 'العودة إلى المنتجات',
        backToList: 'المنتجات',
        editAction: 'تعديل',
        deleteAction: 'حذف',
        statusLabel: 'الحالة',
        priceLabel: 'السعر',
        categoryLabel: 'التصنيف',
        categoryMissing: 'لا يوجد تصنيف مرتبط',
        inventoryInStock: '{{count}} متوفر',
        inventoryLow: 'متبقي: {{count}}',
        inventoryOutOfStock: 'غير متوفر',
        descriptionLabel: 'الوصف',
        galleryLabel: 'معرض صور المنتج',
        thumbnailLabel: 'صورة {{index}}',
        noImagesLabel: 'لا توجد صور لهذا المنتج',
        loadingLabel: 'جارٍ تحميل المنتج...',
      },
      errors: {
        nameRequired: 'اسم المنتج مطلوب',
        nameTooLong: 'يجب ألا يتجاوز اسم المنتج 200 حرف',
        nameInvalid: 'اسم المنتج يحتوي على أحرف غير مسموح بها',
        descriptionInvalid: 'الوصف يحتوي على أحرف غير مسموح بها',
        priceRequired: 'السعر مطلوب',
        priceInvalid: 'السعر يجب أن يكون رقمًا موجبًا بخانتين عشريتين كحد أقصى',
        salePriceInvalid: 'سعر التخفيض يجب أن يكون رقمًا موجبًا وأقل من السعر العادي',
        inventoryInvalid: 'يجب أن تكون الكمية رقمًا صحيحًا غير سالب',
        categoryRequired: 'اختر تصنيفًا لهذا المنتج',
        imageTooLarge: 'حجم الصورة كبير جدًا (الحد الأقصى 2 ميغابايت). اختر صورة أصغر.',
        imageInvalidType: 'يجب أن تكون الصورة من نوع JPEG أو PNG أو WEBP',
        tooManyImages: 'يمكن إضافة 5 صور كحد أقصى لكل منتج',
        storageQuotaExceeded:
          'تم تجاوز حد التخزين للمتجر (الحد الأقصى 50 ميغابايت). احذف بعض الصور لتحرير المساحة.',
        imageUploadFailed: 'فشل رفع الصورة. يرجى المحاولة مجددًا.',
        barcodeInvalid: 'الباركود يحتوي على أحرف غير مسموحة.',
        barcodeTooLong: 'الباركود يجب ألا يتجاوز 80 حرفًا.',
        barcodeDuplicate: 'هذا الباركود مستخدم في صنف آخر.',
        barcodeDeletedConflict: 'أكد استخدام باركود كان مرتبطًا بصنف محذوف.',
        barcodeChangedElsewhere: 'تغير الباركود في مكان آخر. حدّث الصفحة وحاول مرة أخرى.',
        barcodeReplaceConfirmationRequired: 'أكد استبدال الباركود قبل الحفظ.',
        barcodeClearConfirmationRequired: 'أكد حذف الباركود قبل الحفظ.',
        activeOrderedOrders: 'عالِج الطلبات الجديدة المرتبطة بهذا المنتج قبل تعديله.',
        // DEPRECATED: use common.errors.networkFailed
        networkFailed: 'لم نتمكّن من تحميل المنتجات. يرجى المحاولة مجدّدًا.',
        notFound: 'المنتج غير موجود',
        // DEPRECATED: use common.errors.permissionDenied
        permissionDenied: 'ليس لديك صلاحية للقيام بذلك',
        // DEPRECATED: use common.errors.unknown
        unknown: 'حدث خطأ، يرجى المحاولة مجددًا',
      },
      variants: {
        errors: {
          optionNameRequired: 'اسم الخيار مطلوب',
          optionValueRequired: 'قيمة الخيار مطلوبة',
          duplicateOptionValue: 'قيمة الخيار مكررة',
          duplicateCombination: 'تركيبة الخيارات مكررة',
          tooManyOptions: 'يمكن إضافة ثلاثة خيارات كحد أقصى',
          tooManyValues: 'عدد قيم الخيارات كبير جدًا',
          tooManyVariants: 'يمكن إنشاء 100 متغيّر كحد أقصى',
          noActiveVariant: 'يجب أن يحتوي المنتج على متغيّر نشط واحد على الأقل',
          imageMismatch: 'صورة المتغيّر يجب أن تكون من صور المنتج نفسه',
          cannotDeleteOptionValue: 'لا يمكن حذف قيمة مستخدمة في متغيّرات حالية',
        },
      },
      toasts: {
        created: 'تم إنشاء المنتج',
        updated: 'تم تحديث المنتج',
        deleted: 'تم حذف المنتج',
        imagesPartialFailure: 'تم حفظ المنتج، لكن فشل رفع بعض الصور',
      },
      // F-028 Per-Product Publish Toggle — values
      publish: {
        buttons: {
          publish: 'نشر',
          unpublish: 'إخفاء',
          publishing: 'جارٍ النشر…',
          unpublishing: 'جارٍ الإخفاء…',
        },
        publishModal: {
          title: 'نشر هذا المنتج؟',
          description: 'سيظهر هذا المنتج في متجرك فورًا.',
          urlLabel: 'سيراه العملاء على:',
          confirm: 'نشر المنتج',
        },
        unpublishModal: {
          title: 'إخفاء هذا المنتج؟',
          description: 'لن يظهر هذا المنتج في متجرك بعد الآن. يمكنك إعادة نشره في أي وقت.',
          urlLabel: 'سيتوقف هذا الرابط عن العمل:',
          confirm: 'إخفاء المنتج',
          stay: 'الإبقاء على النشر',
        },
        disabled: {
          storeNotPublished: 'انشر متجرك أولًا.',
          storeNotPublishedCta: 'الذهاب إلى لوحة التحكم',
          insufficientInventory: 'أضف مخزونًا للنشر.',
          insufficientInventoryCta: 'تعديل المنتج',
          categoryRequired: 'اختر تصنيفًا قبل النشر.',
          categoryRequiredCta: 'تعديل المنتج',
          categoryRequiredCreateCta: 'إنشاء تصنيف',
        },
        errors: {
          storeNotPublished: 'انشر متجرك أولًا.',
          insufficientInventory: 'لا يوجد مخزون لهذا المنتج. أضف مخزونًا قبل النشر.',
          categoryRequired: 'اختر تصنيفًا فعّالًا قبل نشر هذا المنتج.',
          permissionDenied: 'ليس لديك صلاحية نشر هذا المنتج.',
          notFound: 'هذا المنتج لم يعد موجودًا.',
          networkFailed: 'خطأ في الشبكة. الرجاء المحاولة مرة أخرى.',
          unknown: 'حدث خطأ ما. حاول مجددًا.',
        },
        toasts: {
          published: 'تم نشر المنتج.',
          unpublished: 'تم إخفاء المنتج.',
        },
        card: {
          menuPublish: 'نشر',
          menuUnpublish: 'إخفاء',
        },
      },
    },
    categories: {
      title: 'التصنيفات',
      subtitle: 'نظّم كتالوج متجرك في التصنيفات التي ستظهر مع المنتجات.',
      addNew: 'إضافة تصنيف',
      loading: 'جارٍ تحميل التصنيفات...',
      empty: {
        title: 'أنشئ تصنيفك الأول',
        subtitle: 'التصنيفات تجعل نشر المنتجات مضبوطًا وتجهّز كتالوج واجهة المتجر.',
        cta: 'إضافة تصنيف',
      },
      list: {
        order: 'الموضع {{order}}',
      },
      actions: {
        edit: 'تعديل {{name}}',
        delete: 'حذف {{name}}',
        moveUp: 'تحريك {{name}} للأعلى',
        moveDown: 'تحريك {{name}} للأسفل',
      },
      form: {
        title: {
          create: 'إضافة تصنيف',
          edit: 'تعديل التصنيف',
        },
        description: {
          create: 'اكتب اسم التصنيف ويمكنك إضافة صورة ووصف عامين اختياريين.',
          edit: 'حدّث اسم التصنيف أو صورته أو وصفه العام.',
        },
        nameLabel: 'اسم التصنيف',
        namePlaceholder: 'مثال: زيت الزيتون',
        publicDescription: {
          legend: 'الأوصاف العامة',
          help: 'اكتب نصا قصيرا اختياريا يظهر للزبائن في واجهة المتجر عند تفعيل عرضه.',
          arLabel: 'الوصف بالعربية',
          heLabel: 'الوصف بالعبرية',
          enLabel: 'الوصف بالإنجليزية',
          placeholder: 'مثال: مختارات طازجة من المتجر',
        },
        mediaUpload: 'رفع صورة',
        mediaReplace: 'استبدال الصورة',
        mediaRemove: 'إزالة الصورة',
        mediaHint: 'JPEG أو PNG أو WEBP أو GIF، حتى 2MB',
        mediaPreviewAlt: 'معاينة صورة التصنيف',
        submitCreate: 'إنشاء التصنيف',
        submitEdit: 'حفظ التغييرات',
      },
      delete: {
        title: 'حذف هذا التصنيف؟',
        description: 'سيتم حذف {{name}} من تصنيفات متجرك.',
        confirm: 'حذف التصنيف',
        assignedProductsRecovery: 'انقل المنتجات المرتبطة بهذا التصنيف قبل حذفه.',
      },
      toasts: {
        created: 'تم إنشاء التصنيف',
        updated: 'تم تحديث التصنيف',
        deleted: 'تم حذف التصنيف',
        reordered: 'تم تحديث ترتيب التصنيفات',
      },
      errors: {
        nameRequired: 'اسم التصنيف مطلوب',
        nameTooLong: 'اسم التصنيف يجب ألا يتجاوز 80 حرفًا',
        nameInvalid: 'اسم التصنيف يحتوي على أحرف غير مسموح بها',
        descriptionTooLong: 'وصف التصنيف يجب ألا يتجاوز 240 حرفا لكل لغة',
        descriptionInvalid: 'وصف التصنيف يجب أن يكون نصا عاديا بلا روابط أو تنسيق أو رموز مخفية',
        nameDuplicate: 'يوجد تصنيف فعّال بهذا الاسم بالفعل',
        imageInvalidType: 'يجب أن يكون الملف JPEG أو PNG أو WEBP أو GIF',
        imageTooLarge: 'حجم الصورة كبير جدًا (الحد الأقصى 2MB). اختر صورة أصغر.',
        imageUploadFailed: 'فشل رفع صورة التصنيف. حاول مرة أخرى.',
        storageQuotaExceeded:
          'تم تجاوز حد التخزين للمتجر (الحد الأقصى 50 ميغابايت). احذف بعض الصور لتحرير المساحة.',
        assignedProducts: 'هذا التصنيف مرتبط بمنتجات حاليًا.',
        permissionDenied: 'ليس لديك صلاحية إدارة هذا التصنيف.',
        notFound: 'هذا التصنيف لم يعد موجودًا.',
        reorderInvalid: 'تغيّر ترتيب التصنيفات. حدّث الصفحة وحاول مرة أخرى.',
      },
    },
    promotionalAds: {
      title: 'إعلانات واجهة المتجر',
      subtitle: 'أضف صور عروض تظهر أعلى صفحة المتجر.',
      addNew: 'إضافة إعلان',
      legacyNotice:
        'متجرك يستخدم الآن قالب تصميم، لذلك لم تعد هذه الإعلانات تظهر في متجرك. لتغيير البانرات والصور، افتح <storefrontLink>واجهة المتجر</storefrontLink> وفعّل <editMode>وضع التعديل</editMode>. الإعلانات القديمة محفوظة هنا للاطلاع فقط.',
      readOnlyStaffNotice: 'يمكن لمالك المتجر أو المدير فقط تعديل الإعلانات.',
      accessLoadError: 'تعذّر تحميل إعدادات الإعلانات. تحقّق من اتصالك وحاول مرة أخرى.',
      marketingTabsLabel: 'أقسام التسويق',
      empty: {
        title: 'لا توجد إعلانات بعد',
        subtitle: 'ابدأ بصورة عرض واحدة لتظهر في أعلى واجهة المتجر.',
      },
      list: {
        untitled: 'إعلان بدون عنوان',
      },
      form: {
        title: {
          create: 'إضافة إعلان',
          edit: 'تعديل الإعلان',
        },
        mediaLabel: 'صورة الإعلان',
        mediaHint: 'WEBP أو JPEG أو PNG أو GIF، حتى 4MB. النسبة المفضلة قريبة من 3:1.',
        titleLabel: 'العنوان',
        titlePlaceholder: 'مثال: تخفيضات نهاية الأسبوع',
        altLabel: 'النص البديل',
        altPlaceholder: 'صف ما يظهر في الصورة',
        back: 'العودة إلى الإعلانات',
        pageTitleCreate: 'إنشاء إعلان ترويجي',
        pageTitleEdit: 'تعديل إعلان ترويجي',
        destinationLabel: 'رابط خارجي',
        destinationPlaceholder: 'https://example.com',
        activeLabel: 'إظهار الإعلان في واجهة المتجر',
        submitCreate: 'إنشاء الإعلان',
        submitEdit: 'حفظ التغييرات',
      },
      destination: {
        title: 'الوجهة',
        description: 'اختر ما يفتح عندما يضغط المتسوق على الإعلان.',
        typeLabel: 'نوع الوجهة',
        none: 'بدون رابط',
        noneDescription: 'اعرض الصورة بدون انتقال.',
        sales: 'صفحة العروض',
        salesDescription: 'افتح منتجات العروض في هذا المتجر.',
        category: 'تصنيف',
        categoryDescription: 'وجّه المتسوقين إلى تصنيف ظاهر للزبائن.',
        product: 'منتج',
        productDescription: 'وجّه المتسوقين إلى صفحة منتج.',
        external: 'إنستغرام أو فيسبوك',
        externalDescription: 'افتح صفحة أو منشورًا اجتماعيًا موثوقًا.',
        externalLabel: 'رابط إنستغرام أو فيسبوك',
        externalPlaceholder: 'https://www.instagram.com/store-name',
        categorySearchLabel: 'بحث في التصنيفات',
        categorySearchPlaceholder: 'اسم التصنيف',
        productSearchLabel: 'بحث في المنتجات',
        productSearchPlaceholder: 'اسم المنتج',
        productCategoryFilterLabel: 'تصفية المنتجات حسب التصنيف',
        productCategoryFilterButton: 'تصفية: {{name}}',
        productCategoryFilterAll: 'كل المنتجات',
        productCategoryFilterSearchLabel: 'بحث في تصنيفات المنتجات',
        productCategoryFilterSearchPlaceholder: 'بحث في التصنيفات',
        categoryEmpty: 'لا توجد تصنيفات مطابقة',
        productEmpty: 'لا توجد منتجات مطابقة',
        categoryUnavailable: 'هذا التصنيف غير متاح في واجهة المتجر.',
        productUnavailable: 'هذا المنتج غير متاح في واجهة المتجر.',
        selectedCategory: 'التصنيف المحدد: {{name}}',
        selectedProduct: 'المنتج المحدد: {{name}}',
        clearSelection: 'مسح الاختيار',
        summary: {
          noLink: 'بدون رابط',
          sales: 'صفحة العروض',
          category: 'تصنيف: {{value}}',
          product: 'منتج: {{value}}',
          external: 'خارجي: {{value}}',
          unavailable: 'وجهة غير متاحة',
        },
      },
      pickers: {
        loadingCategories: 'جارٍ تحميل التصنيفات...',
        loadingProducts: 'جارٍ تحميل المنتجات...',
        retryCategories: 'إعادة تحميل التصنيفات',
        retryProducts: 'إعادة تحميل المنتجات',
        productStatus: {
          published: 'منشور',
          draft: 'مسودة',
        },
        availability: {
          inStock: 'متوفر',
          outOfStock: 'غير متوفر',
        },
      },
      actions: {
        edit: 'تعديل {{title}}',
        delete: 'حذف {{title}}',
        moveUp: 'تحريك {{title}} للأعلى',
        moveDown: 'تحريك {{title}} للأسفل',
      },
      status: {
        active: 'فعّال',
        inactive: 'غير فعّال',
      },
      delete: {
        title: 'حذف هذا الإعلان؟',
        description: 'لن يظهر هذا الإعلان في واجهة المتجر بعد الحذف.',
        confirm: 'حذف الإعلان',
      },
      toasts: {
        created: 'تم إنشاء الإعلان',
        updated: 'تم تحديث الإعلان',
        deleted: 'تم حذف الإعلان',
        reordered: 'تم تحديث ترتيب الإعلانات',
      },
      errors: {
        mediaRequired: 'ارفع صورة للإعلان',
        mediaInvalidType: 'يجب أن يكون الملف WEBP أو JPEG أو PNG أو GIF فقط',
        mediaTooLarge: 'الصورة أكبر من 4MB',
        mediaDimensionsInvalid: 'أبعاد الصورة لا تناسب إعلان واجهة المتجر',
        titleTooLong: 'العنوان يجب ألا يتجاوز 80 حرفًا',
        titleInvalid: 'العنوان يحتوي على رموز تحكم غير مدعومة',
        altTooLong: 'النص البديل يجب ألا يتجاوز 160 حرفًا',
        altInvalid: 'النص البديل يحتوي على رموز تحكم غير مدعومة',
        destinationInvalid: 'استخدم رابط HTTPS آمن',
        destinationTypeRequired: 'اختر نوع الوجهة',
        categoryRequired: 'اختر تصنيفًا',
        productRequired: 'اختر منتجًا',
        externalHttpsRequired:
          'أدخل رابط HTTPS صحيحًا من إنستغرام أو فيسبوك بدون مسافات أو بيانات دخول',
        destinationTargetUnavailable: 'اختر وجهة متاحة في واجهة المتجر',
        tooManyAds: 'يمكنك الاحتفاظ حتى 10 إعلانات',
        tooManyActiveAds: 'يمكن تفعيل حتى 5 إعلانات فقط',
        storageQuotaExceeded: 'تم تجاوز حد التخزين للمتجر. احذف بعض الصور لتحرير المساحة.',
        permissionDenied: 'ليس لديك صلاحية إدارة هذا الإعلان',
        notFound: 'هذا الإعلان لم يعد موجودًا',
        reorderInvalid: 'تغيّر ترتيب الإعلانات. حدّث الصفحة وحاول مرة أخرى.',
      },
    },
    /** Epic #228 P5: the shared Admin DestinationEditor (aliases reuse promotionalAds / websiteTemplates copy). */
    destination: {
      pickCategory: 'اختر تصنيفًا من القائمة.',
      pickProduct: 'اختر منتجًا من القائمة.',
      pickCollection: 'اختر مجموعة.',
      finishToSave: 'أكمل اختيارك ليتم الحفظ',
      incompleteTitle: 'هذا الرابط غير مكتمل',
      incomplete: {
        category: 'اختر تصنيفًا أو وجهة أخرى. إذا غادرت الآن، يبقى الرابط كما كان.',
        product: 'اختر منتجًا أو وجهة أخرى. إذا غادرت الآن، يبقى الرابط كما كان.',
        collection: 'اختر مجموعة أو وجهة أخرى. إذا غادرت الآن، يبقى الرابط كما كان.',
        external:
          'أدخل رابط إنستغرام أو فيسبوك أو اختر وجهة أخرى. إذا غادرت الآن، يبقى الرابط كما كان.',
      },
      leaveUnchanged: 'المغادرة دون تغيير الرابط',
      externalRefused:
        'لا يمكن استخدام هذا الرابط. الصق عنوان صفحة أو منشور على إنستغرام أو فيسبوك.',
      unavailableNext: 'اختر عنصرًا آخر أدناه، أو اختر وجهة مختلفة.',
      labelMissing: 'أضف نصًا للزر حتى يتمكن المتسوقون من الضغط على هذا الرابط.',
      title: 'الوجهة',
      typeLabel: 'نوع الوجهة',
      none: 'بدون رابط',
      noneDescription: 'لا يُفتح شيء عند الضغط.',
      sales: 'صفحة العروض',
      salesDescription: 'افتح منتجات العروض في هذا المتجر.',
      category: 'تصنيف',
      categoryDescription: 'وجّه المتسوقين إلى تصنيف ظاهر للزبائن.',
      product: 'منتج',
      productDescription: 'وجّه المتسوقين إلى صفحة منتج.',
      external: 'إنستغرام أو فيسبوك',
      externalDescription: 'افتح صفحة أو منشورًا اجتماعيًا موثوقًا.',
      storePage: 'صفحة في المتجر',
      storePageDescription: 'افتح صفحة أخرى من متجرك.',
      collection: 'مجموعة',
      collectionDescription: 'وجّه المتسوقين إلى مجموعة منتجات.',
      contact: 'التواصل',
      contactDescription: 'دع المتسوقين يراسلونك أو يتصلون بك.',
      more: 'وجهات أخرى',
      fewer: 'وجهات أقل',
      externalLabel: 'رابط إنستغرام أو فيسبوك',
      externalPlaceholder: 'https://www.instagram.com/store-name',
      externalHint: 'تعمل روابط instagram.com و facebook.com فقط.',
      externalRequired: 'أدخل رابط إنستغرام أو فيسبوك',
      externalHttpsRequired: 'يجب أن يبدأ الرابط بـ https://',
      externalHostUnsupported: 'يُسمح فقط بروابط إنستغرام وفيسبوك',
      externalTooLong: 'الرابط طويل جدًا (256 حرفًا كحد أقصى)',
      externalInvalid: 'يحتوي الرابط على رموز غير مسموح بها',
      invalid: 'اختر وجهة هذا الرابط.',
      unavailable: 'هذا العنصر لم يعد متاحًا. لن يُنقل الزبائن إلى أي مكان.',
      unavailableBadge: 'غير متاح',
      selectedCategory: 'التصنيف المحدد: {{name}}',
      selectedProduct: 'المنتج المحدد: {{name}}',
      selectedUnknown: 'العنصر المحدد',
      chooseCategory: 'اختر فئة',
      chooseProduct: 'اختر منتجًا',
      chooseCollection: 'اختر مجموعة',
      categorySearchLabel: 'بحث في التصنيفات',
      categorySearchPlaceholder: 'اسم التصنيف',
      productSearchLabel: 'بحث في المنتجات',
      productSearchPlaceholder: 'اسم المنتج',
      productCategoryFilterButton: 'تصفية: {{name}}',
      productCategoryFilterAll: 'كل المنتجات',
      productCategoryFilterSearchLabel: 'بحث في تصنيفات المنتجات',
      productCategoryFilterSearchPlaceholder: 'بحث في التصنيفات',
      categoryEmpty: 'لا توجد تصنيفات مطابقة',
      productEmpty: 'لا توجد منتجات مطابقة',
      noCategories: 'لا توجد تصنيفات بعد. أضف تصنيفًا من صفحة التصنيفات، أو اختر وجهة أخرى.',
      noProducts: 'لا توجد منتجات بعد. أضف منتجًا من صفحة المنتجات، أو اختر وجهة أخرى.',
      noCollections: 'لا توجد مجموعات للاختيار بعد.',
      loadingCategories: 'جارٍ تحميل التصنيفات...',
      loadingProducts: 'جارٍ تحميل المنتجات...',
      retryCategories: 'إعادة تحميل التصنيفات',
      retryProducts: 'إعادة تحميل المنتجات',
      inStock: 'متوفر',
      outOfStock: 'غير متوفر',
      storePageLabel: 'الصفحة',
      contactLabel: 'طريقة التواصل',
      page: {
        home: 'الرئيسية',
        catalog: 'قائمة المنتجات',
        shop: 'تسوّق جميع المنتجات',
        storeInfo: 'معلومات المتجر',
      },
      method: {
        whatsapp: 'واتساب',
        phone: 'الهاتف',
      },
      summary: {
        noLink: 'بدون رابط',
        sales: 'صفحة العروض',
        category: 'تصنيف: {{value}}',
        product: 'منتج: {{value}}',
        collection: 'مجموعة: {{value}}',
        external: 'خارجي: {{value}}',
        unavailable: 'وجهة غير متاحة',
        storePage: {
          home: 'الرئيسية',
          catalog: 'قائمة المنتجات',
          shop: 'تسوّق جميع المنتجات',
          storeInfo: 'معلومات المتجر',
        },
        contact: {
          whatsapp: 'واتساب',
          phone: 'الهاتف',
          email: 'البريد الإلكتروني',
        },
      },
    },
    couriers: {
      title: 'المندوبون',
      count: '{{count}} مندوب',
      create: 'إضافة مندوب',
      edit: 'تعديل المندوب',
      active: 'نشط',
      inactive: 'غير نشط',
      empty: {
        title: 'لا يوجد مندوبون بعد',
        description: 'أضف مندوبي التوصيل الموثوقين لتعيين الطلبات بدون نسخ التفاصيل يدويًا.',
      },
      nameLabel: 'اسم المندوب',
      phoneLabel: 'رقم الهاتف',
      internalNotesLabel: 'ملاحظات داخلية',
      actions: {
        create: 'إضافة مندوب',
        edit: 'تعديل المندوب',
        activate: 'تفعيل المندوب',
        deactivate: 'إيقاف المندوب',
        delete: 'حذف المندوب',
      },
      columns: {
        name: 'الاسم',
        phone: 'الهاتف',
        status: 'الحالة',
        createdAt: 'أُضيف في',
        actions: 'إجراءات',
      },
      status: {
        active: 'نشط',
        inactive: 'غير نشط',
      },
      form: {
        title: {
          create: 'إضافة مندوب',
          edit: 'تعديل المندوب',
        },
        description: 'أدخل بيانات المندوب لاستخدامها عند تعيين الطلبات وإرسال روابط التوصيل.',
        nameLabel: 'اسم المندوب',
        phoneLabel: 'رقم الهاتف',
        notesLabel: 'ملاحظات داخلية',
        activeLabel: 'المندوب نشط',
        save: 'حفظ المندوب',
      },
      delete: {
        title: 'حذف المندوب؟',
        description: 'سيتم إيقاف {{name}} مع إبقاء سجل التوصيلات السابق للمراجعة.',
      },
      toasts: {
        created: 'تم إنشاء المندوب',
        updated: 'تم تحديث المندوب',
        deleted: 'تم إيقاف المندوب',
      },
      verification: {
        title: 'تحقق المندوب',
        pending: 'بانتظار التحقق',
        approved: 'تم التحقق',
        sendOtp: 'إرسال رمز التحقق',
        resendOtp: 'إعادة إرسال الرمز',
        enterOtp: 'أدخل رمز التحقق',
        verify: 'تحقق',
        sent: 'تم إرسال الرمز إلى {{phone}}',
        cooldown: 'يمكنك إعادة الإرسال بعد {{time}}',
        localDebugOtp: 'رمز التطوير المحلي',
        localDebugOtpHelp: 'لن يتم إرسال رسالة SMS حقيقية محليًا. استخدم هذا الرمز للتحقق.',
      },
      portal: {
        copyLink: 'نسخ رابط البوابة',
        shareLink: 'مشاركة رابط البوابة',
        sendWhatsApp: 'إرسال عبر واتساب',
        revoke: 'إلغاء الرابط',
        regenerate: 'تجديد الرابط',
        generate: 'إنشاء الرابط',
        generated: 'تم إنشاء رابط بوابة المندوب',
        unavailablePending: 'متاح فقط للمندوبين الذين تم التحقق منهم',
        revoked: 'تم إلغاء رابط بوابة المندوب',
        regenerated: 'تم تجديد رابط بوابة المندوب',
        copied: 'تم نسخ رابط بوابة المندوب',
        whatsappMessage:
          'مرحبًا {{courierName}}، هذا رابط بوابة التوصيل الخاصة بمتجر {{storeName}}: {{portalUrl}}\n\nاحتفظ بهذا الرابط معك ولا ترسله لأي شخص آخر.',
        safetyNote: 'شارك هذا الرابط مع هذا المندوب فقط.',
        recovery: {
          title: 'رابط البوابة جاهز',
          description: 'منع المتصفح النسخ التلقائي لرابط {{courierName}}. الرابط متاح هنا.',
          linkLabel: 'رابط البوابة',
        },
        errors: {
          linkNotFound: 'لا يوجد رابط نشط لهذا المندوب.',
          unverifiedCourier: 'يجب التحقق من المندوب قبل إنشاء الرابط.',
          inactiveCourier: 'فعّل المندوب قبل إنشاء الرابط.',
          networkFailed: 'تعذر تجهيز رابط بوابة المندوب. تحقق من الاتصال وحاول مرة أخرى.',
          copyFailed: 'تعذر نسخ رابط بوابة المندوب. حاول مرة أخرى.',
        },
      },
      errors: {
        nameRequired: 'اسم المندوب مطلوب.',
        phoneInvalid: 'أدخل رقم هاتف صحيحًا مع رمز الدولة.',
        notesTooLong: 'يجب ألا تتجاوز الملاحظات الداخلية 500 حرف.',
        phoneDuplicate: 'هذا الرقم مستخدم لمندوب آخر.',
        permissionDenied: 'ليس لديك صلاحية لإدارة المندوبين.',
        networkFailed: 'تعذر تحديث المندوبين. تحقق من الاتصال وحاول مرة أخرى.',
        otpInvalid: 'الرمز غير صحيح.',
        otpExpired: 'انتهت صلاحية الرمز. أرسل رمزًا جديدًا.',
        otpCooldown: 'انتظر قبل إعادة إرسال الرمز.',
        tooManyAttempts: 'محاولات كثيرة جدًا. أرسل رمزًا جديدًا.',
        alreadyVerified: 'تم التحقق من هذا المندوب بالفعل.',
        smsUnavailable: 'تعذر إرسال الرسالة. حاول مرة أخرى.',
      },
    },
    orders: {
      fulfillment: {
        pickupOnly: 'هذا الإجراء متاح للاستلام الذاتي فقط.',
        deliveryOnly: 'هذا الإجراء متاح لطلبات التوصيل فقط.',
      },
      title: 'الطلبات',
      searchPlaceholder: 'ابحث باسم الزبون أو الهاتف أو رقم الطلب',
      sort: {
        totalDesc: 'المجموع: من الأعلى للأقل',
        totalAsc: 'المجموع: من الأقل للأعلى',
        label: 'الترتيب',
        visibleLabel: 'الترتيب:',
        createdAtDesc: 'الأحدث أولاً',
        createdAtAsc: 'الأقدم أولاً',
        subtotalDesc: 'المجموع: من الأعلى للأقل',
        subtotalAsc: 'المجموع: من الأقل للأعلى',
      },
      filter: {
        all: 'الكل',
        ordered: 'تم الطلب',
        shipped: 'تم الشحن',
        delivered: 'تم التسليم',
        cancelled: 'ملغى',
        rejected: 'مرفوض',
        awaitingApproval: 'بانتظار الموافقة',
        groupLabel: 'تصفية حسب الحالة',
      },
      columns: {
        total: 'المجموع',
        customer: 'الزبون',
        date: 'التاريخ',
        items: 'المنتجات',
        subtotal: 'المجموع',
        status: 'الحالة',
        action: 'إجراء',
      },
      empty: {
        all: {
          title: 'لا توجد طلبات بعد',
          subtitle: 'عندما يقدّم الزبائن طلبات، ستظهر هنا.',
        },
        ordered: 'لا توجد طلبات جديدة',
        shipped: 'لا توجد طلبات تم شحنها',
        delivered: 'لا توجد طلبات تم توصيلها',
        cancelled: 'لا توجد طلبات ملغاة',
        rejected: 'لا توجد طلبات مرفوضة',
        awaitingApproval: {
          title: 'لا توجد طلبات بانتظار الموافقة',
          subtitle: 'ستظهر هنا الطلبات التي تحتاج مراجعة.',
        },
      },
      loadMore: 'تحميل المزيد',
      loadingMore: 'جاري التحميل...',
      itemCount: '{{count}} منتج',
      viewOrder: 'عرض',
      viewOrderAria: 'فتح الطلب {{id}} للزبون {{customer}}',
      urgentLabel: 'عاجل',
      badge: {
        ariaLabel: '{{count}} طلب جديد',
        ariaLabelCapped: '99+ طلب جديد',
      },
      prepare: {
        title: 'تجهيز طلب',
        subtitle: 'أنشئ طلبًا من مخزون المتجر الحالي بدون فتح واجهة الزبائن.',
        openCta: 'تجهيز طلب',
        backToOrders: 'العودة إلى الطلبات',
        steps: {
          items: 'المنتجات',
          delivery: 'التوصيل',
          review: 'المراجعة',
        },
        picker: {
          title: 'اختيار المنتجات',
          searchLabel: 'البحث في المخزون',
          searchPlaceholder: 'منتج أو خيار أو باركود',
          categoryLabel: 'التصنيف',
          categoryAll: 'كل التصنيفات',
          categoryLoading: 'جارٍ تحميل التصنيفات...',
          loading: 'جارٍ البحث في المخزون...',
          empty: 'لا توجد منتجات مطابقة.',
          error: 'تعذر تحميل المخزون. حاول مرة أخرى.',
          capped: 'نعرض أول {{count}} منتجًا. ابحث لتضييق القائمة.',
          add: 'إضافة',
          selected: 'تم الاختيار',
          draft: 'غير منشور',
          barcode: 'باركود',
          stock: '{{count}} في المخزون',
          outOfStock: 'نفد المخزون',
          inactive: 'غير نشط',
          unavailable: 'غير متاح',
        },
        lines: {
          title: 'المنتجات المختارة',
          empty: 'أضف منتجًا واحدًا على الأقل لتجهيز الطلب.',
          product: 'المنتج',
          quantity: 'الكمية',
          unitPrice: 'سعر الوحدة',
          lineTotal: 'مجموع السطر',
          remove: 'إزالة المنتج',
          subtotal: 'المجموع الفرعي',
          quantityWhole: 'أدخل كمية صحيحة أكبر من صفر.',
          quantityStock: 'المتوفر في المخزون {{count}} فقط.',
        },
        delivery: {
          title: 'تفاصيل التوصيل',
          customerName: 'اسم الزبون',
          customerNameOptional: 'اسم الزبون (اختياري)',
          customerNamePlaceholder: 'اسم المستلم',
          phoneCountry: 'الدولة',
          phoneNumber: 'رقم الهاتف',
          phonePlaceholder: '050 123 4567',
          locality: 'البلدة أو المدينة',
          localityPlaceholder: 'ابحث عن بلدة',
          localityEmpty: 'لم يتم العثور على بلدات.',
          addressLine1: 'العنوان أو وصف التوصيل',
          addressLine1Optional: 'العنوان أو وصف التوصيل (اختياري)',
          addressLine1Placeholder: 'شارع، بيت، علامة، أو تعليمات توصيل',
          notes: 'ملاحظات الطلب',
          notesPlaceholder: 'ملاحظات اختيارية للمتجر أو المندوب',
        },
        review: {
          title: 'مراجعة الطلب',
          deliverySummary: 'ملخص التوصيل',
          noPaymentNotice: 'لا يتم تحصيل دفع إلكتروني لهذا الطلب المجهّز.',
          create: 'إنشاء الطلب',
          creating: 'جارٍ إنشاء الطلب...',
          editItems: 'تعديل المنتجات',
          editDelivery: 'تعديل التوصيل',
          requirementsTitle: 'أكمل هذه المتطلبات قبل إنشاء الطلب:',
        },
        success: {
          created: 'تم إنشاء الطلب المجهّز.',
        },
        errors: {
          noLines: 'أضف منتجًا واحدًا على الأقل.',
          quantityInvalid: 'أدخل كميات صحيحة أكبر من صفر وضمن المخزون.',
          insufficientStock: 'بعض المنتجات المختارة لم يعد مخزونها كافيًا.',
          deletedProduct: 'بعض المنتجات المختارة لم تعد متاحة.',
          inactiveVariant: 'بعض الأصناف المختارة غير نشطة.',
          variantUnavailable: 'بعض المنتجات المختارة لم تعد متاحة.',
          customerNameRequired: 'أدخل اسم الزبون.',
          phoneRequired: 'أدخل رقم هاتف الزبون.',
          phoneInvalid: 'أدخل رقم هاتف صالحًا مع رمز الدولة.',
          localityRequired: 'اختر البلدة أو المدينة.',
          localityInvalid: 'اختر بلدة أو مدينة فعّالة.',
          addressRequired: 'أدخل العنوان أو وصف التوصيل.',
          addressTooLong: 'العنوان أو وصف التوصيل طويل جدًا.',
          unauthorized: 'لا تملك صلاحية إنشاء هذا الطلب.',
          networkFailed: 'فشل الاتصال. حاول مرة أخرى.',
          unknown: 'تعذر إنشاء الطلب المجهّز.',
        },
      },
      shippingLabel: {
        open: 'طباعة ملصق الشحن',
        title: 'ملصق الشحن',
        backToOrder: 'العودة إلى الطلب',
        print: 'طباعة',
        printAria: 'طباعة ملصق الشحن لهذا الطلب',
        previewHeading: 'معاينة الملصق',
        loading: 'جارٍ تحميل الملصق...',
        notFoundTitle: 'تعذر فتح الملصق',
        notFoundDescription: 'قد يكون الطلب غير موجود أو لا تملك صلاحية الوصول إليه.',
        manualApprovalBlockedTitle: 'الموافقة مطلوبة أولاً',
        manualApprovalBlockedDescription: 'وافق على هذا الطلب قبل طباعة ملصق الشحن.',
        retry: 'إعادة المحاولة',
        fields: {
          order: 'الطلب',
          package: 'الطرد',
          packageTotal: 'مبلغ الطرد',
          batch: 'دفعة التوصيل',
          recipient: 'المستلم',
          phone: 'الهاتف',
          destination: 'الوجهة',
          address: 'العنوان',
          deliveryInformation: 'معلومات التوصيل',
          preciseLocation: 'الموقع الدقيق',
          sender: 'المرسل',
          senderPhone: 'هاتف المرسل',
          notes: 'ملاحظات التوصيل',
          printedAt: 'تاريخ الطباعة',
        },
        noCourierAssignment: 'لا يوجد مندوب معيّن لهذا الطلب',
        singleOrderNotice: 'هذا الملصق مخصص لهذا الطلب فقط.',
      },
      courierAssignment: {
        title: 'تعيين المندوب',
        assign: 'تعيين مندوب',
        bulkAssign: 'تعيين المندوب',
        unassign: 'إلغاء تعيين المندوب',
        bulkUnassign: 'إلغاء تعيين المندوب',
        unassigned: 'تم إلغاء تعيين المندوب.',
        assignedTo: 'مُعيّن إلى {{name}}',
        packageTag: 'الطرد {{tag}}',
        selectedCount: '{{count}} محدد',
        noAutoShipNotice: 'تعيين مندوب لا يغيّر حالة الطلب إلى تم الشحن.',
        manualApprovalRequiredNotice: 'وافق على هذا الطلب قبل تعيين مندوب.',
        currentlyAssigned: 'مُعيّن بالفعل إلى {{name}}. اختر مندوباً آخر لتغييره.',
        mixedExistingAssignments:
          'بعض الطلبات المحددة لديها مندوب معيّن. سيؤدي التعيين إلى استبدال المندوب الحالي لها.',
        notEligible: 'هذا الطلب غير مؤهل للتعيين.',
        unassignRequiresAssignedSelection: 'اختر الطلبات المعيّنة لمندوب فقط لإلغاء التعيين.',
        chooseCourier: 'اختر مندوباً',
        noActiveCouriers: 'لا يوجد مندوبون نشطون لهذا المتجر.',
        noVerifiedCouriers: 'لا يوجد مندوبون نشطون تم التحقق منهم لهذا المتجر.',
        copyLink: 'نسخ الرابط',
        batchLinkTitle: 'رابط دفعة التوصيل',
        batchLinkTitleWithCount: 'رابط دفعة التوصيل · {{count}} طرود',
        batchLinkDescription: 'هذا الرابط يشمل كل الطلبات المعيّنة ضمن دفعة التوصيل هذه.',
        linkCopied: 'تم نسخ رابط التوصيل.',
        linkGenerated: 'تم إنشاء رابط التوصيل.',
        sendWhatsapp: 'إرسال واتساب',
        resendWhatsApp: 'إرسال عبر واتساب',
        resend: 'إعادة إرسال الرابط',
        regenerate: 'إنشاء رابط جديد',
        regenerateLink: 'إنشاء رابط جديد',
        revoke: 'إلغاء الرابط',
        revokeLink: 'إلغاء الرابط',
        revoked: 'تم إلغاء رابط التوصيل.',
        whatsappMessage:
          'مرحباً {{courierName}}، أرسل لك {{storeName}} قائمة توصيل: {{manifestUrl}}',
        errors: {
          invalidStatus: 'يمكن تعيين الطلبات الجديدة أو المشحونة فقط.',
          manualApprovalRequired: 'وافق على الطلبات المعلقة قبل تعيين مندوب.',
          inactiveCourier: 'هذا المندوب غير نشط.',
          unverifiedCourier: 'يجب التحقق من المندوب قبل تعيين الطلبات.',
          ordersUnavailable: 'بعض الطلبات المحددة غير متاحة. حدّث الصفحة وحاول مرة أخرى.',
          tooManyOrders: 'يمكنك تعيين حتى 50 طلبًا دفعة واحدة.',
          linkExpired: 'لا يوجد رابط توصيل نشط. أنشئ رابطًا جديدًا.',
          assignmentConflict: 'تغيرت بعض التعيينات. حدّث الصفحة وحاول مرة أخرى.',
          assignmentNotFound: 'بعض الطلبات المحددة غير معيّنة لمندوب.',
          assignmentHasProof: 'لا يمكن إلغاء تعيين طلب لديه إثبات توصيل.',
        },
      },
      courierProof: {
        awaitingProof: 'بانتظار إثبات التوصيل',
        awaitingConfirmation: 'بانتظار التأكيد الداخلي',
        confirmed: 'تم التأكيد داخليًا',
        viewProof: 'عرض الإثبات',
        confirm: 'تأكيد التوصيل',
        errors: {
          invalidLink: 'رابط إثبات التوصيل غير صالح.',
          notFound: 'هذا الإثبات لم يعد متاحًا.',
          alreadyConfirmed: 'تم تأكيد هذا الإثبات بالفعل.',
          signedUrlFailed: 'تعذر فتح صورة الإثبات.',
        },
      },
      manualApproval: {
        pendingBadge: 'بانتظار الموافقة',
        pendingCallout: 'وافق على هذا الطلب قبل الشحن أو الرفض أو تعيين مندوب أو الطباعة.',
        pendingPickupCallout: 'وافق على هذا الطلب قبل تأكيد استلامه.',
        approve: 'الموافقة على الطلب',
        approving: 'جارٍ الموافقة…',
        decline: 'رفض الطلب',
        declining: 'جارٍ الرفض…',
        approveModalTitle: 'الموافقة على الطلب؟',
        approvePrompt: 'سيؤدي ذلك إلى فتح إجراءات التجهيز لهذا الطلب.',
        declineModalTitle: 'رفض الطلب؟',
        declinePrompt: 'سيتم رفض الطلب وإرجاع المخزون وإشعار الزبون.',
        approveSuccess: 'تمت الموافقة على الطلب.',
        declineSuccess: 'تم رفض الطلب.',
        badges: {
          pending: 'بانتظار الموافقة',
          approved: 'تمت الموافقة',
          declined: 'مرفوض',
        },
      },
      detail: {
        backToOrders: 'العودة إلى الطلبات',
        orderId: 'رقم الطلب',
        orderIdLabel: 'رقم الطلب:',
        placedOn: 'تاريخ الطلب',
        placedOnLabel: 'تاريخ الطلب:',
        customer: 'معلومات العميل',
        callButton: 'اتصال',
        whatsappButton: 'واتساب',
        contactWhatsappMessage: 'مرحباً، أود التحدث عن الطلب رقم {{orderId}}',
        shippingAddress: 'عنوان التسليم',
        deliveryInformation: 'معلومات التوصيل',
        copyAddress: 'نسخ العنوان',
        addressCopied: 'تم النسخ',
        preciseLocation: 'الموقع الدقيق للتوصيل',
        noPreciseLocation: 'لم يشارك الزبون موقعاً دقيقاً',
        deliveryLocationShareTitle: 'موقع التوصيل',
        deliveryLocationShareMessage: 'موقع الزبون للتوصيل:',
        shareLocationWhatsapp: 'مشاركة عبر واتساب',
        openGoogleMaps: 'فتح الخرائط',
        openWaze: 'فتح Waze',
        copyLocationLink: 'نسخ رابط الموقع',
        locationCopied: 'تم نسخ رابط الموقع',
        copyFailed: 'فشل النسخ',
        notes: 'ملاحظات العميل',
        lineItems: 'المنتجات',
        viewProduct: 'عرض المنتج',
        subtotal: 'المجموع الفرعي',
        notFound: 'الطلب غير موجود',
        notFoundDesc: 'هذا الطلب غير موجود أو ليس لديك صلاحية عرضه',
        loading: 'جاري تحميل الطلب...',
        errorRetry: 'إعادة المحاولة',
      },
      actions: {
        collectFailed: 'تعذّر تأكيد الاستلام. حاول مجددًا.',
        collectedSuccess: 'تم تأكيد استلام الطلب',
        collectDescription: 'هل استلم الزبون الطلب من مكان الاستلام؟',
        collectTitle: 'تأكيد استلام الطلب',
        collecting: 'جارٍ تأكيد الاستلام',
        markCollected: 'تأكيد الاستلام',
        ship: 'تحديد كمشحون',
        deliver: 'تحديد كمُسلَّم',
        reject: 'رفض الطلب',
        cancel: 'إلغاء الطلب',
        shipping: 'جاري الشحن...',
        delivering: 'جاري التسليم...',
        rejecting: 'جاري الرفض...',
        cancelling: 'جاري الإلغاء...',
        shipPrompt: 'هل تريد تحديد الطلب كمشحون؟ افعل هذا عندما تسلّم البضاعة فعليًا.',
        deliverPrompt: 'هل تريد تحديد الطلب كمُسلَّم؟ سيُغلق الطلب.',
        rejectPrompt: 'هل تريد رفض هذا الطلب؟ ستعود كميات الطلب إلى المخزون وسيُغلق الطلب.',
        cancelPrompt: 'هل تريد إلغاء هذا الطلب؟ ستعود كميات الطلب إلى المخزون وسيتم إبلاغ العميل.',
        shipModalTitle: 'تحديد كمشحون',
        deliverModalTitle: 'تحديد كمُسلَّم',
        rejectModalTitle: 'رفض الطلب',
        cancelModalTitle: 'إلغاء الطلب',
        modalConfirm: 'نعم، متابعة',
        modalCancel: 'لا، رجوع',
        successToasts: {
          shipped: 'تم تحديد الطلب كمشحون',
          delivered: 'تم تحديد الطلب كمُسلَّم',
          rejected: 'تم رفض الطلب',
          cancelled: 'تم إلغاء الطلب',
        },
      },
    },
    // F-148 استلام المخزون المُراجَع (التصميم §12). محتوى التاجر (أسماء الموردين، المراجع،
    // الملاحظات، أسماء المنتجات) يُعرض كما هو ولا يمر عبر هذه المفاتيح.
    receiving: {
      title: 'إيصالات الاستلام',
      subtitle: 'سجّل الشحنات، راجع الكميات، ثم أضفها إلى المخزون بخطوة واحدة.',
      entryButton: 'استلام شحنة',
      notEnabled: 'الاستلام غير متاح لحسابك. اطلب من مالك المتجر صلاحية إدارة المخزون.',
      backToList: 'العودة إلى الإيصالات',
      paused: {
        banner: 'الاستلام متوقف مؤقتًا لهذا المتجر. تبقى الإيصالات والتنزيلات والتصحيحات متاحة.',
        draftsReadOnly: 'المسودات للقراءة فقط أثناء توقف الاستلام. يمكنك إلغاؤها فقط.',
      },
      tabs: {
        drafts: 'المسودات',
        receipts: 'الإيصالات',
      },
      list: {
        empty: 'لا توجد مسودات مفتوحة. ابدأ باستلام شحنة.',
        emptyReceipts: 'لا توجد إيصالات مسجّلة بعد.',
        lines: '{{count}} أسطر',
        acceptedUnits: '{{count}} وحدة مقبولة',
        updated: 'آخر تحديث {{date}}',
        loadMore: 'تحميل المزيد',
        open: 'فتح',
        draftLabel: 'مسودة',
        receiptLabel: 'إيصال',
      },
      new: {
        title: 'شحنة جديدة',
        supplier: 'المورّد',
        supplierPlaceholder: 'ابحث أو اكتب اسم المورّد',
        supplierNew: 'إنشاء مورّد "{{name}}"',
        supplierExistingMatch: 'مورّد موجود',
        supplierRequired: 'اختر مورّدًا أو أنشئ واحدًا.',
        reference: 'مرجع الشحنة',
        referenceOptional: 'اختياري',
        referenceHelp: 'اتركه فارغًا وسننشئ مرجعًا تلقائيًا.',
        referenceTooLong: 'يجب ألا يتجاوز المرجع 80 حرفًا.',
        referenceControlCharacter: 'يحتوي المرجع على حرف تحكم غير مدعوم.',
        linkedReceipt: 'إيصال مرتبط',
        note: 'ملاحظة',
        create: 'إنشاء مسودة',
        creating: 'جارٍ الإنشاء…',
      },
      reference: {
        systemBadge: 'مرجع تلقائي',
        systemHelp: 'أنشأته دكانتي لأنه لم يُدخل مرجع للشحنة.',
        merchantLabel: 'مرجع الشحنة',
      },
      draft: {
        title: 'مسودة الاستلام',
        lines: 'الأسطر',
        noLines: 'لا توجد أسطر بعد. امسح باركود أو أضف سطرًا أو استورد ملف CSV.',
        addRow: 'إضافة سطر',
        scan: 'مسح',
        importCsv: 'استيراد CSV',
        downloadTemplate: 'تنزيل القالب',
        save: 'حفظ',
        review: 'مراجعة',
        discard: 'إلغاء المسودة',
        discardConfirm: 'إلغاء هذه المسودة؟ لم تُضف أي كمية إلى المخزون.',
        discarded: 'تم إلغاء المسودة.',
        versionConflict: 'تغيّرت المسودة في نافذة أخرى. أعد التحميل لعرض أحدث نسخة.',
        reload: 'إعادة التحميل',
        errorSummary: 'صحّح ما يلي قبل المراجعة',
        errorSummaryItem: 'السطر {{line}}: {{message}}',
        combinePreview:
          'بعد الدمج: المتوقع {{expected}}، المقبول {{accepted}}، التالف {{damaged}}، الناقص {{missing}}',
        notOpen: 'هذه المسودة لم تعد مفتوحة.',
        openReceipt: 'فتح الإيصال',
      },
      save: {
        saved: 'تم الحفظ',
        saving: 'جارٍ الحفظ…',
        unsaved: 'تغييرات غير محفوظة',
        failed: 'فشل الحفظ',
        retry: 'إعادة محاولة الحفظ',
        fixFields: 'صحّح الحقول المحددة ليتم الحفظ.',
      },
      line: {
        lineNo: 'السطر {{line}}',
        variant: 'الخيار',
        variantRef: 'معرّف الخيار',
        barcode: 'الباركود',
        supplierCode: 'رمز المورّد',
        supplierItem: 'صنف المورّد',
        unitKind: 'طريقة العدّ',
        unit: 'وحدات',
        pack: 'عبوات',
        packs: 'عدد العبوات',
        unitsPerPack: 'وحدة لكل عبوة',
        packMath: '{{packs}} عبوة × {{unitsPerPack}} = {{total}} وحدة',
        confirmPack: 'تأكيد تحويل الوحدات لكل عبوة',
        expected: 'المتوقع',
        accepted: 'المقبول',
        damaged: 'التالف',
        missing: 'الناقص',
        note: 'ملاحظة السطر',
        remove: 'حذف السطر',
        selectVariant: 'اختيار الخيار',
        changeVariant: 'تغيير الخيار',
        inactiveBadge: 'غير نشط',
        unresolvedScan: 'باركود ممسوح لم تتم مطابقته بعد',
        noVariant: 'لم يتم اختيار خيار',
        clearVariant: 'مسح الاختيار',
        quantities: 'الكميات',
        identifiers: 'المعرّفات',
      },
      picker: {
        title: 'اختيار خيار',
        search: 'ابحث باسم المنتج أو الخيار أو الباركود',
        noResults: 'لا توجد خيارات مطابقة.',
        loadMore: 'تحميل المزيد',
        exactBarcode: 'مطابقة الباركود بالضبط',
        results: 'نتائج البحث',
      },
      conflict: {
        title: 'المعرّفات تشير إلى خيارات مختلفة',
        description:
          'الباركود ومعرّف الخيار في هذا السطر يشيران إلى خيارين مختلفين. اختر الخيار الذي وصل فعلًا.',
        byBarcode: 'حسب الباركود',
        byRef: 'حسب معرّف الخيار',
        use: 'استخدام هذا الخيار',
      },
      duplicates: {
        title: 'أسطر مكررة لنفس الخيار',
        description: '{{product}} — {{variant}} يظهر في الأسطر {{lines}}. ادمجها قبل المراجعة.',
        combine: 'دمج الأسطر',
      },
      csv: {
        title: 'استيراد CSV',
        choose: 'اختر ملف CSV',
        file: 'الملف',
        templateHelp: 'استخدم القالب: CSV بترميز UTF-8، مفصول بفواصل، حتى 500 سطر.',
        import: 'استيراد الأسطر',
        importing: 'جارٍ الاستيراد…',
        imported: 'تم استيراد {{count}} سطرًا.',
        duplicateWarning: 'هذا المحتوى يطابق مسودة أو إيصالًا موجودًا: {{references}}.',
        acknowledge: 'تحققت، وهذه شحنة مختلفة.',
        utf8Guidance:
          'هذا الملف ليس CSV UTF-8. في Excel اختر "CSV UTF-8 (مفصول بفواصل)" ثم ارفعه مجددًا.',
        fileError: 'خطأ في الملف',
        readFailed: 'تعذّر قراءة الملف. اختره مجددًا أو جرّب ملفًا آخر.',
        rowErrors: 'أخطاء الأسطر (أول 50)',
        row: 'السطر',
        column: 'العمود',
        problem: 'المشكلة',
        errors: {
          empty_file: 'الملف فارغ.',
          too_large: 'حجم الملف أكبر من 2 ميبيبايت.',
          unsupported_format: 'ملفات CSV فقط مدعومة. لا يمكن استيراد ملفات Excel أو PDF.',
          utf16_encoding: 'الملف بترميز UTF-16. احفظه بصيغة CSV UTF-8 ثم ارفعه مجددًا.',
          encoding_not_utf8:
            'هذا الملف ليس CSV UTF-8. في Excel اختر "CSV UTF-8 (مفصول بفواصل)" ثم ارفعه مجددًا.',
          invalid_character:
            'يحتوي الملف على حرف تالف (�)، غالبًا من تحويل سابق. أعد التصدير بصيغة CSV UTF-8.',
          semicolon_delimiter: 'الملف يستخدم الفاصلة المنقوطة. صدّره مفصولًا بفواصل.',
          missing_headers: 'أعمدة القالب المطلوبة غير موجودة في سطر العناوين.',
          unknown_header: 'سطر العناوين يحتوي على عمود غير موجود في القالب.',
          duplicate_header: 'سطر العناوين يكرر عمودًا.',
          too_many_rows: 'يحتوي الملف على أكثر من 500 سطر.',
          control_character: 'تحتوي الخلية على حرف تحكم غير مدعوم.',
          bad_quote: 'يحتوي السطر على علامة اقتباس غير مغلقة أو في غير مكانها.',
          too_many_fields: 'يحتوي السطر على حقول أكثر من سطر العناوين.',
          not_integer: 'أدخل عددًا صحيحًا بدون إشارات أو كسور أو فواصل.',
          out_of_range: 'العدد خارج النطاق المسموح.',
          invalid_barcode: 'الباركود غير صالح.',
          invalid_uuid: 'معرّف الخيار ليس معرّف دكانتي صالحًا.',
          too_long: 'النص طويل جدًا.',
          pack_incomplete: 'أسطر العبوات تحتاج عدد العبوات والوحدات لكل عبوة معًا.',
          pack_total_mismatch: 'يجب أن تساوي الوحدات المتوقعة عدد العبوات × الوحدات لكل عبوة.',
          partial_disposition: 'املأ المقبول والتالف والناقص معًا، أو اتركها الثلاثة فارغة.',
          invalid_unit_kind: 'يجب أن تكون قيمة unit_kind هي "unit" أو "pack".',
        },
      },
      review: {
        title: 'المراجعة والتسجيل',
        description:
          'تُضاف الوحدات المقبولة فقط إلى المخزون. تُسجَّل الوحدات التالفة والناقصة في الإيصال.',
        lines: 'تغييرات المخزون',
        inventoryNow: 'الآن',
        adds: '+{{count}}',
        after: 'بعد',
        totals: 'الإجماليات',
        confirm: 'تسجيل الإيصال',
        confirmTitle: 'تسجيل هذا الإيصال؟',
        confirmDescription:
          'سيزيد مخزون {{lines}} خيارات بمقدار {{accepted}} وحدة مقبولة. لا يمكن التراجع؛ التعديلات اللاحقة تتم عبر التصحيحات.',
        posting: 'جارٍ التسجيل…',
        checking: 'جارٍ التحقق من النتيجة…',
        notReady: 'صحّح المشكلات المانعة في المسودة قبل التسجيل.',
        backToDraft: 'العودة إلى المسودة',
        posted: 'تم تسجيل الإيصال.',
        alreadyPosted: 'هذه المسودة مسجّلة مسبقًا. جارٍ فتح الإيصال.',
        similarRecent:
          'سُجّل إيصال بنفس الأسطر لهذا المورّد بتاريخ {{date}}. تأكد أن هذه شحنة مختلفة.',
        openSimilar: 'فتح الإيصال المشابه',
      },
      receipt: {
        title: 'إيصال الاستلام',
        postedBy: 'سجّله',
        postedAt: 'وقت التسجيل',
        supplier: 'المورّد',
        reference: 'المرجع',
        linked: 'مرتبط بالإيصال',
        netAccepted: 'صافي المقبول',
        corrections: 'التصحيحات',
        noCorrections: 'لا توجد تصحيحات.',
        download: 'تنزيل ملخص الفروقات CSV',
        noEditNotice:
          'لا يمكن تعديل الإيصالات المسجّلة أو حذفها. استخدم تصحيحًا لتقليل كمية مقبولة.',
        lines: 'الأسطر',
        newLinked: 'استلام شحنة تكميلية',
        inventoryChange: '{{before}} ← {{after}}',
        correctedBy:
          '{{units}} وحدة أُعيد تصنيفها كـ{{reclassify}} بواسطة {{actor}} في {{date}}: {{reason}}',
      },
      export: {
        lineNo: 'السطر',
        product: 'المنتج',
        variant: 'الخيار',
        barcode: 'الباركود',
        supplierCode: 'رمز المورّد',
        supplierItemName: 'صنف المورّد',
        expected: 'المتوقع',
        accepted: 'المقبول',
        damaged: 'التالف',
        missing: 'الناقص',
        corrected: 'المصحَّح',
        netAccepted: 'صافي المقبول',
        note: 'ملاحظة',
      },
      correction: {
        action: 'تصحيح',
        title: 'تصحيح الكمية المقبولة',
        description:
          'يقلّل الكمية المقبولة لهذا السطر ويخصم الوحدات من المخزون. يبقى الإيصال الأصلي دون تغيير.',
        units: 'الوحدات المراد خصمها',
        available: 'في المخزون الآن: {{count}}',
        remaining: 'القابل للتصحيح في هذا السطر: {{count}}',
        reason: 'السبب',
        reasons: {
          accepted_count_error: 'خطأ في عدّ المقبول',
          damage_found_after_posting: 'اكتُشف تلف بعد التسجيل',
          wrong_variant_received: 'وصل خيار خاطئ',
          other: 'سبب آخر',
        },
        reclassifyLabel: 'تسجيل الوحدات المخصومة على أنها',
        reclassify: {
          missing: 'ناقصة',
          damaged: 'تالفة',
        },
        note: 'ملاحظة',
        noteRequired: 'الملاحظة مطلوبة عند اختيار "سبب آخر".',
        unitsInvalid: 'أدخل عددًا صحيحًا بين 1 و{{max}}.',
        increaseHint: 'لإضافة وحدات أو تسجيل خيار مختلف، استلم شحنة جديدة مرتبطة.',
        confirm: 'تطبيق التصحيح',
        applying: 'جارٍ التطبيق…',
        applied: 'تم تطبيق التصحيح.',
        pausedAllowed: 'تبقى التصحيحات متاحة أثناء توقف الاستلام.',
      },
      barcodeHint: {
        notRecorded: 'التغييرات السريعة هنا لا تُسجَّل كإيصالات استلام.',
        openReceiving: 'استلم شحنة بدلًا من ذلك',
      },
      scan: {
        label: 'مسح للإضافة',
        liveRegion: 'نتائج المسح',
        added: '{{product}} — {{variant}}: المتوقع {{expected}}، المقبول {{accepted}}',
        incremented: '{{product}} — {{variant}}: المتوقع {{expected}}، المقبول {{accepted}}',
        packLine: 'هذا الصنف يُستلم بالعبوات في السطر {{line}}. عدّل عدد العبوات هناك.',
        duplicateLines: 'هذا الخيار موجود في الأسطر {{lines}}. ادمج الأسطر أولًا.',
        unresolvedUnknown: 'أُضيف باركود غير معروف كسطر {{line}}. اختر خيارًا للمتابعة.',
        unresolvedIneligible: 'هذا الباركود يعود لخيار محذوف. أُضيف كسطر {{line}} للمراجعة.',
        alreadyUnresolved: 'هذا الباركود بانتظار المطابقة في السطر {{line}}.',
        invalid: 'هذا ليس باركودًا صالحًا.',
        lineLimit: 'تتسع المسودة لـ{{max}} سطرًا كحد أقصى.',
        quantityLimit: 'السطر {{line}} وصل إلى الحد الأقصى للكمية.',
        lookupFailed: 'فشل البحث. تحقق من الاتصال وامسح مرة أخرى.',
      },
      issues: {
        VARIANT_REQUIRED: 'اختر خيارًا لهذا السطر.',
        IDENTIFIER_UNKNOWN: 'لا يوجد خيار يطابق هذا المعرّف. اختر واحدًا يدويًا.',
        IDENTIFIER_AMBIGUOUS: 'أكثر من خيار يطابق هذا المعرّف. اختر واحدًا يدويًا.',
        IDENTIFIER_CONFLICT: 'الباركود ومعرّف الخيار يشيران إلى خيارين مختلفين. حلّ التعارض.',
        VARIANT_INELIGIBLE: 'هذا الخيار محذوف أو لم يعد متاحًا للاستلام.',
        PACK_CONFIRMATION_REQUIRED: 'أكّد تحويل الوحدات لكل عبوة.',
        PACK_TOTAL_MISMATCH:
          'يجب أن تساوي الوحدات المتوقعة عدد العبوات × الوحدات لكل عبوة ({{product}}).',
        QUANTITY_MISSING: 'أدخل الكمية.',
        QUANTITY_OUT_OF_RANGE: 'أدخل عددًا صحيحًا ضمن النطاق المسموح.',
        QUANTITY_SUM_MISMATCH:
          'يجب أن يساوي المقبول + التالف + الناقص المتوقع ({{expected}}). المقبول المحسوب: {{calculated}}.',
        DUPLICATE_VARIANT: 'هذا الخيار يظهر في أكثر من سطر. ادمج الأسطر.',
        INVENTORY_LIMIT_EXCEEDED: 'إضافة هذه الكمية تتجاوز حد المخزون 999,999.',
        NO_LINES: 'أضف سطرًا واحدًا على الأقل.',
        TOO_MANY_LINES: 'تتسع المسودة لـ{{max}} سطرًا كحد أقصى (حاليًا {{count}}).',
        REFERENCE_ALREADY_RECEIVED: 'يوجد إيصال بنفس المورّد والمرجع.',
        DUPLICATE_CONTENT_UNACKNOWLEDGED: 'أكّد تحذير المحتوى المكرر قبل التسجيل.',
        RECEIVING_DISABLED: 'الاستلام متوقف مؤقتًا لهذا المتجر.',
        SIMILAR_RECENT_RECEIPT: 'سُجّل إيصال مشابه مؤخرًا لهذا المورّد.',
      },
      errors: {
        F148_NOT_FOUND: 'لم يتم العثور على هذه المسودة أو الإيصال.',
        F148_DISABLED: 'الاستلام متوقف مؤقتًا لهذا المتجر.',
        F148_VALIDATION: 'بعض القيم غير صالحة. تحقق من الحقول المحددة.',
        F148_DRAFT_EXISTS: 'توجد مسودة مفتوحة بنفس المورّد والمرجع.',
        F148_DRAFT_VERSION_CONFLICT: 'تغيّرت المسودة في نافذة أخرى. أعد التحميل لعرض أحدث نسخة.',
        F148_DRAFT_NOT_OPEN: 'هذه المسودة مسجّلة أو ملغاة مسبقًا.',
        F148_REVIEW_STALE: 'تغيّرت المسودة منذ مراجعتها. راجعها مرة أخرى.',
        F148_DRAFT_INVALID: 'تحتوي المسودة على مشكلات مانعة. صحّحها ثم راجع مجددًا.',
        F148_REFERENCE_ALREADY_RECEIVED: 'يوجد إيصال بنفس المورّد والمرجع.',
        F148_IDEMPOTENCY_KEY_REUSED:
          'استُخدم هذا الطلب سابقًا بقيم مختلفة. أعد التحميل وحاول مجددًا.',
        F148_VARIANT_INELIGIBLE: 'خيار في هذه المسودة محذوف أو لم يعد متاحًا. لم يُسجَّل شيء.',
        F148_INVENTORY_LIMIT: 'التسجيل سيتجاوز حد المخزون 999,999 لأحد الخيارات. لم يُسجَّل شيء.',
        F148_STOCK_BUSY: 'المخزون مشغول حاليًا. مسودتك محفوظة؛ حاول مرة أخرى.',
        F148_CORRECTION_EXCEEDS_RECEIPT: 'التصحيح يتجاوز الكمية القابلة للتصحيح في هذا السطر.',
        F148_CORRECTION_EXCEEDS_AVAILABLE: 'لا توجد وحدات كافية في المخزون لهذا التصحيح.',
        F148_UNKNOWN: 'حدث خطأ ما. مسودتك محفوظة؛ حاول مرة أخرى.',
      },
    },
    stock: {
      worklist: {
        scopeLabel: 'نطاق العرض',
        scopeActive: 'خيارات المنتجات النشطة',
        scopeAll: 'جميع خيارات المنتجات',
        scopeSummary: 'إجمالي {{scope}}',
        scopeHelp: 'تشمل الأعداد كامل النطاق، ولا تتغير مع البحث أو فلتر حالة المخزون.',
        variants: 'خيارات المنتجات',
        outCount: 'غير متوفرة',
        lowCount: 'مخزون منخفض',
        available: 'المتاح للبيع',
        availableHelp: 'الكمية المسجّلة المتاحة للبيع، وليست جردًا فعليًا.',
        lowRule: 'المخزون المنخفض: من 1 إلى 5 وحدات',
        defaultVariant: 'الخيار الأساسي',
        inactive: 'غير نشط',
        unpublished: 'منتج غير منشور',
        barcode: 'الباركود',
        search: 'بحث بالاسم أو الخيارات أو الباركود',
        searchTooLong: 'استخدم 100 حرف كحد أقصى.',
        results: 'النتائج المطابقة: {{total}} · المعروضة: {{loaded}}',
        viewProduct: 'عرض المنتج',
        viewProductLabel: 'عرض المنتج: {{product}}، {{variant}}',
        backToStock: 'العودة إلى المخزون',
        loadMore: 'عرض المزيد',
        loadingMore: 'جارٍ تحميل المزيد',
        end: 'نهاية هذه النتائج',
        clear: 'مسح البحث والفلاتر',
        lastChecked: 'آخر تحقق ناجح: {{time}}',
        paused: 'التحديث التلقائي متوقف أثناء مراجعة صفحات متعددة. اضغط تحديث لأحدث البيانات.',
        changed: 'قد يكون المخزون قد تغيّر. حدّث القائمة لمراجعة أحدث النتائج.',
        restarted: 'تم تحديث القائمة من البداية.',
        loadFailed: 'تعذّر تحميل المخزون. حاول مجددًا.',
        refreshFailed: 'تعذّر التحديث. تُعرض آخر بيانات تم تحميلها.',
        pageFailed: 'تعذّر تحميل المزيد. النتائج المعروضة محفوظة.',
        accessDenied: 'لم يعد الوصول إلى مخزون هذا المتجر متاحًا.',
        invalidQuery: 'تعذّر استخدام هذا البحث. امسح البحث أو حدّث القائمة.',
        noVariants: 'لا توجد خيارات منتجات لعرضها في هذا المتجر.',
        noActive: 'لا توجد خيارات منتجات نشطة. يمكنك عرض جميع خيارات المنتجات.',
        noMatches: 'لا توجد نتائج مطابقة لهذا البحث والفلاتر.',
        showAll: 'عرض جميع خيارات المنتجات',
        openProducts: 'عرض المنتجات',
        viewStockLabel: 'مراجعة المخزون: {{product}}، {{variant}}',
      },
      title: 'لوحة المخزون',
      refresh: 'تحديث',
      refreshing: 'جارٍ التحديث...',
      loading: 'جارٍ تحميل المخزون...',
      summary: {
        // NOTE: heading renders as "stock overview" — never "store totals".
        // See V1 LIMITATION on StockSummary type.
        heading: 'نظرة عامة على المخزون',
        totalSkus: 'إجمالي المنتجات',
        totalInventory: 'إجمالي المخزون',
        lowStockCount: 'مخزون منخفض',
        outOfStockCount: 'نفد المخزون',
      },
      columns: {
        product: 'المنتج',
        inventory: 'المخزون',
        available: 'المتاح',
        status: 'الحالة',
        actions: 'إجراءات',
      },
      status: {
        healthy: 'متوفر',
        lowStock: 'مخزون منخفض',
        outOfStock: 'نفد المخزون',
      },
      filter: {
        all: 'الكل',
        lowStock: 'مخزون منخفض',
        outOfStock: 'نفد المخزون',
        searchPlaceholder: 'ابحث عن منتج...',
      },
      empty: {
        title: 'لا توجد منتجات',
        subtitle: 'أضف منتجات لمتجرك لبدء تتبع المخزون.',
        noResults: 'لا توجد نتائج للتصفية المحددة.',
      },
      updateInventory: {
        trigger: 'تحديث المخزون',
        triggerForProduct: 'تحديث مخزون {{name}}',
        modalTitle: 'تحديث مخزون {{name}}',
        currentInventory: 'المخزون الحالي: {{count}}',
        explanation: 'هذا يغيّر إجمالي المخزون المتاح للبيع.',
        newInventoryLabel: 'المخزون الجديد',
        availablePreview: 'المتاح بعد التحديث: {{count}}',
        confirm: 'تحديث',
        confirming: 'جارٍ التحديث...',
        cancel: 'إلغاء',
        errors: {
          negative: 'المخزون لا يمكن أن يكون سالبًا.',
          networkFailed: 'فشل الاتصال. حاول مرة أخرى.',
          unknown: 'حدث خطأ ما. حاول مرة أخرى.',
        },
        toasts: {
          updated: 'تم تحديث المخزون',
        },
      },
      errors: {
        networkFailed: 'تعذّر تحميل بيانات المخزون. تحقق من الاتصال وأعد المحاولة.',
        unknown: 'حدث خطأ في تحميل المخزون.',
      },
    },
    reviews: {
      title: 'تقييمات المنتجات',
      emptyTitle: 'لا توجد تقييمات بعد',
      emptyDescription: 'ستظهر تقييمات الزبائن الموثّقة هنا بعد تسليم الطلبات.',
      loadMore: 'تحميل المزيد',
      columns: {
        product: 'المنتج',
        rating: 'التقييم',
        review: 'رأي الزبون',
        visibility: 'الظهور',
        response: 'رد المتجر',
        date: 'التاريخ',
        actions: 'إجراءات',
      },
      filters: {
        product: 'المنتج',
        allProducts: 'كل المنتجات',
        productSearch: 'ابحث في المنتجات التي لديها تقييمات',
        previousProducts: 'المنتجات السابقة',
        moreProducts: 'منتجات أخرى لديها تقييمات',
        visibility: 'الظهور',
      },
      visibility: {
        all: 'الكل',
        visible: 'ظاهر',
        hidden: 'مخفي',
        reasonRequired: 'اختر سبب الإخفاء',
        noteTooLong: 'يجب ألا تتجاوز الملاحظة 500 حرف',
      },
      actions: {
        respond: 'ردّ',
        editResponse: 'تعديل الرد',
        removeResponse: 'إزالة الرد',
        hide: 'إخفاء',
        unhide: 'إظهار',
        disabledForStaff: 'هذه العملية متاحة للمالك أو المدير فقط',
      },
      response: {
        title: 'ردّ المتجر',
        placeholder: 'اكتب رداً قصيراً للزبون',
        save: 'حفظ الرد',
        required: 'اكتب رداً قصيراً',
        tooLong: 'يجب ألا يتجاوز الرد 1000 حرف',
      },
      hideReasons: {
        abusive: 'محتوى مسيء',
        privateInfo: 'يتضمن معلومات خاصة',
        offTopic: 'خارج الموضوع',
        spam: 'مزعج أو متكرر',
        other: 'سبب آخر',
      },
      moderation: {
        hideTitle: 'إخفاء التقييم',
        unhideTitle: 'إظهار التقييم',
        reasonLabel: 'سبب الإخفاء',
        noteLabel: 'ملاحظة داخلية',
        notePlaceholder: 'اختياري، تظهر للإدارة فقط',
        hiddenMeta: 'مخفي: {{reason}}',
      },
      errors: {
        permissionDenied: 'ليست لديك صلاحية تعديل التقييمات',
        loadFailed: 'تعذّر تحميل التقييمات',
      },
    },
  },
  storefront: {
    beauty: {
      shopAll: 'تسوّق جميع المنتجات',
      menu: 'فتح قائمة المتجر',
      closeMenu: 'إغلاق قائمة المتجر',
      search: 'البحث في المتجر',
      searchPlaceholder: 'ابحث عن منتجات',
      closeSearch: 'إغلاق البحث',
      account: 'حسابي',
      cart: 'سلة التسوّق',
      productCount: '{{count}} منتج',
      loadedCount: 'عرض {{loaded}} من {{total}}',
      loadMore: 'عرض المزيد',
      sort: 'ترتيب المنتجات',
      clearSearch: 'مسح البحث',
      noResults: 'لا توجد منتجات تطابق بحثك.',
      selectShade: 'اختر درجة اللون',
      selectOptions: 'اختر الخيارات',
      shadeCount: '{{count}} درجة لون',
      shadeCount_one: 'درجة لون واحدة',
      moreDetails: 'المزيد من التفاصيل',
      details: 'تفاصيل المنتج',
      shippingReturns: 'التوصيل والإرجاع',
      relatedHeading: 'المزيد من هذه الفئة',
      reviews: 'التقييمات',
      ratingSummary: 'التقييم {{average}} من 5 من {{count}} تقييم',
      previous: 'السابق',
      next: 'التالي',
      community: 'مجتمعنا',
      browseProduct: 'عرض {{name}}',
      shop: 'التسوّق',
      contact: 'تواصل معنا',
      policies: 'سياسات المتجر',
      currency: 'الأسعار بالشيكل الإسرائيلي',
      newsletterInert: 'معاينة فقط؛ لا يمكن إرسال الاشتراك هنا.',
      catalogLoadError: 'تعذّر تحميل المنتجات. حاول مرة أخرى.',
      factsLoadError: 'تعذّر تحميل تفاصيل المنتجات الإضافية.',
      chooseOptions: 'اختر جميع الخيارات قبل الإضافة إلى السلة.',
      backToShop: 'العودة للتسوّق',
      newsletterHeading: 'ابقَ على اطلاع',
      newsletterBody: 'اشترك لتلقّي أخبار المتجر.',
      galleryIndex: 'الصورة {{index}} من {{total}}',
      searchSubmit: 'بحث',
      footerGroupToggle: 'فتح أو إغلاق {{group}}',
      communityProductUnavailable: 'المنتج غير متاح',
    },
    website: {
      luxury: {
        categories: 'اكتشف الفئات',
        discoverCategory: 'اكتشف المجموعة',
        bestSellers: 'الأكثر مبيعًا',
        sale: 'التخفيضات',
        newArrivals: 'وصل حديثًا',
        moreFromCategory: 'المزيد من هذه الفئة',
        backToCategory: 'العودة إلى الفئة',
        productDetails: 'تفاصيل المنتج',
        merchandisingError: 'تعذّر تحميل المنتجات. حاول مرة أخرى.',
      },
      fashion: {
        demoWhiteShirt: 'قميص أبيض بأزرار',
        demoBlackBag: 'حقيبة كتف سوداء',
        demoCollection: 'القطع الأساسية',
        viewCollection: 'عرض مجموعة {{category}}',
        campaignLoadError: 'تعذر تحميل هذه المجموعة.',
        collectionUnavailableTitle: 'هذه المجموعة غير متاحة حاليًا',
        collectionUnavailableDescription: 'عُد إلى المتجر لتصفّح المنتجات المتاحة.',
        retry: 'حاولوا مجددًا',
        previousProductImage: 'الصورة السابقة للمنتج {{name}}',
        nextProductImage: 'الصورة التالية للمنتج {{name}}',
        productImagePosition: 'الصورة {{index}} من {{count}} للمنتج {{name}}',
        sizeGuideOpen: 'عرض دليل المقاسات',
        sizeGuideClose: 'إغلاق دليل المقاسات',
        newsletterCompany: 'الشركة',
        sizeGuideTitle: 'دليل المقاسات',
        description: 'الوصف',
        detailsCare: 'التفاصيل والعناية',
        deliveryReturns: 'التوصيل والإرجاع',
        generatedArtwork: 'صور أزياء اصطناعية أصلية أُنشئت لقوالب دكانتي.',
      },
      credits: {
        licenseScope: 'تخضع الصور الأصلية وتعديلاتنا للتراخيص المرتبطة أدناه.',
        title: 'حقوق صور القوالب',
        intro:
          'الصور المستخدمة في قوالب مواقع دوكانتي ومعايناتها. يمكن للتجار استبدالها بصورهم الخاصة.',
        source: 'الصورة الأصلية',
        license: 'الترخيص',
        changes:
          'التعديلات: قصّ الصور وتغيير حجمها وضغطها بصيغة WebP، واستخدامها أيضًا في لقطات معاينة القوالب.',
      },
      updating: {
        reload: 'إعادة تحميل المتجر',
        reloadFailed: 'ما زال المتجر يحتاج إلى إصدار أحدث. حاولوا لاحقًا.',
        title: 'يتم تحديث هذا المتجر',
        body: 'يرجى العودة بعد قليل.',
        browse: 'تصفح دكانتي',
      },
      skipToContent: 'الانتقال إلى المحتوى',
      nav: {
        label: 'تنقل المتجر',
        home: 'الرئيسية',
        shop: 'تسوق',
        about: 'من نحن',
        cart: 'السلة',
        account: 'الحساب',
        search: 'بحث',
        openMenu: 'فتح القائمة',
        closeMenu: 'إغلاق القائمة',
      },
      hero: {
        previous: 'الشريحة السابقة',
        next: 'الشريحة التالية',
        slideStatus: 'الشريحة {{current}} من {{total}}',
      },
      media: {
        pause: 'إيقاف مؤقت',
        play: 'تشغيل',
      },
      categories: {
        heading: 'تسوق حسب الفئة',
      },
      products: {
        newArrivals: 'وصل حديثًا',
        bestSellers: 'الأكثر مبيعًا',
        trending: 'رائج الآن',
        related: 'قد يعجبك أيضًا',
        viewAll: 'عرض الكل',
      },
      about: {
        title: 'عن المتجر',
        delivery: 'التوصيل',
        returns: 'الإرجاع',
        contact: 'التواصل',
      },
      product: {
        careTitle: 'العناية',
        sizeGuideTitle: 'دليل المقاسات',
      },
      confirmation: {
        title: 'تم استلام الطلب',
        continue: 'متابعة التسوق',
      },
      footer: {
        powered: 'مدعوم من دكانتي',
      },
      canvas: {
        checkoutDisabled: 'هذه صفحة إتمام الطلب الحقيقية. إرسال الطلبات متوقف أثناء التعديل.',
        sampleProduct: 'منتج تجريبي',
        sampleCategory: 'فئة تجريبية',
        embeddedBlocked: 'لا يمكن عرض هذه الصفحة هنا.',
        orderConfirmationNotice: 'بعد أن يطلب العميل، يرى تأكيد طلبه هنا.',
        seeOrderConfirmation: 'عرض صفحة تأكيد الطلب',
        notInEditor: 'هذه الصفحة ليست جزءًا من محرر واجهة المتجر.',
        backToStore: 'العودة إلى الصفحة الرئيسية للمتجر',
      },
    },
    storefrontEngine: {
      fallback: {
        sectionUnavailable: 'تعذر عرض هذا القسم الآن.',
      },
      liveCanvas: {
        empty: {
          title: 'بانتظار الباني',
          body: 'يعرض هذا المسار المحتوى فقط بعد أن يبدأ باني الإدارة جلسة لوحة موثوقة.',
        },
        loading: 'بانتظار الباني',
        ready: 'اللوحة جاهزة',
        renderFailed: 'تعذر عرض اللوحة.',
        invalidPayload: 'حمولة اللوحة غير صالحة.',
        unavailable: 'لوحة العرض الحية غير متاحة.',
        controlsDisabled: 'عناصر تحكم اللوحة غير متاحة مؤقتًا.',
        selectionLabel: 'تحديد قسم من واجهة المتجر',
        sections: {
          hero: 'قسم الواجهة',
          header: 'رأس المتجر',
          footer: 'تذييل المتجر',
          mobileNav: 'تنقل الهاتف',
          announcementBar: 'شريط الإعلانات',
          benefits: 'المزايا',
          faq: 'الأسئلة الشائعة',
          aboutStore: 'عن المتجر',
          testimonials: 'شهادات',
          newsletterCta: 'دعوة النشرة',
          trustBadge: 'شارة الثقة',
          promotionalAds: 'إعلانات المتجر',
          categories: 'الفئات',
          liveOffers: 'العروض المباشرة',
          products: 'المنتجات',
          trustSummary: 'ملخص الثقة',
          editorialBanner: 'لافتة تحريرية',
        },
        selection: {
          chromeLabel: 'محدد',
          aria: {
            section: 'قسم قابل للاختيار: {{section}}',
            selectedSection: 'القسم المحدد في اللوحة: {{section}}',
          },
        },
        edit: {
          shortLabel: 'تعديل',
          editSection: 'تعديل {{section}}',
          lockedShortLabel: 'مقفل',
          lockedSection: '{{section}} محمي في لوحة البناء',
        },
        textFields: {
          editTextField: 'تعديل {{field}} في {{section}}',
          labels: {
            heroHeadline: 'عنوان الواجهة',
            heroEyebrow: 'عبارة الواجهة',
            heroDescription: 'وصف الواجهة',
            heroPrimaryActionLabel: 'زر الواجهة الرئيسي',
            contentHeading: 'عنوان القسم',
            contentBody: 'نص القسم',
            contentBenefitTitle: 'عنوان الميزة',
            contentBenefitBody: 'نص الميزة',
            contentFaqQuestion: 'سؤال شائع',
            contentFaqAnswer: 'إجابة شائعة',
            contentAboutParagraph: 'فقرة عن المتجر',
            contentTestimonialQuote: 'نص الشهادة',
            contentTestimonialName: 'اسم صاحب الشهادة',
            contentTestimonialContext: 'تفاصيل الشهادة',
            contentNewsletterButton: 'زر النشرة',
            contentEditorialBannerButton: 'زر اللافتة',
          },
        },
        richContentFields: {
          editRichContentField: 'تعديل المحتوى المنسق لـ {{field}} في {{section}}',
          labels: {
            contentBenefitsBody: 'نص المزايا',
            contentBenefitBody: 'نص الميزة',
            contentFaqBody: 'مقدمة الأسئلة الشائعة',
            contentFaqAnswer: 'إجابة شائعة',
            contentAboutParagraph: 'فقرة عن المتجر',
            contentTestimonialsBody: 'مقدمة الاقتباسات',
            contentTestimonialQuote: 'نص الشهادة',
            contentNewsletterBody: 'نص دعوة النشرة',
            contentEditorialBannerBody: 'نص اللافتة',
          },
        },
        mediaFields: {
          replaceMediaField: 'استبدال {{field}} في {{section}}',
          labels: {
            heroDesktop: 'صورة الواجهة للحاسوب',
            heroMobile: 'صورة الواجهة للهاتف',
            trustBadgeImage: 'صورة شارة الثقة',
            editorialBannerDesktop: 'صورة اللافتة لسطح المكتب',
            editorialBannerMobile: 'صورة اللافتة للجوال',
          },
        },
        add: {
          shortLabel: 'إضافة',
          addAfterSection: 'إضافة قسم بعد {{section}}',
        },
        lifecycle: {
          duplicate: 'نسخ {{section}}',
          hide: 'إخفاء {{section}}',
          show: 'إظهار {{section}}',
          delete: 'حذف {{section}}',
          hiddenPlaceholder: '{{section}} مخفي في المسودة.',
        },
        visibility: {
          deviceHiddenPlaceholder: '{{section}} مخفي في حجم المعاينة هذا.',
        },
        heroSchedule: {
          always: 'نشطة دائما',
          active: 'ظاهرة الآن',
          upcoming: 'مجدولة',
          expired: 'منتهية',
        },
        reorder: {
          handle: 'اسحب لإعادة ترتيب {{section}}',
          moveUp: 'نقل {{section}} قبل القسم السابق',
          moveDown: 'نقل {{section}} بعد القسم التالي',
          dropBefore: 'إفلات قبل {{section}}',
          dropAfter: 'إفلات بعد {{section}}',
          movedBefore: 'تم نقل {{section}} قبل {{target}}.',
          movedAfter: 'تم نقل {{section}} بعد {{target}}.',
        },
        inertAction: 'إجراءات المتسوق معطلة داخل لوحة البناء.',
        aria: {
          route: 'لوحة باني واجهة المتجر',
          selectedSection: 'قسم اللوحة المحدد',
          selectedControls: 'عناصر تحكم اللوحة للقسم {{section}}',
        },
      },
    },
    preview: {
      banner: 'وضع المعاينة',
      expired: 'انتهت صلاحية رابط المعاينة.',
      notAvailable: 'المعاينة غير متاحة.',
      noindexLabel: 'مخفية عن محركات البحث',
      unsupportedTitle: 'صفحة المعاينة غير متاحة',
      unsupportedDescription:
        'هذه الوجهة ليست ضمن المعاينة الآمنة بعد. تابع من الصفحة الرئيسية للمعاينة.',
      backToPreview: 'العودة إلى الصفحة الرئيسية للمعاينة',
    },
    welcome: 'مرحبًا بك في دكانتي',
    shopNow: 'تسوق الآن',
    offerCampaigns: {
      homeRailTitle: 'حملات مباشرة',
      liveBadge: 'عرض مباشر',
      endsIn: 'ينتهي خلال {{time}}',
      endedTitle: 'انتهى هذا العرض',
      endedDescription: 'تحقق من المتجر لمشاهدة عروض أخرى.',
      emptyTitle: 'لا توجد منتجات متاحة في هذا العرض',
      emptyDescription: 'قد تكون المنتجات نفدت أو لم تعد مخفّضة.',
      variantLabel: 'الخيار: {{variant}}',
      homeCta: 'مشاهدة العرض',
      shareLabel: 'مشاركة العرض',
      meta: {
        title: '{{campaignTitle}} من {{storeName}}',
        description: 'عرض مباشر من {{storeName}} لفترة محدودة.',
      },
    },
    courierManifest: {
      title: 'قائمة التوصيل',
      loading: 'جارٍ تحميل قائمة التوصيل...',
      retry: 'إعادة المحاولة',
      error: {
        title: 'تعذّر تحميل قائمة التوصيل',
        description:
          'تحقق من الاتصال وحاول مرة أخرى. إذا استمر الخطأ فاطلب رابطًا جديدًا من المتجر.',
      },
      batchCode: 'دفعة {{displayCode}}',
      courierGreeting: 'لـ {{name}}',
      expiresAt: 'ينتهي في {{expiresAt}}',
      orders: 'توقفات التوصيل',
      orderCount: '{{count}} طلب',
      orderLabel: 'توقف {{displayId}}',
      address: 'العنوان',
      customerPhone: 'هاتف الزبون',
      googleMaps: 'خرائط Google',
      waze: 'Waze',
      packageCount: '{{count}} طرد',
      packageBatchCount: '{{count}} توقفات توصيل',
      notes: 'ملاحظات الزبون',
      openMap: 'فتح الخريطة',
      storeContact: 'اتصال بالمتجر: {{phone}}',
      storeContactUnavailable: 'رقم المتجر غير متاح',
      packageTag: 'الطرد {{tag}}',
      proof: {
        submit: 'إرسال إثبات التوصيل',
        replace: 'استبدال الإثبات',
        submitted: 'تم إرسال الإثبات',
        choosePhoto: 'اختيار صورة',
        chooseFromLibrary: 'اختيار من الصور',
        takePhoto: 'التقاط صورة',
        fileSizeKilobytes: '{{count}} كيلوبايت',
        fileSizeMegabytes: '{{count}} ميجابايت',
        errors: {
          invalidType: 'استخدم صورة JPG أو PNG أو WebP.',
          tooLarge: 'يجب ألا تتجاوز الصورة 5 ميجابايت.',
          notShipped: 'لا يمكن تسليم هذا التوقف من هنا.',
          alreadyConfirmed: 'أكد المتجر هذا التوصيل بالفعل.',
          uploadFailed: 'تعذر رفع صورة الإثبات. حاول مرة أخرى.',
        },
      },
      invalid: {
        title: 'رابط التوصيل غير متاح',
        body: 'قد يكون الرابط منتهيًا أو ملغيًا أو ناقصًا. اطلب رابطًا جديدًا من المتجر.',
        description: 'قد يكون الرابط منتهيًا أو ملغيًا أو ناقصًا. اطلب رابطًا جديدًا من المتجر.',
      },
    },
    courierPortal: {
      title: 'بوابة المندوب',
      invalid: {
        title: 'رابط بوابة المندوب غير متاح',
        description: 'قد يكون الرابط ملغى أو غير صحيح. اطلب رابطًا جديدًا من المتجر.',
      },
      empty: {
        title: 'لا توجد طرود جاهزة الآن',
        description: 'ستظهر هنا الطلبات المشحونة والمخصصة لهذا المندوب.',
      },
      localities: {
        title: 'البلدات',
        count: '{{count}} طرد',
      },
      locality: {
        back: 'العودة إلى البلدات',
      },
      language: {
        label: 'اللغة',
        ar: 'العربية',
        he: 'العبرية',
        en: 'الإنجليزية',
      },
      device: {
        forgetAction: 'إزالة هذا الجهاز',
        title: 'إزالة هذا الجهاز؟',
        description:
          'استخدم هذا الخيار إذا لم يكن هذا هاتفك. لن يفتح هذا الجهاز البوابة مرة أخرى إلا إذا أرسل المتجر الرابط الكامل من جديد.',
        confirm: 'إزالة هذا الجهاز',
      },
      packageCount: '{{count}} طرد',
      customer: 'الزبون',
      proof: {
        required: 'يجب إرسال إثبات التوصيل قبل تأكيد تسليم هذا الطرد.',
        submitted: 'تم إرسال إثبات التوصيل وينتظر تأكيد المتجر.',
        confirmed: 'أكد المتجر إثبات التوصيل.',
      },
    },
    storeChrome: {
      announcementBar: {
        label: 'إعلان المتجر',
      },
      labels: {
        storeHome: 'صفحة المتجر',
        storeCategories: 'التصنيفات',
        storeSales: 'العروض',
        bestSellers: 'الأكثر مبيعًا',
        trendingNow: 'الرائج الآن',
        newArrivals: 'وصل حديثًا',
        category: 'تصنيف',
        cart: 'السلة',
        account: 'الحساب',
        orders: 'الطلبات',
        whatsapp: 'واتساب',
        phone: 'هاتف',
        instagram: 'إنستغرام',
        facebook: 'فيسبوك',
      },
      footer: {
        quickLinks: 'روابط المتجر',
        socialLinks: 'التواصل الاجتماعي',
      },
    },
    home: {
      nav: {
        label: 'تنقل الصفحة الرئيسية',
        home: 'الرئيسية',
        stores: 'المتاجر',
        sales: 'العروض',
        orders: 'طلباتي',
        account: 'الحساب',
      },
      storeNav: {
        home: 'المتجر',
        sales: 'العروض',
      },
      rootLanding: {
        eyebrow: 'دكانتي',
        title: 'رابط متجرك المحلي جاهز عندما تحتاجه',
        subtitle: 'استخدم رابط المتجر الذي وصل إليك، أو أدِر ملفك وطلباتك من هنا.',
        profile: 'الملف الشخصي',
        openStore: 'افتح متجرك',
      },
      hero: {
        badge: 'تسوّق محليًا',
        title: 'اكتشف متاجر محلية',
        subtitle: 'تصفّح متاجر من قريتك واطلب مباشرة من أصحابها.',
        browseStores: 'تصفّح المتاجر',
        openYourStore: 'افتح متجرك',
        fromProduct: 'من منتج منشور',
        fromStore: 'من متجر منشور',
      },
      products: {
        title: 'منتجات من المتاجر المحلية',
        empty: 'لا توجد منتجات منشورة بعد.',
        error: 'تعذّر تحميل المنتجات. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
        viewProductLabel: 'عرض {{productName}}',
      },
      sales: {
        title: 'تخفيضات وعروض',
        subtitle: 'منتجات مخفّضة من متاجر محلية',
        empty: 'لا توجد تخفيضات متاحة الآن.',
        error: 'تعذّر تحميل التخفيضات. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
      },
      publishedStores: {
        title: 'المتاجر المحلية',
        empty: 'لا توجد متاجر منشورة بعد.',
        error: 'تعذّر تحميل المتاجر. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
      },
      featuredStores: {
        title: 'متاجر مميزة',
        empty: 'لا توجد متاجر بعد. كن أول من يفتح متجره!',
        error: 'تعذّر تحميل المتاجر. حاول مرة أخرى.',
        retry: 'إعادة المحاولة',
        viewStore: 'زيارة المتجر',
        viewStoreLabel: 'زيارة المتجر — {{storeName}}',
        storeLogoAlt: 'شعار {{storeName}}',
      },
      howItWorks: {
        title: 'كيف يعمل دكانتي؟',
        step1Title: 'تصفّح المتاجر',
        step1Description: 'اكتشف متاجر محلية من قريتك وتصفّح منتجاتهم.',
        step2Title: 'تواصل مع البائع',
        step2Description: 'تواصل مباشرة مع صاحب المتجر عبر واتساب أو الهاتف.',
        step3Title: 'اطلب واستلم',
        step3Description: 'أكمل طلبك وتابع تفاصيله من حسابك.',
      },
      meta: {
        title: 'دكانتي',
        description: 'ملف العملاء وروابط المتاجر لمتسوّقي دكانتي.',
      },
    },
    sale: {
      onSale: 'تخفيض',
      discountPercent: 'خصم {{percent}}%',
      originalPrice: 'السعر الأصلي {{price}}',
    },
    contactSeller: {
      prefilledMessage: 'السلام عليكم، أنا مهتم بـ {{productName}}. الرابط: {{url}}',
      unavailable: 'معلومات الاتصال غير متوفرة',
      modal: {
        title: 'كيف تحب أن تتواصل؟',
        whatsapp: 'فتح واتساب',
        phone: 'اتصال هاتفي',
        close: 'إغلاق',
      },
    },
    storeNotAvailable: {
      title: 'المتجر غير متاح',
      description: 'هذا المتجر غير متوفّر حاليًا أو لا وجود له.',
      backHome: 'العودة إلى دكانتي',
    },
    storePlaceholder: {
      liveBadge: 'مباشر',
      comingSoon: 'التجربة الكاملة للمتجر قادمة قريبًا',
    },
    storeSales: {
      title: 'منتجات العروض',
      subtitle: 'منتجات مخفّضة من هذا المتجر فقط.',
      emptyTitle: 'لا توجد عروض الآن',
      emptyDescription: 'ارجع إلى هذا المتجر لاحقًا لمشاهدة التخفيضات الجديدة.',
      error: 'تعذّر تحميل منتجات العروض. حاول مرة أخرى.',
      meta: {
        title: 'عروض {{storeName}}',
        description: 'تصفّح المنتجات المخفّضة من {{storeName}}.',
      },
    },
    storeCollections: {
      bestSellers: {
        title: 'الأكثر مبيعًا',
      },
      trendingNow: {
        title: 'الرائج الآن',
      },
      newArrivals: {
        title: 'وصل حديثًا',
      },
      subtitle: 'منتجات مختارة من {{storeName}}',
      emptyTitle: 'لا توجد منتجات في هذه المجموعة بعد',
      emptyDescription: 'عد لاحقًا عندما يحصل هذا المتجر على نشاط أكثر.',
      meta: {
        title: '{{collectionName}} من {{storeName}}',
      },
    },
    customProductCollections: {
      subtitle: 'منتجات مختارة من {{storeName}}',
      emptyTitle: 'لا توجد منتجات في هذه المجموعة الآن',
      emptyDescription: 'ارجع لاحقًا عندما يحدّث هذا المتجر مجموعته.',
      meta: {
        title: '{{collectionName}} من {{storeName}}',
        description: 'تصفّح {{collectionName}} من {{storeName}}.',
      },
    },
    storeCategoriesPage: {
      title: 'كل التصنيفات',
      subtitle: 'تصفّح كل التصنيفات النشطة من {{storeName}}',
      emptyTitle: 'لا توجد تصنيفات بعد',
      emptyDescription: 'لم ينشر هذا المتجر تصنيفات تحتوي على منتجات بعد.',
      error: 'تعذّر تحميل التصنيفات. حاول مرة أخرى.',
      meta: {
        title: 'تصنيفات {{storeName}}',
        description: 'تصفّح كل التصنيفات من {{storeName}}.',
      },
    },
    storeHeader: {
      homeAriaLabel: 'العودة إلى متجر {{storeName}}',
      storeLogoName: 'متجر {{storeName}}',
      cartAriaLabel: 'سلة متجر {{storeName}}',
    },
    // F-005 Phase 4a stub strings. The final Arabic copy is produced by
    // stitch-react during Phase 4c — see §9.1 of
    // .dukanti/designs/F-005.md. We ship recognisable placeholders now
    // so (a) TypeScript's `Translations` type widening is satisfied
    // across he.ts / en.ts, (b) i18next does not fall back visibly and
    // break tests, and (c) a sharp-eyed reviewer can spot missed copy.
    storeHome: {
      header: {
        wordmark: 'دكانتي',
        wordmarkAriaLabel: 'دكانتي — الصفحة الرئيسية',
      },
      languageSwitcher: 'اللغة',
      hero: {
        storeLogoAlt: 'شعار {{storeName}}',
      },
      conversionHero: {
        primaryCta: 'تسوّق الآن',
        categoriesCta: 'تصفّح التصنيفات',
        featuredProduct: 'من المتجر',
        visualFallback: 'لمحة من {{storeName}}',
        descriptionFallback: 'منتجات مختارة من {{storeName}} في مكان واحد.',
      },
      contact: {
        title: 'تواصل مباشر مع المتجر',
        description: 'اختر واتساب أو اتصال هاتفي حسب بيانات التواصل التي نشرها صاحب المتجر.',
        whatsapp: 'واتساب',
        phone: 'اتصال',
        whatsappAriaLabel: 'تواصل مع {{storeName}} عبر واتساب',
        phoneAriaLabel: 'اتصل بـ {{storeName}}',
      },
      products: {
        title: 'المنتجات',
      },
      sections: {
        hero: 'واجهة المتجر',
        contact: 'تواصل مباشر',
        bestSellers: 'الأكثر مبيعًا',
        trendingNow: 'الرائج الآن',
        newArrivals: 'وصل حديثًا',
        specialOffers: 'عروض خاصة',
        selectedProducts: 'منتجات مختارة',
        customCollection: 'مجموعة مختارة',
        sales: 'التخفيضات',
        latestProducts: 'آخر المنتجات',
        availableNow: 'متوفر الآن',
        unavailable: 'غير متوفر حاليًا',
        allProducts: 'كل المنتجات',
        viewAll: 'عرض الكل',
        productsUnavailableHint: 'هذه منتجات منشورة لكنها غير متوفرة للطلب الآن.',
        emptyManualProducts: 'لا توجد منتجات مختارة يمكن عرضها الآن.',
        emptyCustomCollection: 'لا توجد منتجات من هذه المجموعة يمكن عرضها الآن.',
        emptyAutomaticProducts: 'لا توجد منتجات مؤهلة يمكن عرضها الآن.',
        railError: 'تعذّر تحميل هذا القسم.',
        networkError: 'تعذّر تحميل هذا القسم. تحقّق من الاتصال وحاول مرة أخرى.',
        unknownError: 'تعذّر تحميل هذا القسم الآن.',
      },
      newsletter: {
        contactTypeLabel: 'وسيلة التواصل',
        email: 'البريد الإلكتروني',
        phone: 'الهاتف',
        emailLabel: 'عنوان البريد الإلكتروني',
        phoneLabel: 'رقم هاتف إسرائيلي',
        emailPlaceholder: 'name@example.com',
        phonePlaceholder: '050 123 4567',
        consentLabel: 'أوافق على تلقي تحديثات من هذا المتجر عبر وسيلة التواصل التي أكتبها.',
        submit: 'متابعة التحديثات',
        pending: 'جارٍ الحفظ...',
        successTitle: 'شكرًا لك',
        successBody: 'تم استلام طلبك.',
        invalidEmail: 'أدخل عنوان بريد إلكتروني صالحًا.',
        invalidPhone: 'أدخل رقم هاتف إسرائيلي صالحًا.',
        consentRequired: 'أكد الموافقة للمتابعة.',
        genericError: 'تعذّر الحفظ الآن. حاول لاحقًا.',
      },
      trust: {
        title: 'ثقة الزبائن',
        summary: '{{average}} من 5 من {{count}} تقييم موثّق',
        badge: '{{average}} · {{count}} تقييم موثّق',
      },
      categories: {
        title: 'تسوّق حسب التصنيف',
        viewAll: 'عرض الكل',
        viewCategory: 'عرض تصنيف {{categoryName}}',
        productCount: '{{count}} منتج',
        loadError: 'تعذّر تحميل التصنيفات.',
        imageAlt: 'صورة تصنيف {{categoryName}}',
      },
      ads: {
        slideAriaLabel: 'إعلان {{index}} من {{total}}',
        openAd: 'فتح الإعلان',
        destinationCue: 'عرض التفاصيل',
        imageAlt: 'إعلان من {{storeName}}',
        previous: 'الإعلان السابق',
        next: 'الإعلان التالي',
        goToSlide: 'عرض الإعلان {{index}}',
      },
      productImageAlt: 'صورة {{productName}}',
      viewProduct: 'عرض المنتج',
      loadMore: 'عرض المزيد',
      loadingMore: 'جارٍ التحميل...',
      productCard: {
        availability: {
          outOfStock: 'نفد من المخزون',
          onlyNLeft: 'بقي {{count}} فقط',
        },
      },
      empty: {
        title: 'لا توجد منتجات بعد',
        description: 'هذا المتجر لم يُضِف أي منتجات بعد — تفقّده لاحقًا.',
      },
      errors: {
        loadMoreFailed: 'تعذّر تحميل المزيد. حاول مرة أخرى.',
        networkFailed: 'فشل الاتصال. تحقّق من الشبكة.',
        unknown: 'حدث خطأ ما. حاول مرة أخرى.',
        loadFirstFailed: 'تعذّر تحميل المنتجات الآن.',
        loadFirstFailedHint: 'تحقّق من اتصالك بالإنترنت ثم حاول مرة أخرى.',
      },
      liveRegion: {
        loaded: 'يتم عرض {{count}} منتج محمّل',
        loadedFiltered: 'يتم عرض {{visibleCount}} من {{loadedCount}} منتج محمّل',
      },
      loadedFilter: {
        label: 'تصفية المنتجات المحمّلة',
        placeholder: 'اكتب اسم منتج من المنتجات المحمّلة',
        summary: 'يتم عرض {{visibleCount}} من {{loadedCount}} منتج محمّل',
        clear: 'مسح التصفية',
        hideUnavailable: 'إخفاء المنتجات النافدة من المنتجات المحمّلة',
        emptyTitle: 'لا توجد منتجات محمّلة بهذا الاسم',
        emptyDescription: 'امسح التصفية أو حمّل صفحة أخرى إلى المنتجات المعروضة.',
      },
      loading: {
        srLabel: 'جاري تحميل المتجر',
        ariaLabel: 'جاري تحميل المتجر',
      },
      seo: {
        title: '{{storeName}}',
        fallbackDescription: 'تسوّق من {{storeName}}',
      },
    },
    productCard: {
      fromPrice: 'ابتداءً من {{price}}',
      saleFromPrice: 'تخفيض ابتداءً من {{price}}',
    },
    categoryCatalog: {
      backToStore: 'العودة إلى المتجر',
      productCount: '{{count}} منتج',
      search: {
        label: 'البحث داخل {{categoryName}}',
        placeholder: 'ابحث عن منتج في هذا التصنيف',
        clear: 'مسح البحث',
      },
      sort: {
        label: 'ترتيب المنتجات',
        default: 'الافتراضي',
        priceAsc: 'السعر: من الأقل إلى الأعلى',
        priceDesc: 'السعر: من الأعلى إلى الأقل',
        newest: 'الأحدث',
        nameAsc: 'الاسم: أ-ي',
      },
      loading: 'جارٍ تحميل منتجات التصنيف...',
      empty: {
        title: 'لا توجد منتجات مطابقة',
        description: 'جرّب بحثًا آخر أو امسح البحث لرؤية منتجات التصنيف.',
      },
      emptySearch: {
        title: 'لا توجد منتجات تطابق {{search}}',
        description: 'جرّب بحثًا آخر أو امسح البحث لرؤية منتجات التصنيف.',
        clear: 'مسح البحث',
      },
      errors: {
        loadFailed: 'تعذّر تحميل منتجات التصنيف.',
        loadMoreFailed: 'تعذّر تحميل المزيد من منتجات التصنيف.',
        networkFailed: 'تعذّر الاتصال. حاول مرة أخرى.',
        unknown: 'حدث خطأ غير متوقع.',
      },
      liveRegion: {
        loaded: 'يتم عرض {{visibleCount}} من {{totalCount}} منتج',
      },
      meta: {
        title: '{{categoryName}} — {{storeName}}',
        description: 'تسوّق منتجات {{categoryName}} من {{storeName}}.',
      },
    },
    productPlaceholder: {
      title: 'صفحة المنتج قيد التطوير',
      description:
        'نعمل على بناء صفحات المنتجات قريبًا. بإمكانك الرجوع إلى المتجر وتصفّح المنتجات المتوفرة.',
      backToStore: 'العودة إلى المتجر',
    },
    productDetail: {
      backToStore: 'العودة إلى {{storeName}}',
      categoryLabel: 'التصنيف',
      descriptionLabel: 'الوصف',
      contactSeller: 'تواصل مع البائع',
      outOfStock: 'نفد من المخزون',
      availability: {
        inStock: 'متوفر',
        lowStock: 'بقي {{count}} فقط',
        outOfStock: 'نفد من المخزون',
      },
      variants: {
        chooseOption: 'اختر {{option}}',
        available: 'متاح',
        disabled: 'غير متاح للبيع',
        unavailable: 'غير متاح',
        outOfStock: 'نفد من المخزون',
        lowStock: 'تبقى {{count}} فقط',
        selectRequired: 'اختر الخيار المناسب قبل الإضافة للسلة',
      },
      quantity: {
        label: 'الكمية',
        decreaseAriaLabel: 'إنقاص الكمية',
        increaseAriaLabel: 'زيادة الكمية',
        helperMustBeBetween: 'الرجاء إدخال رقم صحيح بين 1 و {{max}}',
        helperExceedsAvailable: 'المتاح {{available}} فقط',
        helperOnlyNLeft: 'بقي {{count}} فقط',
        outOfStockReplacement: 'نفد من المخزون',
        maxInCartReplacement: 'الحد الأقصى موجود في سلتك',
      },
      gallery: {
        previousImage: 'الصورة السابقة',
        nextImage: 'الصورة التالية',
        goToImage: 'الذهاب إلى الصورة {{index}}',
        paginationLabel: 'ترقيم الصور',
        thumbnailLabel: 'الصورة المصغّرة {{index}}',
        noImages: 'لا توجد صور لهذا المنتج',
        zoomImage: 'تكبير الصورة {{index}}',
        zoomOverlayLabel: 'عرض الصورة بالحجم الكامل',
        zoomClose: 'إغلاق',
        zoomCounter: '{{current}} / {{total}}',
        zoomResetZoom: 'إعادة تعيين التكبير',
      },
      seo: {
        title: '{{productName}} — {{storeName}}',
        fallbackDescription: 'تسوّق {{productName}} من {{storeName}}',
      },
      loading: {
        srLabel: 'جاري تحميل المنتج',
      },
      share: {
        button: 'مشاركة',
        copyButton: 'نسخ الرابط',
        shareAriaLabel: 'مشاركة {{productName}}',
        copyAriaLabel: 'نسخ رابط {{productName}}',
        nativeText: '{{productName}} من {{storeName}}',
        toast: {
          sharedTitle: 'تمت مشاركة المنتج',
          copiedTitle: 'تم نسخ الرابط',
          failedTitle: 'تعذّرت المشاركة',
          failedBody: 'لم نتمكن من مشاركة أو نسخ رابط المنتج. حاول مرة أخرى.',
        },
      },
      reviews: {
        title: 'تقييمات الزبائن',
        summary: '{{average}} · {{count}} تقييم',
        retry: 'إعادة تحميل التقييمات',
        yourReviewTitle: 'تقييمك',
        editYourReview: 'تعديل التقييم',
        editTitle: 'تعديل تقييمك',
        saveEdit: 'حفظ التقييم',
        editSuccess: 'تم تحديث تقييمك',
        hiddenOwnReview:
          'هذا التقييم مخفي عن الزبائن حالياً. ستبقى تعديلاتك مرتبطة بنفس عملية الشراء الموثّقة.',
      },
    },
    cart: {
      addToCart: 'أضف إلى السلة',
      adding: 'جارٍ الإضافة…',
      outOfStockButton: 'غير متوفر',
      maxInCartButton: 'الحد الأقصى في السلة',
      persistenceError:
        'لم نتمكن من حفظ هذا المنتج في سلتك على هذا المتصفح. تأكد من إعدادات التخزين أو الوضع الخاص ثم حاول مرة أخرى.',
      successToast: {
        title: 'أُضيف إلى السلة',
        body: '{{productName}} × {{quantity}}',
        viewCart: 'عرض السلة',
      },
      errorToast: {
        title: 'تعذّر الإضافة إلى السلة',
      },
      line: {
        variantSummary: '{{summary}}',
      },
      primedBanner: {
        title: 'نكمل من حيث توقفت — أضف {{storeName}} إلى سلتك',
        dismiss: 'تجاهل',
      },
      postAddPanel: {
        title: 'تمت إضافة {{productName}} إلى السلة',
        body: 'أصبح في سلتك الآن {{quantity}}.',
        viewCart: 'عرض السلة',
        continueShopping: 'متابعة التسوق',
        dismiss: 'إخفاء',
      },
      // F-015: cart header icon + badge + dropdown.
      header: {
        // iconLabel (6 forms)
        iconLabel_zero: 'سلة التسوق فارغة',
        iconLabel_one: 'سلة التسوق — عنصر واحد',
        iconLabel_two: 'سلة التسوق — عنصران',
        iconLabel_few: 'سلة التسوق — {{count}} عناصر',
        iconLabel_many: 'سلة التسوق — {{count}} عنصرًا',
        iconLabel_other: 'سلة التسوق — {{count}} عنصر',

        // static strings
        dropdownTitle: 'سلتك',
        dropdownAriaLabel: 'معاينة السلة',
        subtotal: 'المجموع الفرعي',
        viewCart: 'عرض السلة',
        emptyTitle: 'سلتك فارغة',
        browseProducts: 'تصفح المنتجات',
        // Security W4: pure translated string — no `{{message}}`/raw-error
        // interpolation allowed. A future diff adding one is a merge blocker.
        loadError: 'تعذّر تحميل السلة',

        // itemCountSuffix (6 forms)
        itemCountSuffix_zero: 'لا توجد عناصر',
        itemCountSuffix_one: 'عنصر واحد',
        itemCountSuffix_two: 'عنصران',
        itemCountSuffix_few: '{{count}} عناصر',
        itemCountSuffix_many: '{{count}} عنصرًا',
        itemCountSuffix_other: '{{count}} عنصر',

        // moreItems (6 forms)
        moreItems_zero: '+لا إضافي',
        moreItems_one: '+عنصر إضافي',
        moreItems_two: '+عنصران إضافيان',
        moreItems_few: '+{{count}} عناصر إضافية',
        moreItems_many: '+{{count}} عنصرًا إضافيًا',
        moreItems_other: '+{{count}} إضافية',

        // itemsUnavailable (6 forms)
        itemsUnavailable_zero: 'لا يوجد عناصر غير متوفرة',
        itemsUnavailable_one: 'عنصر واحد لم يعد متوفرًا',
        itemsUnavailable_two: 'عنصران لم يعودا متوفرين',
        itemsUnavailable_few: '{{count}} عناصر لم تعد متوفرة',
        itemsUnavailable_many: '{{count}} عنصرًا لم يعد متوفرًا',
        itemsUnavailable_other: '{{count}} عناصر لم تعد متوفرة',
      },
      // F-016: full cart page strings.
      page: {
        title: 'سلة التسوق',
        subtitle: 'راجع منتجاتك قبل إتمام الشراء',
        breadcrumbBack: 'العودة إلى المتجر',
        empty: {
          title: 'سلتك فارغة',
          body: 'لم تُضِف أي منتج إلى سلتك بعد.',
          browseProducts: 'تصفّح المنتجات',
        },
        line: {
          removeAriaLabel: 'إزالة {{productName}} من السلة',
          unitPrice: '{{price}} للوحدة',
          lineSubtotal: 'المجموع الفرعي للسطر',
          priceUpdated: 'السعر تغيّر',
          priceWas: 'كان: {{oldPrice}}',
          priceNow: 'الآن: {{newPrice}}',
          unavailable: 'غير متوفر',
          unknownProduct: 'لم يعد المنتج متاحًا',
          imageAlt: 'صورة {{productName}}',
        },
        unavailableBanner: {
          title: 'بعض المنتجات لم تعد متاحة',
          body: 'يوجد {{count}} عنصر لم يعد متاحًا للشراء. أزِله للمتابعة إلى تأكيد الطلب.',
        },
        handoffRecovery: {
          retrying: 'نحاول نقل سلتك بعد تسجيل الدخول...',
          partial:
            'لم نستطع نقل كل عناصر السلة. راجع السلة ثم حاول المتابعة لتأكيد الطلب مرة أخرى.',
          savedIntentTitle: 'تحتاج بعض العناصر إلى مراجعة',
          savedIntentBody:
            'هذه عناصر محفوظة من السلة المحلية ولم تُنقل بعد. أزل ما لم تعد تريده، ثم حاول المتابعة مرة أخرى.',
          retrySavedItems: 'حاول نقل العناصر المحفوظة مرة أخرى',
        },
        summary: {
          title: 'ملخّص الطلب',
          subtotal: 'المجموع الفرعي',
          itemCount_zero: 'لا توجد عناصر',
          itemCount_one: 'عنصر واحد',
          itemCount_two: 'عنصران',
          itemCount_few: '{{count}} عناصر',
          itemCount_many: '{{count}} عنصرًا',
          itemCount_other: '{{count}} عنصر',
          stockCheckNote:
            'تبقى المنتجات في سلتك دون حجز المخزون. يتم تأكيد التوفر عند إرسال الطلب.',
          proceedToCheckout: 'المتابعه لتأكيد الطلب',
          checkoutDisabledHint: 'أزِل المنتجات غير المتوفرة قبل المتابعة',
          checkoutDisabledHandoffHint: 'راجِع عناصر السلة المحفوظة أو أزِلها قبل المتابعة',
          signinRequiredDialog: {
            title: 'تحقق من رقمك لتأكيد الطلب',
            body: 'سنرسل رمزًا واحدًا، ثم نعيدك لتأكيد الطلب. ستبقى المنتجات محفوظة في سلتك.',
            continue: 'المتابعة برقم الهاتف',
            cancel: 'البقاء في السلة',
          },
        },
        removeDialog: {
          title: 'إزالة {{productName}}؟',
          body: 'سيتم حذف {{productName}} من سلتك.',
          confirm: 'إزالة',
          cancel: 'إلغاء',
        },
        errors: {
          refetchFailed: 'تعذّر تحميل سلة التسوق. حاول مرة أخرى.',
          updateFailed: 'تعذّر تحديث السلة',
          removeFailed: 'تعذّر إزالة المنتج من السلة',
        },
        toast: {
          removed: 'تمت إزالة {{productName}} من السلة',
        },
        skeleton: {
          loadingAriaLabel: 'جارٍ تحميل سلة التسوق',
        },
        retryButton: 'إعادة المحاولة',
      },
    },
    // F-017: real checkout flow.
    checkout: {
      review: {
        cartChanged: 'تغيّرت المنتجات في سلتك. راجع السلة المحدّثة ثم أكّد من جديد.',
        cartRefreshFailed: 'تعذّر تحديث السلة. حاول مجددًا قبل تأكيد الطلب.',
        verificationFailed: 'تعذّر التحقّق من منتجات السلة. حاول مجددًا قبل التأكيد.',
      },
      page: {
        title: 'إتمام الطلب',
        backToCart: 'العودة إلى السلة',
        shippingSection: 'عنوان التوصيل',
        changeAddress: 'تغيير العنوان',
        useDifferentAddress: 'استخدام عنوان آخر',
        manageAddresses: 'إدارة العناوين المحفوظة',
        saveForNextTime: 'حفظ هذا العنوان للمرة القادمة',
        localityPlaceholder: 'اختر البلدة أو المدينة',
        localityLoading: 'جاري تحميل البلدات...',
        localityError: 'تعذر تحميل البلدات. حاول مرة أخرى.',
        notesSection: 'ملاحظات للبائع',
        submitCta: 'تأكيد الطلب',
        deliveryPriceNoticeTitle: 'سيتم تأكيد سعر التوصيل بشكل منفصل',
        deliveryPriceNotice:
          'سعر التوصيل غير مُضاف حالياً. سيتواصل معك المتجر لتأكيد تكلفة التوصيل قبل إرسال طلبك.',
      },
      deliveryMethod: {
        title: 'طريقة التوصيل',
        location: 'الموقع',
        address: 'العنوان',
      },
      deliveryInfo: {
        title: 'معلومات التوصيل',
        description: 'أخبر المتجر أين يوصّل الطلب. الموقع الدقيق اختياري.',
        localityLabel: 'البلدة أو المدينة',
        postalCodeLabel: 'الرمز البريدي',
        recipientLabel: 'اسم المستلم',
        backupPhoneLabel: 'هاتف بديل',
        errors: {
          localityRequired: 'اختر البلدة أو المدينة.',
          postalCodeRequired: 'أدخل الرمز البريدي.',
          postalCodeInvalid: 'أدخل رمزاً بريدياً إسرائيلياً صالحاً.',
          recipientRequired: 'أدخل اسم المستلم.',
          recipientTooLong: 'اسم المستلم طويل جداً.',
          backupPhoneInvalid: 'أدخل رقم هاتف بديل صالحاً.',
        },
      },
      deliveryLocation: {
        title: 'الموقع الدقيق للتوصيل',
        description: 'شارك موقعك الحالي ليصل التاجر إلى نقطة التوصيل بدقة.',
        localityLabel: 'البلدة أو المدينة',
        localityRequired: 'اختر البلدة أو المدينة قبل مشاركة الموقع.',
        homeWarning:
          'استخدم هذا الخيار فقط عندما تكون في البيت أو في المكان الذي تستقبل فيه الطلبات عادة.',
        cta: 'مشاركة موقعي الدقيق',
        update: 'تحديث الموقع الدقيق',
        locating: 'جاري تحديد الموقع...',
        shared: 'تمت إضافة الموقع الدقيق للتوصيل',
        clear: 'إزالة الموقع',
        denied: 'تم رفض إذن الموقع. يمكنك إتمام الطلب بدون GPS.',
        deniedWithExisting:
          'تم رفض إذن الموقع. سيبقى الموقع الدقيق الذي أضفته سابقاً مرفقاً بهذا الطلب.',
        unavailable: 'الموقع الدقيق غير متاح على هذا الجهاز. يمكنك إتمام الطلب بدون GPS.',
        unavailableWithExisting:
          'الموقع الدقيق غير متاح على هذا الجهاز. سيبقى الموقع الذي أضفته سابقاً مرفقاً بهذا الطلب.',
      },
      locationModal: {
        title: 'مشاركة الموقع الدقيق؟',
        body: 'سيطلب المتصفح إذنك. سنضيف هذه الإحداثيات إلى هذا الطلب فقط.',
        confirmCta: 'مشاركة الموقع',
        cancelCta: 'إلغاء',
      },
      modal: {
        title: 'تأكيد الطلب',
        body: 'أنت على وشك تقديم طلب إلى {{storeName}}.',
        itemCount_one: 'عنصر واحد',
        itemCount_other: '{{count}} عناصر',
        subtotal: 'المجموع الفرعي',
        confirmCta: 'تأكيد',
        cancelCta: 'إلغاء',
      },
    },
  },
  // F-017: order domain namespace.
  order: {
    submit: 'إرسال الطلب',
    confirm: 'تأكيد الطلب',
    cancel: 'إلغاء الطلب',
    placed: 'تم تقديم الطلب',
    tracking: 'تتبّع الطلب',
    shippingAddress: 'عنوان التوصيل',
    deliveryInformation: 'معلومات التوصيل',
    preciseLocation: 'الموقع الدقيق للتوصيل',
    orderSummary: 'ملخّص الطلب',
    stockCheckNotice: 'يتم حجز المخزون عند إرسال الطلب. سيتواصل البائع معك لترتيب التوصيل.',
    notes: {
      placeholder: 'أضف ملاحظات للبائع (اختياري)',
      maxLengthHint: '{{current}}/{{max}}',
    },
    status: {
      ordered: 'تم الطلب',
      shipped: 'تم الشحن',
      delivered: 'تم التسليم',
      cancelled: 'ملغى',
      rejected: 'مرفوض',
    },
    // F-018: order confirmation page keys
    headline: {
      placed: 'تم استلام طلبك!',
      ordered: 'تم استلام طلبك!',
      shipped: 'تم شحن طلبك!',
      delivered: 'تم توصيل طلبك!',
      cancelled: 'تم إلغاء الطلب',
      rejected: 'تم رفض الطلب',
    },
    whatHappensNext: 'ماذا سيحدث الآن؟',
    whatHappensNextBody:
      'سيراجع البائع طلبك ويتواصل معك عبر واتساب أو الهاتف لتأكيد التوصيل وترتيب الدفع. يمكنك متابعة حالة طلبك هنا في أي وقت.',
    contactMerchant: 'تواصل مع البائع',
    contactMerchantWhatsappMessage: 'مرحباً {{storeName}}، أود السؤال عن طلبي رقم {{orderId}}',
    contactMerchantWhatsappAriaLabel: 'مراسلة {{storeName}} عبر واتساب بخصوص هذا الطلب',
    contactMerchantPhoneAriaLabel: 'الاتصال بـ {{storeName}} بخصوص هذا الطلب',
    id: 'رقم الطلب',
    placedDate: 'تاريخ الطلب',
    cancelButton: 'إلغاء الطلب',
    cancelQuestion: 'لديك رأي آخر؟',
    cancelConfirmTitle: 'إلغاء هذا الطلب؟',
    cancelConfirmBody: 'سيتم إلغاء الطلب وإرجاع المنتجات إلى مخزون المتجر.',
    cancelConfirmCta: 'نعم، إلغاء الطلب',
    cancelSuccess: 'تم إلغاء طلبك',
    timeline: {
      title: 'تتبّع الطلب',
      completedOn: 'اكتمل في {{- date}}',
    },
    viewAllOrders: 'عرض جميع طلباتي',
    backToStore: 'العودة إلى المتجر',
    customerNotes: 'ملاحظاتك للبائع',
    loadingDetails: 'جارٍ تحميل تفاصيل الطلب',
    reviewPrompt: {
      title: 'تقييمات هذا الطلب',
      submit: 'إرسال التقييم',
      alreadyReviewed: 'تم تقييم هذا المنتج',
      ratingRequired: 'اختر تقييماً من 1 إلى 5',
      textTooLong: 'يجب ألا يتجاوز النص 1000 حرف',
      whitespaceOnly: 'اكتب نصاً واضحاً أو اترك الحقل فارغاً',
      success: 'تم إرسال تقييمك',
      openDialog: 'كتابة تقييم',
      ratingOnlyHint: 'يمكنك إرسال تقييم بالنجوم فقط أو إضافة نص قصير.',
      reviewedHint: 'تبقى تقييماتك المرسلة مرتبطة بالمنتجات التي استلمتها.',
      yourReview: 'تقييمك',
      editReview: 'تعديل التقييم',
      hiddenReview: 'مخفي عن الزبائن حالياً. تعديلك يحافظ على رابط الشراء الموثّق.',
      merchantResponse: 'رد البائع',
      textLabel: 'نص التقييم',
      textPlaceholder: 'اكتب رأيك بالمنتج',
      dialogTitle: 'تقييم {{productName}}',
      close: 'إغلاق',
    },
    errors: {
      productUnavailable: 'بعض المنتجات لم تعد متوفرة: {{names}}',
      variantUnavailable: 'أحد الخيارات لم يعد متاحًا. راجع السلة.',
      cartEmpty: 'سلتك فارغة. أضف منتجات قبل إتمام الطلب.',
      storeUnavailable: 'هذا المتجر لا يقبل الطلبات حاليًا.',
      networkFailed: 'فشل الاتصال. تحقّق من الشبكة وحاول مرة أخرى.',
      unknown: 'حدث خطأ. حاول مرة أخرى.',
      // F-018: cancel-specific error keys
      cancelFailed: 'تعذّر إلغاء الطلب. حاول مرة أخرى.',
      cancelAlreadyProcessed: 'لا يمكن إلغاء هذا الطلب في حالته الحالية.',
      orderNotFound: 'الطلب غير موجود.',
      // F-023: merchant transition error keys
      invalidTransition: 'لا يمكن تنفيذ هذه العملية في الحالة الحالية للطلب.',
      transitionUnauthorized: 'ليس لديك صلاحية تغيير حالة هذا الطلب.',
      shipFailed: 'فشل تحديث المخزون عند الشحن. حاول مرة أخرى.',
      deliverFailed: 'تعذّر تسجيل التسليم. حاول مرة أخرى.',
      courierProofRequired: 'يجب على المندوب إرسال صورة إثبات التسليم من رابط التوصيل.',
      manualApprovalRequired: 'وافق على هذا الطلب قبل إجراءات التجهيز.',
      rejectFailed: 'تعذّر رفض الطلب. حاول مرة أخرى.',
    },
    history: {
      title: 'طلباتي',
      totalOrders: '{{count}} طلب',
      activeOrders: '{{count}} نشط',
      filterLabel: 'تصفية حسب الحالة',
      filterAll: 'الكل',
      itemCount: '{{count}} منتج',
      viewOrder: 'عرض',
      loadMore: 'تحميل المزيد',
      loadingMore: 'جاري التحميل...',
      loadingOrders: 'جاري تحميل الطلبات',
      backToAccount: 'الحساب',
      emptyAllCta: 'تصفّح المتاجر',
      emptyAllSubtitle: 'استعرض المتاجر وابدأ بالتسوق',
      emptyFilteredHint: 'جرّب تصفية أخرى أو تحقق لاحقاً',
      empty: {
        all: 'لم تقدّم أي طلبات بعد',
        ordered: 'لا توجد طلبات بانتظار الشحن',
        shipped: 'لا توجد طلبات تم شحنها',
        delivered: 'لا توجد طلبات تم توصيلها',
        cancelled: 'لا توجد طلبات ملغاة',
        rejected: 'لا توجد طلبات مرفوضة',
      },
    },
    // F-020: status-change toast key
    statusChangedToast: 'طلبك الآن {{status}}',
  },
  promotionKit: {
    whatsapp: {
      storeHome: 'زوروا متجر {{storeName}}: {{url}}',
      product: 'شاهدوا {{targetName}} من {{storeName}}: {{url}}',
      category: 'تصفحوا {{targetName}} من {{storeName}}: {{url}}',
      liveOfferCampaign: 'عرض مباشر من {{storeName}}: {{targetName}} {{url}}',
      salesPage: 'تخفيضات {{storeName}} بانتظاركم: {{url}}',
      reviewHighlight: 'زبائن {{storeName}} يحبون {{targetName}}. شاهدوا المزيد: {{url}}',
    },
    poster: { cta: 'امسح الكود واطلب من المتجر' },
    story: { cta: 'اطلبوا من المتجر' },
  },
  errors: {
    notFound: 'الصفحة غير موجودة',
    networkFailed: 'فشل الاتصال بالشبكة',
    title: 'حدث خطأ غير متوقع',
    description: 'نعتذر عن الإزعاج. يمكنك المحاولة مرة أخرى.',
    retry: 'إعادة المحاولة',
  },
};

export type Translations = typeof ar;
